import React, { useState, useRef, useEffect, useMemo } from "react";
import { useTheme } from "../../components/ThemeSwitcher/ThemeSwitcher";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import esriRequest from "@arcgis/core/request.js";
import { showAlert } from "../../utils/Helpers";
import Query from "@arcgis/core/rest/support/Query.js";
import * as query from "@arcgis/core/rest/query.js";
import DivLoader from "../../components/common/Loader/DivLoader";
import useScripts from "../../utils/UseScripts";
import "./AnimalApprovedRecords.css";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point.js";
import { Button, Form } from "react-bootstrap";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import AlertMessage from "../../components/common/Alert/AlertMessage";
import { BiFilterAlt } from "react-icons/bi";
import { GrLocation } from "react-icons/gr";
import { ImCancelCircle } from "react-icons/im";
import { MdOutlineDelete } from "react-icons/md";
import { FiEye } from "react-icons/fi";
import { LuCheck } from "react-icons/lu";
import { FiUpload } from "react-icons/fi";
import { FiEdit2 } from "react-icons/fi";
import { RxCalendar } from "react-icons/rx";
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol";
import Color from "@arcgis/core/Color";
import { RiDeleteBinLine } from "react-icons/ri";
import AnimalModalPopups from "./AnimalModalPopups";
import * as XLSX from "xlsx";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import PopupTemplate from "@arcgis/core/PopupTemplate";
import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel.js";
import Sketch from "@arcgis/core/widgets/Sketch.js";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils";
import { Popover } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import CustomDropdownIndicator from "../../components/common/CustomDropdownIndicator";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import CommonFunctions from "./CommonFunctions";
import AnimalSightingMobilePending from "./AnimalSightingMobile/AnimalSightingMobilePending";
import { RxCross2 } from "react-icons/rx";
import DOMPurify from "dompurify";
import { useEDPContext } from "../../components/EDPContext";
import esriConfig from "@arcgis/core/config.js";
import { applyTheme, updateAllCharts, updateImages } from "../../utils/theme";
import { useUserGroups } from "../../../src/components/common/Auth/UserGroupsContext";
import { BiArrowBack } from "react-icons/bi";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetchApprovedRecordsByApprovalType } from "./AnimalApprovedRecords";
let editingRows = [];
var sketchVM = null;
var sketch = null;
let filteredData = null;
let resetToOriginalDataRows = null;
let elementInstances = {};
const AnimalPendingRecords = ({ onClose, isUnmounted, fullView, ...props }) => {
  const { mapview, showForm, setShowForm, sptledit, setSptlEdit } = props;
  let { theme } = useTheme();
  const { groupNames, groupFunctions, groupServices } = useUserGroups();
  const { t } = useTranslation();
  const IconAttachtarget = useRef(null);
  const [showPopover, setShowPopover] = useState(false);
  const [loading, setLoading] = useState(false);
  const groupMap = {
    [t("Invertebrates")]: window.userGroups.invertebrates,
    [t("Plants")]: window.userGroups.plants,
    [t("Mammals")]: window.userGroups.mammals,
    [t("Reptiles")]: window.userGroups.reptiles,
  };
  const tableRefs = {
    [t("Invertebrates")]: useRef(null),
    [t("Plants")]: useRef(null),
    [t("Mammals")]: useRef(null),
    [t("Reptiles")]: useRef(null),
  };

  const { globalDataContextValue } = useEDPContext();
  const { globalData, setGlobalData } = globalDataContextValue;
  const AnimalSightingTab = globalData.find(module => module.moduleName === "Animal Sighting")
    ?.subTabs.find(subTab => subTab.name === "PendingRecords");
 
  const pendingRecordList = [t("Invertebrates"), t("Plants"), t("Mammals"), t("Reptiles")];
  const filteredPendingRecordList = pendingRecordList.filter(
    (item) => groupNames.includes(groupMap[item])
  );

  const [activePendingtabs, setActivePendingtab] = useState(
    filteredPendingRecordList.length > 0 ? filteredPendingRecordList[0] : ""
  );


  const [isEditing, setIsEditing] = useState(false);
  const [PlantsData, setPlantsData] = useState([]);
  const [InvertebratesData, setInvertebratesData] = useState([]);
  const [MammalsData, setMammalsData] = useState([]);
  const [ReptilesData, setReptilesData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const getInitialSelectedRows = (category) => {
    return (
      globalData
        .find(m => m.moduleName === "Animal Sighting")
        ?.subTabs.find(st => st.name === "PendingRecords")
        ?.selectedRows?.[category] ?? []
    );
  };

  const [PlantsSelectedRows, setPlantsSelectedRows] = useState(() => getInitialSelectedRows("Plants"));
  const [InvertebratesSelectedRows, setInvertebratesSelectedRows] = useState(() => getInitialSelectedRows("Invertebrates"));
  const [MammalsSelectedRows, setMammalsSelectedRows] = useState(() => getInitialSelectedRows("Mammals"));
  const [ReptilesSelectedRows, setReptilesSelectedRows] = useState(() => getInitialSelectedRows("Reptiles"));
  const PlantscurrentRows = useRef([]);
  const InvertebratescurrentRows = useRef([]);
  const MammalscurrentRows = useRef([]);
  const ReptilescurrentRows = useRef([]);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [PlantsDomainValues, setPlantsDomainValues] = useState([]);
  const [InsectsDomainValues, setInsectsDomainValues] = useState([]);
  const [MammalsDomainValues, setMammalsDomainValues] = useState([]);
  const [ReptilesDomainValues, setReptilesDomainValues] = useState([]);
  const [OrderFamilyNames, setOrderFamilyNames] = useState([]);
  const [FamilySpeciesNames, setFamilySpeciesNames] = useState([]);
  const [SpeciesOrder, setSpeciesOrder] = useState([]);
  const [FamilyName, setFamilyName] = useState([]);
  const [MammalsSpeciesNames, setMammalsSpeciesNames] = useState([]);
  const [ReptilesSpeciesNames, setReptileSpeciesNames] = useState([]);
  const [DropdownSpeciesValues, setDropdownSpeciesValues] = useState([]);
  const [DropdownFamilyValues, setDropdownFamilyValues] = useState([]);
  const [DropdownMammalsSpeciesNames, setDropdownMammalsSpeciesNames,] = useState([]);
  const [DropdownReptilesSpecies, setDropdownReptileSpecies] = useState([]);
  const [InsectsDrafAttachments, setInsectsDraftAttachments] = useState([]);
  const [PlantsDrafAttachments, setPlantsDraftAttachments] = useState([]);
  const [MammalsDrafAttachments, setMammalsDraftAttachments] = useState([]);
  const [ReptilesDrafAttachments, setReptilesDraftAttachments] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const fileInputRef = useRef(null);
  const fileUploadRef = useRef(null);
  const dateInputRef = useRef(null);
  const [editedRows, setEditedRows] = React.useState({});
  const [InsectsDraftRecords, setInsectsDraftRecords] = useState([]);
  const [InsectsApprovedRecords, setInsectsApprovedRecords] = useState([]);
  const [show, setShow] = useState(false); // Modal visibility state
  const [attachmentsContent, setAttachmentsContent] = useState(null);
  const [alertmessage, setAlertMessage] = useState(null);
  const [showfilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const [invertebrateheaders, setInvertebrateHeaders] = useState([]);
  const [plantsheaders, setPlantsHeaders] = useState([]);
  const [mammalsheaders, setMammalsHeaders] = useState([]);
  const [reptilesheaders, setReptilesHeaders] = useState([]);
  const [CloneData, setCloneData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [errors, setErrors] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [bulkfile, setBulkfile] = useState([]);
  const divSpatialEdit = useRef(null);
  const [isToggled, setIsToggled] = useState(false);
  const [editingLayer, setEditingLayer] = useState(null);
  const [isEditingEnabled, setIsEditingEnabled] = useState(false); // Toggle state
  const [modalObjectId, setModalObjectId] = useState(null);
  const [invertebratesRows, setInvertebratesRows] = useState([]);
  const [plantsRows, setPlantsRows] = useState([]);
  const [reptilesRows, setReptilesRows] = useState([]);
  const [mammalsRows, setMammalsRows] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState("DD");
  const graphicsLayerRef = useRef(null);
  const sketchViewModelRef = useRef(null);
  const [activeButton, setActiveButton] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isDataModified, setIsDataModified] = useState(false);
  const [isResetBtnShow, setIsResetBtnShow] = useState(false);


  // Find the Animal Sighting tab

  const shouldFetchDomainValues = !AnimalSightingTab?.data?.InsectsDomainValues ||
    !AnimalSightingTab?.data?.PlantsDomainValues ||
    !AnimalSightingTab?.data?.MammalsDomainValues ||
    !AnimalSightingTab?.data?.ReptilesDomainValues ||
    !AnimalSightingTab?.data?.SpeciesOrder ||
    !AnimalSightingTab?.data?.FamilyName;
  // const { GetDomainValues } = useMemo(() => CommonFunctions({
  //   setInsectsDomainValues,
  //   setPlantsDomainValues,
  //   setMammalsDomainValues,
  //   setReptilesDomainValues,
  //   setSpeciesOrder,
  //   setFamilyName,
  //   setMammalsSpeciesNames,
  //   setReptileSpeciesNames,
  //   t,
  //   setLoading,
  // }));

  // const handleCalendarClick = () => {
  //   if (dateInputRef.current) {
  //     if (dateInputRef.current.showPicker) {
  //       dateInputRef.current.showPicker(); // Preferred
  //     } else {
  //       dateInputRef.current.focus(); // Fallback
  //     }
  //   }
  // };

  const handleCalendarClick = (event) => {
    const dateInput = event.currentTarget
      .closest(".dateInputBlk")
      ?.querySelector('input[type="datetime-local"]');
  
    if (!dateInput) return;
  
    if (typeof dateInput.showPicker === "function") {
      dateInput.showPicker();
    } else {
      dateInput.focus();
    }
  };

  const { GetDomainValues } = useMemo(() => {
    if (shouldFetchDomainValues) {
      return CommonFunctions({
        setInsectsDomainValues,
        setPlantsDomainValues,
        setMammalsDomainValues,
        setReptilesDomainValues,
        setSpeciesOrder,
        setFamilyName,
        setMammalsSpeciesNames,
        setReptileSpeciesNames,
        t,
        setLoading,
      });
    }
    else {
      const AnimalSightingTab = globalData.find(module => module.moduleName === "Animal Sighting")
        ?.subTabs.find(subTab => subTab.name === "PendingRecords");
      setInsectsDomainValues([AnimalSightingTab.data.InsectsDomainValues] || []);
      setPlantsDomainValues([AnimalSightingTab.data.PlantsDomainValues] || []);
      setMammalsDomainValues([AnimalSightingTab.data.MammalsDomainValues] || []);
      setReptilesDomainValues([AnimalSightingTab.data.ReptilesDomainValues] || []);
      setSpeciesOrder(AnimalSightingTab.data.SpeciesOrder || []);
      setFamilyName(AnimalSightingTab.data.FamilyName || []);
      setMammalsSpeciesNames(AnimalSightingTab.data.MammalsSpeciesNames || []);
      setReptileSpeciesNames(AnimalSightingTab.data.ReptileSpeciesNames || []);
    }
    return {}; // Prevents execution if data already exists
  }, [shouldFetchDomainValues]); // Re-runs only when globalData changes

  const interceptorAdded = useRef(false);
  const token = localStorage.getItem("PortalToken");

  const updateTheme = (event) => {
    const newTheme = event.detail;
    theme = newTheme;
    //updateAllCharts(chartInstances, theme, t);
    applyTheme(elementInstances, theme, "AnimalSighting")
  };

  useEffect(() => {
    window.addEventListener("themeChanged", updateTheme);

    return () => {
      window.removeEventListener("themeChanged", updateTheme);
    };
  }, [])
  useEffect(() => {
    setGlobalData(prev =>
      prev.map(m =>
        m.moduleName === 'Animal Sighting'
          ? {
            ...m,
            subTabs: m.subTabs.map(st =>
              st.name === 'PendingRecords'
                ? {
                  ...st,
                  /* keep selections from every category in one place */
                  selectedRows: {
                    Plants: PlantsSelectedRows,
                    Invertebrates: InvertebratesSelectedRows,
                    Mammals: MammalsSelectedRows,
                    Reptiles: ReptilesSelectedRows,
                  },
                }
                : st
            ),
          }
          : m
      )
    );
  }, [
    PlantsSelectedRows,
    InvertebratesSelectedRows,
    MammalsSelectedRows,
    ReptilesSelectedRows,
  ]);
  useEffect(() => {
    setGlobalData(prev =>
      prev.map(m =>
        m.moduleName === 'Animal Sighting'
          ? {
            ...m,
            subTabs: m.subTabs.map(st =>
              st.name === 'PendingRecords'
                ? {
                  ...st,
                  /* keep selections from every category in one place */
                  activePendingtabs: activePendingtabs
                }
                : st
            ),
          }
          : m
      )
    );
  }, [
    activePendingtabs,
  ]);
  useEffect(() => {
    if (!scriptLoaded || interceptorAdded.current) return;

    if (token) {
      const escapedBase = window.animalSightingBaseUrl.replace(/\//g, "\\/");
      const regex = new RegExp(`${escapedBase}.+\\/FeatureServer(\\/\\d+)?(\\/\\w+)?`, "i");

      esriConfig.request.interceptors.push({
        urls: regex,
        // use the BeforeInterceptorCallback to add token to query
        before: function (params) {
          if (params && params.requestOptions) {
            params.requestOptions.query = {
              ...params.requestOptions.query,
              token
            };
            // Explicitly prevent IdentityManager token injection
            params.requestOptions.authMode = "anonymous";
          }
        },
      });
    }

    interceptorAdded.current = true;
  }, [scriptLoaded, token]);

  const handleButtonClick = (buttonId, onClickFunction) => {
    setActiveButton((prevActiveButton) =>
      prevActiveButton === buttonId ? null : buttonId
    );
    onClickFunction();
  };

  const AnimalSightsGraphicLayers = useRef({
    Plants: new GraphicsLayer({ id: "PlantsGraphicLayerId" }),
    Mammals: new GraphicsLayer({ id: "MammalsGraphicLayerId" }),
    Insects: new GraphicsLayer({ id: "InsectsGraphicLayerId" }),
    Reptiles: new GraphicsLayer({ id: "ReptilesGraphicLayerId" }),
  }).current;

  const SelectionSymbol = new SimpleMarkerSymbol({
    style: SimpleMarkerSymbol.STYLE_CIRCLE,
    size: 20,
    outline: new SimpleLineSymbol({
      style: SimpleLineSymbol.STYLE_SOLID,
      color: new Color([0, 230, 169, 1]),
      width: 2,
    }),
    color: new Color([0, 230, 169, 0.65]),
  });
  const initialInsectState = {
    insectOrder: "",
    speciesName: "",
    family: "",
    specimenTaken: "",
    location: "",
    habitatStatus: "",
    habitat: "",
    trappingMethod: "",
    recordedBy: "",
    observedNumber: "",
    insectslongitude: "",
    insectslatitude: "",
    insectsnotes: "",
    surveyDate: "",
    photoNo: "",
    specimenNo: "",
    insectslongDegrees: "",
    insectslongMinutes: "",
    insectslongSeconds: "",
    insectslatDegrees: "",
    insectslatMinutes: "",
    insectslatSeconds: "",
  };
  const [InsectsData, setInsectsData] = useState(initialInsectState);
  const initialPlantState = {
    plantSpecies: "",
    phenology: "",
    generalLocation: "",
    plantshabitat: "",
    grazingSign: "",
    precipitation: "",
    percentageCover: "",
    specimenCollected: "",
    plantssurveyDate: "",
    plantsNotes: "",
    plantslongitude: "",
    plantslatitude: "",
    plantslongDegrees: "",
    plantslongMinutes: "",
    plantslongSeconds: "",
    plantslatDegrees: "",
    plantslatMinutes: "",
    plantslatSeconds: "",
  };
  const [PlantsDataObj, setPlantsDataObj] = useState(initialPlantState);
  const initialMammalsState = {
    mammalsSpecies: "",
    mammalsSpeciesName: "",
    mammalsSpeciesNumber: "",
    mammalsSightingType: "",
    mammalsHabitat: "",
    mammalsLocation: "",
    mammalsCollector: "",
    mammalsSurveyDate: "",
    mammalsLatitude: "",
    mammalsLongitude: "",
    mammalsNotes: "",
    mammalslongDegrees: "",
    mammalslongMinutes: "",
    mammalslongSeconds: "",
    mammalslatDegrees: "",
    mammalslatMinutes: "",
    mammalslatSeconds: "",
  };
  const [MammalsDataObj, setMammalsDataObj] = useState(initialMammalsState);
  const initialReptilesState = {
    reptiles: "",
    reptileSpecies: "",
    observationNumber: "",
    reptileSightingType: "",
    microHabitat: "",
    reptileHabitat: "",
    reptileLocation: "",
    reptileCollector: "",
    observationDate: "",
    reptileLatitude: "",
    reptileLongitude: "",
    reptileNotes: "",
    reptilelongDegrees: "",
    reptilelongMinutes: "",
    reptilelongSeconds: "",
    reptilelatDegrees: "",
    reptilelatMinutes: "",
    reptilelatSeconds: "",
  };
  const [ReptilesDataObj, setReptilesDataObj] = useState(initialReptilesState);


  useScripts(
    [`${process.env.PUBLIC_URL}/config/AnimalSightsDataEntry.js`],
    () => {
      setScriptLoaded(true);
    }
  );
  useEffect(() => {
    if (!mapview) return;
    const loadData = async () => {
      if (
        window.PlantInfo &&
        window.InvertiblesInfo &&
        window.MammalsInfo &&
        window.ReptilesInfo
      ) {
        setLoading(true);
        try {

          // await Promise.all([
          //   GetFamilyRelationTableData(),
          //   addGraphicLayer(t("Plants"), window.PlantInfo, AnimalSightsGraphicLayers.Plants, t("errorplants"), "PlantsWithoutImage.png", "PlantsWithImage.png"),
          //   addGraphicLayer(t("Invertebrates"), window.InvertiblesInfo, AnimalSightsGraphicLayers.Insects, t("errorinsects"), "InsectsWithoutImage.png", "InsectsWithImage.png"),
          //   addGraphicLayer(t("Mammals"), window.MammalsInfo, AnimalSightsGraphicLayers.Mammals, t("errormammals"), "MammalsWithoutImage.png", "MammalsWithImage.png"),
          //   addGraphicLayer(t("Reptiles"), window.ReptilesInfo, AnimalSightsGraphicLayers.Reptiles, t("errorreptiles"), "ReptileWithoutImage.png", "ReptileWithImage.png"),
          // ]);.

          await GetFamilyRelationTableData();
          if (groupNames.includes(window.userGroups.plants)) {
            const plantsLayer = mapview?.map?.findLayerById("PlantsGraphicLayerId");
            if (!plantsLayer || plantsLayer.graphics.length === 0) {
              await addGraphicLayer(t("Plants"), window.PlantInfo, AnimalSightsGraphicLayers.Plants, t("errorplants"), "PlantsWithoutImage.png", "PlantsWithImage.png");
            }
          }

          if (groupNames.includes(window.userGroups.invertebrates)) {
            const insectsLayer = mapview?.map?.findLayerById("InsectsGraphicLayerId");
            if (!insectsLayer || insectsLayer.graphics.length === 0) {
              await addGraphicLayer(t("Invertebrates"), window.InvertiblesInfo, AnimalSightsGraphicLayers.Insects, t("errorinsects"), "InsectsWithoutImage.png", "InsectsWithImage.png");
            }
          }
          if (groupNames.includes(window.userGroups.mammals)) {
            const mammalsLayer = mapview?.map?.findLayerById("MammalsGraphicLayerId");
            if (!mammalsLayer || mammalsLayer.graphics.length === 0) {
              await addGraphicLayer(t("Mammals"), window.MammalsInfo, AnimalSightsGraphicLayers.Mammals, t("errormammals"), "MammalsWithoutImage.png", "MammalsWithImage.png");
            }
          }
          if (groupNames.includes(window.userGroups.reptiles)) {
            const reptilesLayer = mapview?.map?.findLayerById("ReptilesGraphicLayerId");
            if (!reptilesLayer || reptilesLayer.graphics.length === 0) {
              await addGraphicLayer(t("Reptiles"), window.ReptilesInfo, AnimalSightsGraphicLayers.Reptiles, t("errorreptiles"), "ReptileWithoutImage.png", "ReptileWithImage.png");
            }
          }

          GetDomainValues();
          //setLoading(false);
        } catch (error) {
          //showAlert(t("dataerror"), "error");
          setLoading(false);
        }
        finally {
          setLoading(false); // Ensure loading is set to false after completion
        }
      }
    };
    if (!isUnmounted.current) {
      loadData();
    }
    mapview.on("click", (event) => {  //"pointer-move",
      mapview.hitTest(event).then((response) => {
        const graphicResult = response.results.find((result) =>
          [
            AnimalSightsGraphicLayers.Insects,
            AnimalSightsGraphicLayers.Plants,
            AnimalSightsGraphicLayers.Reptiles,
            AnimalSightsGraphicLayers.Mammals,
          ].includes(result.graphic.layer)
        );
        // if (graphicResult) {
        //   const graphic = graphicResult.graphic;
        //   mapview.openPopup({
        //     location: graphic.geometry,
        //     features: [graphic],
        //     title: "Invertebrates Info",
        //     //content: graphic.popupTemplate.content
        //   });
        // }
        if (graphicResult) {
          const graphic = graphicResult.graphic;
        
          const attributes = graphic.attributes;
        
          // Build fieldInfos from attributes
          const fieldInfos = Object.keys(attributes).map(attrName => {
            const value = attributes[attrName];
        
            // Detect numeric timestamps (e.g., 1672531200000)
            const isTimestamp =
              typeof value === "number" &&
              Math.abs(value) > 1000000000 &&
              Math.abs(value).toString().length >= 10;
        
            // Detect actual Date objects
            const isDateObject = value instanceof Date;
        
            return {
              fieldName: attrName,
              label: attrName,
              format: (isTimestamp || isDateObject)
                ? { dateFormat: "short-date" }
                : null
            };
          });

          const title = graphic?.popupTemplate?.title;
        
          graphic.popupTemplate = {
            title: title,
            content: [{
              type: "fields",
              fieldInfos: fieldInfos
            }]
          };
        
          mapview.openPopup({
            location: graphic.geometry,
            features: [graphic]
          });
        }else {
          mapview.closePopup();
        }
      });
    });

  }, [currentPage, mapview, rowsPerPage, scriptLoaded]);

  useEffect(() => {
    if (isUnmounted.current) {
      ["PlantsGraphicLayerId", "MammalsGraphicLayerId", "ReptilesGraphicLayerId", "InsectsGraphicLayerId"]
        .forEach(id => {
          const layer = mapview?.map?.findLayerById(id);
          if (layer) {
            mapview.map.remove(layer);
          }
        });
      mapview?.graphics?.removeAll();
    }
  }, [isUnmounted])
  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (
  //       InsectsDomainValues.length > 0 &&
  //       PlantsDomainValues.length > 0 &&
  //       MammalsDomainValues.length > 0 &&
  //       ReptilesDomainValues.length > 0
  //     ) {
  //       setLoading(true);
  //       try {
  //         await Promise.all([
  //           fetchLayerRecords(t("Invertebrates"), window.InvertiblesInfo.DisplayAttributes, window.InvertiblesInfo.Url),
  //           fetchLayerRecords(t("Plants"), window.PlantInfo.DisplayAttributes, window.PlantInfo.Url),
  //           fetchLayerRecords(t("Mammals"), window.MammalsInfo.DisplayAttributes, window.MammalsInfo.Url),
  //           fetchLayerRecords(t("Reptiles"), window.ReptilesInfo.DisplayAttributes, window.ReptilesInfo.Url),
  //         ]);
  //       } catch (error) {
  //         console.log(t("dataerror"), error);
  //       } finally {
  //         setLoading(false);
  //       }
  //     }
  //   };
  //   fetchData();
  // }, [
  //   InsectsDomainValues,
  //   PlantsDomainValues,
  //   MammalsDomainValues,
  //   ReptilesDomainValues,
  // ]);
  useEffect(() => {
    const fetchData = async () => {
      if (
        InsectsDomainValues.length > 0 &&
        PlantsDomainValues.length > 0 &&
        MammalsDomainValues.length > 0 &&
        ReptilesDomainValues.length > 0
      ) {
        setLoading(true);
        try {
          const isInvertebratesAllowed = groupNames.includes(window.userGroups.invertebrates);
          const isPlantsAllowed = groupNames.includes(window.userGroups.plants);
          const isMammalsAllowed = groupNames.includes(window.userGroups.mammals);
          const isReptilesAllowed = groupNames.includes(window.userGroups.reptiles);
          const isInvertebratesDataPresent = globalData.some(module =>
            module.moduleName === "Animal Sighting" &&
            module.subTabs.some(subTab =>
              subTab.name === "PendingRecords" &&
              subTab?.data?.InvertebratesData // Check if Invertebrates data is already set
            )
          );

          const isPlantsDataPresent = globalData.some(module =>
            module.moduleName === "Animal Sighting" &&
            module.subTabs.some(subTab =>
              subTab.name === "PendingRecords" &&
              subTab?.data?.PlantsData // Check if Plants data is already set
            )
          );

          const isMammalsDataPresent = globalData.some(module =>
            module.moduleName === "Animal Sighting" &&
            module.subTabs.some(subTab =>
              subTab.name === "PendingRecords" &&
              subTab?.data?.MammalsData // Check if Mammals data is already set
            )
          );

          const isReptilesDataPresent = globalData.some(module =>
            module.moduleName === "Animal Sighting" &&
            module.subTabs.some(subTab =>
              subTab.name === "PendingRecords" &&
              subTab?.data?.ReptilesData // Check if Reptiles data is already set
            )
          );
          var AnimalSightingTab = globalData.find(module => module.moduleName === "Animal Sighting")
            .subTabs.find(subTab => subTab.name === "PendingRecords")
          await Promise.all([
            isInvertebratesAllowed
              ? isInvertebratesDataPresent
                ?
                Promise.resolve().then(() => {
                  setInvertebratesData(AnimalSightingTab.data.InvertebratesData);
                  setInvertebrateHeaders(AnimalSightingTab.data.InvertebrateHeaders);
                  InvertebratescurrentRows.current = AnimalSightingTab.data.InvertebratescurrentRows
                  setInsectsDraftAttachments(AnimalSightingTab.data.InsectsDraftAttachments)
                })

                : fetchLayerRecords(t("Invertebrates"), window.InvertiblesInfo.DisplayAttributes, window.InvertiblesInfo.Url) : Promise.resolve(),

            isPlantsAllowed
              ? isPlantsDataPresent ?
                Promise.resolve().then(() => {
                  setPlantsData(AnimalSightingTab.data.PlantsData);
                  setPlantsHeaders(AnimalSightingTab.data.PlantsHeaders);
                  PlantscurrentRows.current = AnimalSightingTab.data.PlantscurrentRows
                  setPlantsDraftAttachments(AnimalSightingTab.data.PlantsDraftAttachments)
                })

                : fetchLayerRecords(t("Plants"), window.PlantInfo.DisplayAttributes, window.PlantInfo.Url) : Promise.resolve(),

            isMammalsAllowed
              ? isMammalsDataPresent
                ?
                Promise.resolve().then(() => {
                  setMammalsData(AnimalSightingTab.data.MammalsData);
                  setMammalsHeaders(AnimalSightingTab.data.MammalsHeaders);
                  MammalscurrentRows.current = AnimalSightingTab.data.MammalscurrentRows
                  setMammalsDraftAttachments(AnimalSightingTab.data.MammalsDraftAttachments)
                })

                : fetchLayerRecords(t("Mammals"), window.MammalsInfo.DisplayAttributes, window.MammalsInfo.Url) : Promise.resolve(),
            isReptilesAllowed
              ? isReptilesDataPresent
                ?
                Promise.resolve().then(() => {
                  setReptilesData(AnimalSightingTab.data.ReptilesData);
                  setReptilesHeaders(AnimalSightingTab.data.ReptilesHeaders);
                  ReptilescurrentRows.current = AnimalSightingTab.data.ReptilescurrentRows
                  setReptilesDraftAttachments(AnimalSightingTab.data.ReptilesDraftAttachments)
                })

                : fetchLayerRecords(t("Reptiles"), window.ReptilesInfo.DisplayAttributes, window.ReptilesInfo.Url) : Promise.resolve()
          ]);
        } catch (error) {
          //showAlert(t("dataerror"), "error");
          setLoading(false);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [
    InsectsDomainValues,
    PlantsDomainValues,
    MammalsDomainValues,
    ReptilesDomainValues,
  ]);
  useEffect(() => {
    if (editingRows.length === 0 && isEditing) {
      setIsEditing(!isEditing);
    }
  }, [isEditing]);

  useEffect(() => {
    if (sptledit) {
      SpatialSearch();
    }
  }, [sptledit]);

  const tabMapping = {
    [t("Invertebrates")]: {
      layerInfo: window.InvertiblesInfo,
      selectedRows: InvertebratesSelectedRows,
      currentRows: InvertebratescurrentRows,
      domainValues: InsectsDomainValues[0],
      draftAttachments: InsectsDrafAttachments,
      data: InvertebratesData,
    },
    [t("Plants")]: {
      layerInfo: window.PlantInfo,
      selectedRows: PlantsSelectedRows,
      currentRows: PlantscurrentRows,
      domainValues: PlantsDomainValues[0],
      draftAttachments: PlantsDrafAttachments,
      data: PlantsData,
    },
    [t("Mammals")]: {
      layerInfo: window.MammalsInfo,
      selectedRows: MammalsSelectedRows,
      currentRows: MammalscurrentRows,
      domainValues: MammalsDomainValues[0],
      draftAttachments: MammalsDrafAttachments,
      data: MammalsData,
    },
    [t("Reptiles")]: {
      layerInfo: window.ReptilesInfo,
      selectedRows: ReptilesSelectedRows,
      currentRows: ReptilescurrentRows,
      domainValues: ReptilesDomainValues[0],
      draftAttachments: ReptilesDrafAttachments,
      data: ReptilesData,
    },
  };

  // const initializeSketch = (activeTab, mapview, graphicLayers) => {
  //   const sketchConfig = {
  //     view: mapview,
  //     creationMode: "create",
  //     availableCreateTools: ["polygon"],
  //     visible: true,
  //   };
  //   const layerMapping = {
  //     [t("Plants")]: graphicLayers.Plants,
  //     [t("Mammals")]: graphicLayers.Mammals,
  //     [t("Reptiles")]: graphicLayers.Reptiles,
  //     [t("Invertebrates")]: graphicLayers.Insects,
  //   };
  //   const layer = layerMapping[activeTab];
  //   if (!layer) {
  //     return null; // Handle invalid `activeTab`
  //   }
  //   const sketchVM = new SketchViewModel({
  //     ...sketchConfig,
  //     layer,
  //   });
  //   window.sketchVM = sketchVM;
  //   sketchVM.create("polygon");
  //   return { sketchVM };
  // };
  const initializeSketch = (mapview) => {
    // Create a reusable sketch layer
    let sketchLayer = mapview.map.findLayerById("sketch-layer");
    if (!sketchLayer) {
      sketchLayer = new GraphicsLayer({ id: "sketch-layer" });
      mapview.map.add(sketchLayer);
    }
    sketchLayer.removeAll();

    const sketchVM = new SketchViewModel({
      view: mapview,
      layer: sketchLayer,
      creationMode: "create",
      availableCreateTools: ["polygon"],
      visible: true,
    });

    sketchVM.create("polygon");
    window.sketchVM = sketchVM;

    return { sketchVM };
  };
  const highlightTableRows = (features, tableId, activeTab) => {
    const spatialObjectIds = features.map(
      (feature) => feature.attributes.OBJECTID
    );
    if (isMobileView) {
      const cards = document.getElementsByClassName('animalMobCardWrp');
      if (!cards.length) return;
      const cardRows = document.getElementsByClassName('animalMobCardWrp')[0].childNodes;
      cardRows.forEach((row) => (row.style.background = "none"));
      spatialObjectIds.forEach((objectId) => {
        cardRows.forEach((row) => {
          const cardIdCell = row.getAttribute('data-objectid');
          if (cardIdCell === objectId.toString()) {
            row.classList.add("colorcoding");
          }
        });
      });
    }
    else {
      const grid = document.getElementById(tableId);
      if (!grid) return;
      const rows = grid.querySelectorAll("tr");
      rows.forEach((row) => (row.style.background = "none")); // Reset row styles
      // Highlight rows matching OBJECTID
      spatialObjectIds.forEach((objectId) => {
        rows.forEach((row) => {
          //const objectIdCell = row.cells[2]; 
          const objectIdCell = row.querySelector("[data-objectid]");
          if (objectIdCell && objectIdCell.innerText === objectId.toString()) {
            row.classList.add("colorcoding");
          }
        });
      });
    }
  };
  const queryFeatures = async (activeTab, geometry, featureLayerUrls) => {
    const featureLayer = new FeatureLayer({
      url: featureLayerUrls[activeTab],
      outFields: ["*"],
    });
    const query = new Query({
      geometry,
      spatialRelationship: "intersects",
      returnGeometry: false,
      outFields: ["OBJECTID"],
    });
    try {
      const results = await featureLayer.queryFeatures(query);
      return results.features;
    } catch (error) {
      showAlert(t("queryerror"), "error");
      return [];
    }
  };
  const SpatialSearch = async () => {
    const graphicLayers = AnimalSightsGraphicLayers; // Replace with your graphic layers
    const featureLayerUrls = {
      [t("Plants")]: window.PlantInfo.Url,
      [t("Mammals")]: window.MammalsInfo.Url,
      [t("Reptiles")]: window.ReptilesInfo.Url,
      [t("Invertebrates")]: window.InvertiblesInfo.Url,
    };
    const tableIds = {
      [t("Plants")]: "tblPlants",
      [t("Mammals")]: "tblMammals",
      [t("Reptiles")]: "tblReptiles",
      [t("Invertebrates")]: "tblInsects",
    };
    if (!activePendingtabs) return;
    //const { sketchVM } = initializeSketch(activePendingtabs, mapview, graphicLayers);
    const { sketchVM } = initializeSketch(mapview);

    // Attach create event listener
    (sketchVM).on("create", async (event) => {
      if (event.state === "complete") {
        setLoading(true);
        const geometry = event.graphic.geometry;
        const allFeatures = {};

        for (const [layerName, url] of Object.entries(featureLayerUrls)) {
          const features = await queryFeatures(layerName, geometry, featureLayerUrls);
          if (features?.length > 0) {
            allFeatures[layerName] = features;
          }
        }
        // Highlight each table individually
        for (const [layerName, features] of Object.entries(allFeatures)) {
          highlightTableRows(features, tableIds[layerName], layerName);
        }
        // const features = await queryFeatures(
        //   activePendingtabs,
        //   event.graphic.geometry,
        //   featureLayerUrls
        // );
        // highlightTableRows(features, tableIds[activePendingtabs], activePendingtabs);
        if (sketchVM) sketchVM.cancel();
        setSptlEdit(false);
        setLoading(false);
      }
    });
  };
  const addGraphicLayer = async (layerType, layerInfo, graphicLayer, errorMessage, defaultImage, imageWithAttachment) => {
    let featureSet;
    try {
      if (isUnmounted.current) return;
      const layer = new FeatureLayer({ url: layerInfo.Url });
      const queryparams = new Query({
        where: "Status = 'Draft'",
        outFields: ["*"],
        returnGeometry: true,
      });

      const requestOptions = {
        query: {
          token: token,
        },
      };
      var AnimalSightingTab = globalData.find(module => module.moduleName === "Animal Sighting")
        .subTabs.find(subTab => subTab.name === "PendingRecords")

      if (AnimalSightingTab?.data && AnimalSightingTab?.data?.featureSets && AnimalSightingTab?.data?.featureSets[layerType]) {
        featureSet = AnimalSightingTab?.data?.featureSets[layerType]
      }
      else {

        featureSet = await query.executeQueryJSON(layerInfo.Url, queryparams, requestOptions);
        //featureSet = await query.executeQueryJSON(layerInfo.Url, queryparams);
        setGlobalData(prevData =>
          prevData.map(module =>
            module.moduleName === "Animal Sighting"
              ? {
                ...module,
                subTabs: module.subTabs.map(subTab =>
                  subTab.name === "PendingRecords"
                    ? {
                      ...subTab,
                      data: {
                        ...subTab.data,
                        featureSets: {
                          ...subTab.data.featureSets,
                          [layerType]: featureSet // Storing feature set based on layerType
                        },
                      }
                    }
                    : subTab
                )
              }
              : module
          )
        );

      }

      //const featureSet = await query.executeQueryJSON(layerInfo.Url, queryparams)
      if (!featureSet.features.length) return;

      // Fetch all attachments in a single query
      const objectIds = featureSet.features.map(f => f.attributes.OBJECTID);
      let attachmentInfos;
      if (AnimalSightingTab?.data && AnimalSightingTab?.data?.attachmentInfos && AnimalSightingTab?.data?.attachmentInfos[layerType]) {
        attachmentInfos = AnimalSightingTab?.data?.attachmentInfos[layerType]
      }
      else {
        attachmentInfos = await layer.queryAttachments({ objectIds });
        setGlobalData(prevData =>
          prevData.map(module =>
            module.moduleName === "Animal Sighting"
              ? {
                ...module,
                subTabs: module.subTabs.map(subTab =>
                  subTab.name === "PendingRecords"
                    ? {
                      ...subTab,
                      data: {
                        ...subTab.data,
                        attachmentInfos: {
                          ...subTab.data.attachmentInfos,
                          [layerType]: attachmentInfos // Storing attachments based on layerType
                        }
                      }
                    }
                    : subTab
                )
              }
              : module
          )
        );
      }


      const graphics = featureSet.features.map((feature) => {
        const { geometry, attributes } = feature;
        const objID = attributes.OBJECTID;

        let symbolUrl = `${process.env.PUBLIC_URL}/images/AnimalSighting/${defaultImage}`;
        let infoContent = "<div>";

        Object.entries(attributes).forEach(([key, value]) => {
          infoContent += `<b>${key}</b>: ${value}<br>`;
        });

        if (attachmentInfos[objID] && attachmentInfos[objID].length > 0) {
          symbolUrl = `${process.env.PUBLIC_URL}/images/AnimalSighting/${imageWithAttachment}`;
          infoContent += "<br>Attachments:<br>";
          attachmentInfos[objID].forEach((attachment) => {
            infoContent += `<a target='_blank' href="${attachment.url}">${attachment.name}</a><br>`;
          });
        }
        infoContent += "</div>";

        return new Graphic({
          geometry,
          symbol: new PictureMarkerSymbol({
            url: symbolUrl,
            height: 15,
            width: 15,
          }),
          attributes,
          popupTemplate: new PopupTemplate({
            title: `${layerType} Info`,
            content: infoContent,
          }),
        });
      });

      if (!isUnmounted.current) {
        graphicLayer.addMany(graphics); // Add all new graphics

        //const layerAlreadyExists = mapview.map.layers.includes(graphicLayer);

        // if (!layerAlreadyExists) {
        mapview.map.add(graphicLayer);
        //}
      }
    } catch (error) {
      showAlert(errorMessage, "error");
      setLoading(false);
    }
    //  finally {
    //   setLoading(false);
    // }
  };

  const fetchLayerRecords = async (type, fieldsMapping, layerUrl) => {
    const queryparams = new Query({
      where: "Status = 'Draft'",
      outFields: ["*"],
      orderByFields: ["created_date DESC"],
      returnGeometry: true,
    });
    const requestOptions = {
      query: {
        token: token,
      },
    };
    try {
      const Records = await query.executeQueryJSON(layerUrl, queryparams, requestOptions);
      //const Records = await query.executeQueryJSON(layerUrl, queryparams);
      if (!Records.features.length) return;

      const formatDate = (timestamp, adjustHours = 0) => {
        if (!timestamp) return "";
        const date = new Date(JSON.parse(timestamp));
        if (adjustHours) date.setHours(date.getHours() + adjustHours);
        return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()} ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`;
      };

      const DisplayAttributes = fieldsMapping
        .filter((item) => item.Mandatory)
        .map((item) => item.AttrName);

      const DisplayHeaders = [
        ...fieldsMapping
          .filter((item) => item.Mandatory && !["OBJECTID", "Status", "DataSource", "GlobalID"].includes(item.AttrName))
          .map((item) => item.Label),
        "Attachments",
      ];

      const domainValues = {
        [t("Invertebrates")]: InsectsDomainValues[0],
        [t("Mammals")]: MammalsDomainValues[0],
        [t("Reptiles")]: ReptilesDomainValues[0],
        [t("Plants")]: PlantsDomainValues[0],
      }[type];

      const processedData = Records.features.map((item, index) => {
        return {
          id: index + 1,
          ...Object.fromEntries(
            DisplayAttributes.map(attr => {
              if (["Point_X", "POINT_X"].includes(attr)) return [attr, item.geometry?.longitude?.toFixed(5) || ""];
              if (["Point_Y", "POINT_Y"].includes(attr)) return [attr, item.geometry?.latitude?.toFixed(5) || ""];
              if (["SurveyDate", "ObservationDate", "created_date"].includes(attr)) {
                let timestamp = item.attributes[attr];
                if (attr === "SurveyDate" || attr === "ObservationDate") {
                  if (item.attributes["DataSource"] == 1 && timestamp == null) {
                    timestamp = item.attributes["created_date"];
                  }
                }
                return [attr, formatDate(timestamp, item.attributes["DataSource"] == 1 ? 0 : -4)];
              }
              if (domainValues && attr in domainValues) {
                let value;
                if (type === t("Mammals")) {
                  if (attr === "Species") {
                    value = domainValues[attr]?.find((entry) => parseInt(entry.key) === item.attributes[attr])?.value || "";
                  }
                  else {
                    value = domainValues[attr]?.find((entry) => entry.key === item.attributes[attr])?.value || "";
                  }
                }
                else {
                  if (attr === "InsectOrder" || attr === "Reptiles") {
                    value = domainValues[attr]?.find((entry) => parseInt(entry.key) === item.attributes[attr])?.value || "";
                  }
                  else if (type === t("Plants") && attr === "PercentageCover") {
                    value = domainValues[attr]?.find((entry) => entry.key === Number(item.attributes[attr]))?.value ?? "";
                  }
                  else {
                    value = domainValues[attr]?.find((entry) => entry.key === item.attributes[attr])?.value || "";
                  }
                }
                return [attr, value];
              }
              return [attr, item.attributes[attr]];
            })
          ),
        };
      });

      switch (type) {
        case t("Invertebrates"):
          await fetchAttachments(Records, layerUrl, type);
          setInvertebratesData(Records.features);
          setInvertebrateHeaders(DisplayHeaders);
          InvertebratescurrentRows.current = processedData;

          setGlobalData(prevData =>
            prevData.map(module =>
              module.moduleName === "Animal Sighting"
                ? {
                  ...module,
                  subTabs: module.subTabs.map(subTab =>
                    subTab.name === "PendingRecords"
                      ? {
                        ...subTab,
                        data: {
                          ...subTab.data,
                          InvertebratesData: Records.features, // Directly storing features
                          InvertebrateHeaders: DisplayHeaders, // Storing headers as separate
                          InvertebratescurrentRows: processedData // Storing rows separately
                        }
                      }
                      : subTab
                  )
                }
                : module
            )
          );
          break;
        case t("Plants"):
          await fetchAttachments(Records, layerUrl, type);
          setPlantsData(Records.features);
          setPlantsHeaders(DisplayHeaders);
          PlantscurrentRows.current = processedData;

          setGlobalData(prevData =>
            prevData.map(module =>
              module.moduleName === "Animal Sighting"
                ? {
                  ...module,
                  subTabs: module.subTabs.map(subTab =>
                    subTab.name === "PendingRecords"
                      ? {
                        ...subTab,
                        data: {
                          ...subTab.data,
                          PlantsData: Records.features, // Directly storing features
                          PlantsHeaders: DisplayHeaders, // Storing headers as separate
                          PlantscurrentRows: processedData // Storing rows separately
                        }
                      }
                      : subTab
                  )
                }
                : module
            )
          );
          break;
        case t("Mammals"):
          await fetchAttachments(Records, layerUrl, type);
          setMammalsData(Records.features);
          setMammalsHeaders(DisplayHeaders);
          MammalscurrentRows.current = processedData;

          setGlobalData(prevData =>
            prevData.map(module =>
              module.moduleName === "Animal Sighting"
                ? {
                  ...module,
                  subTabs: module.subTabs.map(subTab =>
                    subTab.name === "PendingRecords"
                      ? {
                        ...subTab,
                        data: {
                          ...subTab.data,
                          MammalsData: Records.features, // Directly storing features
                          MammalsHeaders: DisplayHeaders, // Storing headers as separate
                          MammalscurrentRows: processedData // Storing rows separately
                        }
                      }
                      : subTab
                  )
                }
                : module
            )
          );
          break;
        case t("Reptiles"):
          await fetchAttachments(Records, layerUrl, type);
          setReptilesData(Records.features);
          setReptilesHeaders(DisplayHeaders);
          ReptilescurrentRows.current = processedData;

          setGlobalData(prevData =>
            prevData.map(module =>
              module.moduleName === "Animal Sighting"
                ? {
                  ...module,
                  subTabs: module.subTabs.map(subTab =>
                    subTab.name === "PendingRecords"
                      ? {
                        ...subTab,
                        data: {
                          ...subTab.data,
                          ReptilesData: Records.features, // Directly storing features
                          ReptilesHeaders: DisplayHeaders, // Storing headers as separate
                          ReptilescurrentRows: processedData // Storing rows separately
                        }
                      }
                      : subTab
                  )
                }
                : module
            )
          );
          break;
      }
    } catch (ex) {
      throw new Error("Failed to fetch records");
    }
  };
  const onFilterClick = () => {
    setShowFilter(!showfilter);
  };
  const handleCloseModal = () => {
    if (isMobileView) {
      const modal = document.querySelector('.modal');
      if (modal) {
        modal.style.display = 'none';
        setShowModal(false);
        setShowSuccessModal(false);
      }
    }
    else {
      setShowModal(false);
      setShowSuccessModal(false);
    }
  };
  const handleConfirm = () => {
    confirmDelete(idToDelete);
    setLoading(true);
    setShowModal(false);
  };
  const confirmDelete = async (Objid) => {
    try {
      const layerConfig = {
        [t("Plants")]: {
          layerUrl: window.PlantInfo.Url,
          displayAttributes: window.PlantInfo.DisplayAttributes,
          setSelectedRows: setPlantsSelectedRows,
        },
        [t("Invertebrates")]: {
          layerUrl: window.InvertiblesInfo.Url,
          displayAttributes: window.InvertiblesInfo.DisplayAttributes,
          setSelectedRows: setInvertebratesSelectedRows,
        },
        [t("Mammals")]: {
          layerUrl: window.MammalsInfo.Url,
          displayAttributes: window.MammalsInfo.DisplayAttributes,
          setSelectedRows: setMammalsSelectedRows,
        },
        [t("Reptiles")]: {
          layerUrl: window.ReptilesInfo.Url,
          displayAttributes: window.ReptilesInfo.DisplayAttributes,
          setSelectedRows: setReptilesSelectedRows,
        },
      };
      const { layerUrl, displayAttributes, setSelectedRows } = layerConfig[activePendingtabs];

      const layer = new FeatureLayer(layerUrl);
      const query = new Query({
        returnGeometry: true,
        outFields: ["*"],
        where: `OBJECTID IN (${Objid.join(",")})`, // Join Objid for SQL IN clause
      });

      try {
        const featureSet = await layer.queryFeatures(query);
        const graphics = featureSet.features;
        const results = await layer.applyEdits({
          deleteFeatures: graphics,
           params: { token }
        });

        const editsApplied = results.deleteFeatureResults.concat(
          results.addFeatureResults,
          results.updateFeatureResults
        );

        if (editsApplied && editsApplied.length > 0) {
          showAlert(t("featuredelete"), "success");
          setIsEditing(false);
          setIdToDelete([]);
          setLoading(false);
          setActivePendingtab(activePendingtabs);
          setSelectedRows([]);
          fetchLayerRecords(activePendingtabs, displayAttributes, layerUrl);
        } else {
          showAlert(t("errordelete"), "error");
        }
      } catch (error) {
        showAlert(t("errorapplyedits"), "error");
        setLoading(false);
      }
    } catch (error) {
      showAlert(error.message, "error");
      setLoading(false);
    }
  };
  const handleDelete = () => {
    if (activePendingtabs) {
      const { currentRows, selectedRows } = tabMapping[activePendingtabs];
      const idsToDelete = currentRows.current
        .filter((item) => selectedRows.includes(item.id))
        .map((item) => item.OBJECTID);

      if (idsToDelete.length > 0) {
        setIdToDelete(idsToDelete);
        setShowModal(true);
      }
      else {
        showAlert(t("deletefeatures"), "info");
        return;
      }
    }
  };
  const CopyAttachmentsinTarget = (Addresults, ObjectIDList) => {
    let RequestObj = [];
    const { layerInfo, draftAttachments } = tabMapping[activePendingtabs];
    Addresults.forEach((result, i) => {
      const TargetObjID = result.objectId;
      const SourceObjID = ObjectIDList[i];
      const AttachmentIndex = draftAttachments.findIndex((x) => x.OBJECTID === SourceObjID);
      if (AttachmentIndex !== -1) {
        const AttachmentsArray = draftAttachments[AttachmentIndex].AttachmentsList;
        if (Array.isArray(AttachmentsArray)) {
          AttachmentsArray.forEach((attachment) => {
            if (attachment.id && attachment.name && attachment.contentType) {
              const attachmentUrl = `${layerInfo.Url}/${SourceObjID}/attachments/${attachment.id}`;

              const paramObj = {
                TargetID: TargetObjID,
                Attachmenturl: attachmentUrl,
                Type: attachment.contentType,
                Name: attachment.name,
                Attachmentid: attachment.id,
              };
              RequestObj.push(paramObj);
            } else {
              //console.log("Invalid attachment format", attachment);
              setLoading(false);
            }
          });
        } else {
          //console.log("AttachmentsList is not an array or is missing");
          setLoading(false);
        }
      } else {
        //console.log("Attachment index not found for SourceObjID:", SourceObjID);
        setLoading(false);
      }
    });
    if (RequestObj.length > 0) {
      AppendAttachments(RequestObj, 0);
    }
  };
  const AppendAttachments = async (RequestObj, index = 0) => {
    if (index >= RequestObj.length) return; // End recursion when all attachments are processed    
    const CurrentRequest = RequestObj[index];
    const { Attachmenturl, Type, Name, TargetID } = CurrentRequest;
    const { layerInfo } = tabMapping[activePendingtabs];
    try {
      const response = await fetch(Attachmenturl);
      if (!response.ok) {
        throw new Error(`Failed to fetch attachment: ${response.statusText}`);
      }
      const blob = await response.blob();
      const formData = new FormData();
      formData.append("attachment", blob, Name);
      formData.append("f", "json");
      formData.append("token", token);


      const TargetUrl = `${layerInfo.TargetUrl}/${TargetID}/addAttachment?f=json`;
      const uploadResponse = await fetch(TargetUrl, {
        method: "POST",
        body: formData,
      });
      if (!uploadResponse.ok) {
        setLoading(false);
        throw new Error(`Failed to upload attachment: ${uploadResponse.statusText}`);
      }

      const uploadResult = await uploadResponse.json();
      if (uploadResult?.addAttachmentResult?.success) {
        //console.log("Attachment uploaded successfully:", uploadResult.addAttachmentResult);
      } else {
        setLoading(false);
        throw new Error("Attachment upload failed.");
      }

      // Proceed to the next attachment
      await AppendAttachments(RequestObj, index + 1);
    } catch (error) {
      //console.log(`Error processing attachment for TargetID: ${TargetID}`, error);
      try {
        const objId = RequestObj[index].TargetID;
        const layerUrl = layerInfo.TargetUrl;
        await DeleteRecordsinDestination(objId, layerUrl);
        showAlert(t("unablecopyattach"), "error");
        setLoading(false);
      }
      catch (deleteError) {
        showAlert(t("Error deleting failed attachment:"), "error");
        setLoading(false);
      }
    }
  };
  const DeleteRecordsinDestination = async (objid, url) => {
    try {
      const deleteUrl = `${url}/${objid}/delete`;
      const response = await esriRequest(deleteUrl, {
        method: "post",
        query: { f: "json" },
        responseType: "json",
      });
      showAlert(t("featuredelete"), "success");
    } catch (error) {
      showAlert(t("faildelete"), "error");
      setLoading(false);
    }
  };
  const removeGraphicsFromMap = (objectIdsToRemove, graphicLayer) => {
    if (!graphicLayer || !objectIdsToRemove?.length) return;

    const graphicsToRemove = graphicLayer.graphics.items.filter(graphic =>
      objectIdsToRemove.includes(graphic.attributes?.OBJECTID)
    );

    graphicsToRemove.forEach(graphic => {
      graphicLayer.remove(graphic);
    });
  };
  const CopyFeaturesinTarget = async (addData, ObjectIDList, options) => {
    try {
      const { layerInfo } = tabMapping[activePendingtabs];

      const layer = new FeatureLayer({ url: layerInfo.TargetUrl });
      //const result = await layer.applyEdits(addData);
      const result = await layer.applyEdits({
        ...addData,
        params: { token }
      });
      const editsApplied = result.addFeatureResults.concat(
        result.updateFeatureResults,
        result.deleteFeatureResults
      );
      if (editsApplied && editsApplied.length > 0) {
        await CopyAttachmentsinTarget(editsApplied, ObjectIDList);
        showAlert(t("copyfeaturesintarget"), "success");
        setIsEditing(!isEditing);
        if (activePendingtabs.includes(t("Plants"))) {
          setPlantsSelectedRows([]);
          setActivePendingtab(t("Plants"));
          removeGraphicsFromMap(ObjectIDList, AnimalSightsGraphicLayers.Plants);
          fetchLayerRecords(t("Plants"), window.PlantInfo.DisplayAttributes, window.PlantInfo.Url);
          await fetchApprovedRecordsByApprovalType({
            type: t("Plants"),
            layerUrl: window.PlantInfo.TargetUrl,
            fieldsMapping: window.PlantInfo.TargetFieldMapping,
            SurveyFromDate: "",
            SurveyToDate: "",
            t,
            setGlobalData,
            currentRowsRef: PlantscurrentRows,
            setData: setPlantsData,
            setHeaders: setPlantsHeaders
          });
          //setLoading(false);
          //fetchPlantRecords();
        } else if (activePendingtabs.includes(t("Invertebrates"))) {
          setInvertebratesSelectedRows([]);
          setActivePendingtab(t("Invertebrates"));
          removeGraphicsFromMap(ObjectIDList, AnimalSightsGraphicLayers.Insects);
          fetchLayerRecords(t("Invertebrates"), window.InvertiblesInfo.DisplayAttributes, window.InvertiblesInfo.Url);
          await fetchApprovedRecordsByApprovalType({
            type: t("Invertebrates"),
            layerUrl: window.InvertiblesInfo.TargetUrl,
            fieldsMapping: window.InvertiblesInfo.TargetFieldMapping,
            SurveyFromDate: "",
            SurveyToDate: "",
            t,
            setGlobalData,
            currentRowsRef: InvertebratescurrentRows,
            setData: setInvertebratesData,
            setHeaders: setInvertebrateHeaders
          });
          //setLoading(false);
          //fetchInvertebrateRecords();
        } else if (activePendingtabs.includes(t("Mammals"))) {
          setMammalsSelectedRows([]);
          setActivePendingtab(t("Mammals"));
          removeGraphicsFromMap(ObjectIDList, AnimalSightsGraphicLayers.Mammals);
          fetchLayerRecords(t("Mammals"), window.MammalsInfo.DisplayAttributes, window.MammalsInfo.Url);
          await fetchApprovedRecordsByApprovalType({
            type: t("Mammals"),
            layerUrl: window.MammalsInfo.TargetUrl,
            fieldsMapping: window.MammalsInfo.TargetFieldMapping,
            SurveyFromDate: "",
            SurveyToDate: "",
            t,
            setGlobalData,
            currentRowsRef: MammalscurrentRows,
            setData: setMammalsData,
            setHeaders: setMammalsHeaders
          });
          //setLoading(false);
          //fetchMammalRecords();
        } else if (activePendingtabs.includes(t("Reptiles"))) {
          setReptilesSelectedRows([]);
          setActivePendingtab(t("Reptiles"));
          removeGraphicsFromMap(ObjectIDList, AnimalSightsGraphicLayers.Reptiles);
          fetchLayerRecords(t("Reptiles"), window.ReptilesInfo.DisplayAttributes, window.ReptilesInfo.Url);
          await fetchApprovedRecordsByApprovalType({
            type: t("Reptiles"),
            layerUrl: window.ReptilesInfo.TargetUrl,
            fieldsMapping: window.ReptilesInfo.TargetFieldMapping,
            SurveyFromDate: "",
            SurveyToDate: "",
            t,
            setGlobalData,
            currentRowsRef: ReptilescurrentRows,
            setData: setReptilesData,
            setHeaders: setReptilesHeaders
          });
          //setLoading(false);
          //fetchReptileRecords();
        }
      }
    } catch (error) {
      UpdateFeaturesRollback(options);
      showAlert(t("unabletocopyfeatureintarget"), "error");
      //setLoading(false);
    }
    finally {
      setLoading(false);
    }
  };
  const handleApproveApplyEdits = async (layer, TargetFeatures_Add, ObjectIDList, options) => {
    if (!layer) return;
    try {
      //const result = await layer.applyEdits(options);
      const result = await layer.applyEdits({
        ...options,
        params: { token }
      });
      const editsApplied = result.updateFeatureResults.concat(
        result.addFeatureResults,
        result.deleteFeatureResults
      );
      if (editsApplied && editsApplied.length > 0) {
        CopyFeaturesinTarget({ addFeatures: TargetFeatures_Add }, ObjectIDList, options);
      } else {
        showAlert(t("unableupdatefeature"), "error");
        setLoading(false);
      }
    } catch (error) {
      showAlert(t("errorapplyedits"), "error");
      UpdateFeaturesRollback(options);
      setLoading(false);
    }
  };
  const UpdateFeaturesRollback = async (Feature_Update_Revert) => {
    try {
      const { layerInfo } = tabMapping[activePendingtabs];
      const Tokenparam = sessionStorage.getItem("PortalToken");

      // Prepare request payload
      const options = new URLSearchParams();
      options.append("updates", JSON.stringify(Feature_Update_Revert.updateFeatures));
      options.append("f", "json");
      options.append("token", token);

      const response = await fetch(`${layerInfo.Url}/applyEdits`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: options.toString(),
      });
      const data = await response.json();
      if (data?.updateResults) {
        if (activePendingtabs.includes(t("Plants"))) {
          setActivePendingtab(t("Plants"));
          setPlantsSelectedRows([]);
          fetchLayerRecords(t("Plants"), window.PlantInfo.DisplayAttributes, window.PlantInfo.Url);
        } else if (activePendingtabs.includes(t("Invertebrates"))) {
          setActivePendingtab(t("Invertebrates"));
          setInvertebratesSelectedRows([]);
          fetchLayerRecords(t("Invertebrates"), window.InvertiblesInfo.DisplayAttributes, window.InvertiblesInfo.Url);
        } else if (activePendingtabs.includes(t("Mammals"))) {
          setActivePendingtab(t("Mammals"));
          setMammalsSelectedRows([]);
          fetchLayerRecords(t("Mammals"), window.MammalsInfo.DisplayAttributes, window.MammalsInfo.Url);
        } else if (activePendingtabs.includes(t("Reptiles"))) {
          setActivePendingtab(t("Reptiles"));
          setReptilesSelectedRows([]);
          fetchLayerRecords(t("Reptiles"), window.ReptilesInfo.DisplayAttributes, window.ReptilesInfo.Url);
        }
      } else {
        showAlert(t("unableupdatefeature"), "error");
      }
    } catch (error) {
      //console.log("Error in UpdateFeaturesRollback:", error);
      throw new Error("Error in Update Features Rollback");
    }
  };

  const ApproveFeatures = () => {
    setLoading(true);
    const tabConfig = {
      [t("Plants")]: {
        layerUrl: window.PlantInfo.Url,
        currentRows: PlantscurrentRows.current,
        selectedRows: PlantsSelectedRows,
        data: PlantsData,
        displayAttributes: window.PlantInfo.DisplayAttributes,
        targetFieldMapping: window.PlantInfo.TargetFieldMapping,
      },
      [t("Invertebrates")]: {
        layerUrl: window.InvertiblesInfo.Url,
        currentRows: InvertebratescurrentRows.current,
        selectedRows: InvertebratesSelectedRows,
        data: InvertebratesData,
        displayAttributes: window.InvertiblesInfo.DisplayAttributes,
        targetFieldMapping: window.InvertiblesInfo.TargetFieldMapping,
      },
      [t("Mammals")]: {
        layerUrl: window.MammalsInfo.Url,
        currentRows: MammalscurrentRows.current,
        selectedRows: MammalsSelectedRows,
        data: MammalsData,
        displayAttributes: window.MammalsInfo.DisplayAttributes,
        targetFieldMapping: window.MammalsInfo.TargetFieldMapping,
      },
      [t("Reptiles")]: {
        layerUrl: window.ReptilesInfo.Url,
        currentRows: ReptilescurrentRows.current,
        selectedRows: ReptilesSelectedRows,
        data: ReptilesData,
        displayAttributes: window.ReptilesInfo.DisplayAttributes,
        targetFieldMapping: window.ReptilesInfo.TargetFieldMapping,
      },
    };

    //const activeTab = activePendingtabs.find((tab) => tabConfig[tab]);

    if (!activePendingtabs) {
      return;
    }

    const {
      layerUrl,
      currentRows,
      selectedRows,
      data,
      displayAttributes,
      targetFieldMapping,
    } = tabConfig[activePendingtabs];

    const layer = new FeatureLayer({ url: layerUrl });

    const ObjectIDList = getSelectedObjectIDs(currentRows, selectedRows);

    const { TargetFeatures_Add, Feature_Update } = prepareGraphics(
      ObjectIDList,
      data,
      displayAttributes,
      targetFieldMapping,
      activePendingtabs
    );

    handleApproveApplyEdits(layer, TargetFeatures_Add, ObjectIDList, {
      updateFeatures: Feature_Update,
    });
  };
  const getSelectedObjectIDs = (currentRows, selectedRows) => {
    return currentRows
      .filter((item) => selectedRows.includes(item.id))
      .map((item) => parseInt(item.OBJECTID));
  };
  const prepareGraphics = (ObjectIDList, data, DisplayAttributes, FieldMappings, type) => {
    let TargetFeatures_Add = [];
    let Feature_Update = [];

    data.forEach((item) => {
      if (ObjectIDList.includes(item.attributes.OBJECTID)) {
        const obj = prepareAttributes(item.attributes, DisplayAttributes, type);
        obj.Point_X = item.geometry.longitude;
        obj.Point_Y = item.geometry.latitude;
        const targetObj = mapFields(obj, FieldMappings, type);
        const pointGeom = new Point({
          longitude: item.geometry.longitude,
          latitude: item.geometry.latitude,
        });
        TargetFeatures_Add.push(
          new Graphic({
            geometry: pointGeom,
            attributes: targetObj,
          })
        );
        Feature_Update.push(
          new Graphic({
            geometry: pointGeom,
            attributes: obj,
          })
        );
      }
    });
    return { TargetFeatures_Add, Feature_Update };
  };
  const prepareAttributes = (attributes, DisplayAttributes, tabName) => {
    // const obj = {};
    // DisplayAttributes.forEach(({ AttrName }) => {
    //   obj[AttrName] = AttrName === "OBJECTID" ? parseInt(attributes.OBJECTID) : attributes[AttrName];
    // });
    const obj = { ...attributes };
    if (tabName === "Reptiles") {
      //obj.ObservationDate = adjustDate(attributes["ObservationDate"], attributes["DataSource"]);
      if (attributes["DataSource"] === "1") {
        let feqaturecreatedDate = attributes["created_date"];
        let timestamp = JSON.parse(feqaturecreatedDate);
        let date = new Date(timestamp);
        date.setHours(date.getHours() + 4);
        obj.ObservationDate = date.getTime();
      }
      else {
        var feqaturecreatedDate = attributes["ObservationDate"];
        var timestamp = JSON.parse(feqaturecreatedDate);
        var date = new Date(timestamp);
        obj.ObservationDate = date.getTime();
      }

    } else {
      //obj.SurveyDate = adjustDate(attributes["SurveyDate"], attributes["DataSource"]);

      if (attributes["DataSource"] === "1") {
        let feqaturecreatedDate = attributes["created_date"];
        let timestamp = JSON.parse(feqaturecreatedDate);
        let date = new Date(timestamp);
        date.setHours(date.getHours() + 4);
        obj.SurveyDate = date.getTime();
      }
      else {
        var feqaturecreatedDate = attributes["SurveyDate"];
        var timestamp = JSON.parse(feqaturecreatedDate);
        var date = new Date(timestamp);
        obj.SurveyDate = date.getTime();
      }
    }
    obj.Status = "Approved";
    return obj;
  };
  // Map Fields
  const mapFields = (obj, FieldMappings, type) => {
    if (type === t("Invertebrates")) {
      const mappingRules = {
        Researcher: "Recordedby",
        ObservationDate: "SurveyDate",
        NumberOfIndividuals: "ObservedNumber",
        SpeciesFamily: "Family",
        Status: "SpecimenTaken",
        MethodUsed: "TrappingMethod",
        SpeciesOrder: "InsectOrder",
        Species_Order: "InsectOrder",
        LocationName: "Location",
        //FDC_Global_ID: "GlobalID",
      };
      return FieldMappings.reduce((acc, { fieldname, Value }) => {
        if (activePendingtabs === t("Invertebrates") && fieldname === "SpeciesOrder") {
          const match = SpeciesOrder.find(item => item.key === obj.InsectOrder?.toString());
          acc[fieldname] = match ? parseInt(match.key) : "";
        } else if (fieldname === "Species_Order") {
          const match = SpeciesOrder.find(item => item.key === obj.InsectOrder?.toString());
          acc[fieldname] = match ? match.value : "";
        }
        else {
          acc[fieldname] = mappingRules[fieldname]
            ? obj[mappingRules[fieldname]]
            : obj[Value] || obj[fieldname] || null;
        }

        return acc;
      }, {});
    }
    if (type === t("Mammals")) {
      const mappingRules = {
        NumberOfIndividuals: "SpeciesNumber",
        Recorder: "Collector",
        LocationName: "Location",
        //FDC_Global_ID: "GlobalID",
      };
      if (obj["SurveyDate"]) {
        const surveyDate = new Date(obj["SurveyDate"]);
        // Calculate SurveyTime
        const hours = surveyDate.getHours().toString().padStart(2, '0');
        const minutes = surveyDate.getMinutes().toString().padStart(2, '0');
        const seconds = surveyDate.getSeconds().toString().padStart(2, '0');
        obj["SurveyTime"] = `${hours}:${minutes}:${seconds}`;

        // Calculate AM_PM
        obj["AM_PM"] = hours >= 12 ? "pm" : "am";
      }
      // Handle CommonName
      if (obj["SpeciesName"]) {
        const commonLatinName = obj["SpeciesName"].split("(");
        obj["CommonName"] = commonLatinName[0]?.trim() || ""; // Common name
        obj["LatinName"] = commonLatinName[1]?.replace(")", "").trim() || ""; // Latin name
      }
      return FieldMappings.reduce((acc, { fieldname, Value }) => {
        if (fieldname === "Species") {
          const match = MammalsDomainValues[0].Species.find(item => item.key === obj.Species?.toString());
          acc[fieldname] = match ? match.value : "";
        } else {
          acc[fieldname] = mappingRules[fieldname]
            ? obj[mappingRules[fieldname]]
            : obj[Value] || obj[fieldname] || null;
        }

        return acc;
      }, {});
    }
    if (type === t("Plants")) {
      const mappingRules = {
        LatinName: "PlantSpecies",
        Location: "GeneralLocation",
        FDCGlobalID: "GlobalID",
      };
      // return FieldMappings.reduce((acc, { fieldname, Value }) => {
      //   acc[fieldname] = obj[Value] || obj[fieldname] || null; // Direct mapping
      //   return acc;
      // }, {});
      obj["Recorder"] = localStorage ? localStorage.username : "";
      return FieldMappings.reduce((acc, { fieldname, Value }) => {
        if (fieldname === "PercentageCover") {
          const match = PlantsDomainValues[0].PercentageCover.find((item) => item.key === Number(obj.PercentageCover)) || null;
          acc[fieldname] = match ? match.value : null;
        } else {
          acc[fieldname] = mappingRules[fieldname]
            ? obj[mappingRules[fieldname]]
            : obj[Value] || obj[fieldname] || null;
        }
        return acc;
      }, {});
    }
    if (type === t("Reptiles")) {
      const mappingRules = {
        Recorder: "Collector",
        FDC_Global_ID: "GlobalID",
        SpeciesName: "Species"
      };
      if (obj["Species"]) {
        const commonLatinName = obj["Species"].split("(");
        obj["CommonName"] = commonLatinName[0]?.trim() || ""; // Common name
        obj["LatinName"] = commonLatinName[1]?.replace(")", "").trim() || ""; // Latin name
      }
      if (obj['ObservationDate']) {
        var timestamp = JSON.parse(obj['ObservationDate']);
        var date = new Date(timestamp);
        //var survytime = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        //obj["SurveyTime"] = survytime;
        if (!isNaN(date.getTime())) {
          obj["SurveyTime"] = date.toLocaleTimeString("en-GB", { hour12: false });
        } else {
          obj["SurveyTime"] = ""; // Set as empty if invalid
        }
      }
      return FieldMappings.reduce((acc, { fieldname, Value }) => {

        if (fieldname === "SpeciesName") {
          const match = ReptilesDomainValues[0].Species.find(item => item.key === obj.Species?.toString());
          acc[fieldname] = match ? match.value : "";
        } else {
          acc[fieldname] = mappingRules[fieldname]
            ? obj[mappingRules[fieldname]]
            : obj[Value] || obj[fieldname] || null;
        }

        return acc;
      }, {});
    }
  };
  // Adjust Date
  const adjustDate = (date, dataSource) => {
    const newDate = new Date(date);
    if (dataSource === "1") {
      newDate.setHours(newDate.getHours() + 4);
    }
    return newDate.getTime();
  };
  const handleEditSelectedRows = () => {
    if (
      PlantsSelectedRows.length === 0 &&
      InvertebratesSelectedRows.length === 0 &&
      MammalsSelectedRows.length === 0 &&
      ReptilesSelectedRows.length === 0
    ) {
      showAlert(t("Noselectionoffeatures"), "info");
      return;
    } else {
      setIsEditing(!isEditing);
      if (activePendingtabs.includes(t("Plants"))) {
        editingRows = PlantsSelectedRows;
        PlantscurrentRows.current.forEach((item) => {
          if (PlantsSelectedRows.includes(item.id)) {
            setCloneData({ id: item.id, data: { ...item } });
          }
        });
      } else if (activePendingtabs.includes(t("Invertebrates"))) {
        editingRows = InvertebratesSelectedRows;
        InvertebratescurrentRows.current.forEach((item) => {
          if (InvertebratesSelectedRows.includes(item.id)) {
            setCloneData({ id: item.id, data: { ...item } });
          }
        });
      } else if (activePendingtabs.includes(t("Mammals"))) {
        editingRows = MammalsSelectedRows;
        MammalscurrentRows.current.forEach((item) => {
          if (MammalsSelectedRows.includes(item.id)) {
            setCloneData({ id: item.id, data: { ...item } });
          }
        });
      } else if (activePendingtabs.includes(t("Reptiles"))) {
        editingRows = ReptilesSelectedRows;
        ReptilescurrentRows.current.forEach((item) => {
          if (ReptilesSelectedRows.includes(item.id)) {
            setCloneData({ id: item.id, data: { ...item } });
          }
        });
      }
    }
  };

  const handleRowSelection = (rowId) => {
    const tabConfig = {
      [t("Plants")]: setPlantsSelectedRows,
      [t("Invertebrates")]: setInvertebratesSelectedRows,
      [t("Mammals")]: setMammalsSelectedRows,
      [t("Reptiles")]: setReptilesSelectedRows,
    };
    if (!activePendingtabs) {
      return;
    }
    const setSelectedRows = tabConfig[activePendingtabs];

    if (isMobileView) {
      setSelectedRows([rowId]);
    }
    else {
      if (!isEditing) {
        setSelectedRows((prevSelectedRows) =>
          prevSelectedRows.includes(rowId)
            ? prevSelectedRows.filter((id) => id !== rowId)
            : [...prevSelectedRows, rowId]
        );
      } else {
        if (editingRows.includes(rowId)) {
          setSelectedRows((prevSelectedRows) =>
            prevSelectedRows.includes(rowId)
              ? prevSelectedRows.filter((id) => id !== rowId)
              : [...prevSelectedRows, rowId]
          );
          editingRows = editingRows.slice(0, editingRows.indexOf(rowId));
          if (editingRows.length === 0) {
            setIsEditing(!isEditing);
          }
        }
      }
    }
  };
  const handleCancelClick = () => {
    setShowForm(false);
    clearControls();
  };
  const handleCanceledting = () => {
    const tabConfig = {
      [t("Plants")]: {
        currentRowsRef: PlantscurrentRows, // Reference to the ref
        displayAttributes: window.PlantInfo.DisplayAttributes,
      },
      [t("Invertebrates")]: {
        currentRowsRef: InvertebratescurrentRows,
        displayAttributes: window.InvertiblesInfo.DisplayAttributes,
      },
      [t("Mammals")]: {
        currentRowsRef: MammalscurrentRows,
        displayAttributes: window.MammalsInfo.DisplayAttributes,
      },
      [t("Reptiles")]: {
        currentRowsRef: ReptilescurrentRows,
        displayAttributes: window.ReptilesInfo.DisplayAttributes,
      },
    };
    if (activePendingtabs) {
      const { currentRowsRef, displayAttributes } = tabConfig[activePendingtabs];
      const updatedData = currentRowsRef.current.map((item) => {
        if (item.id === CloneData.id) {
          const obj = { ...item };
          displayAttributes.forEach(({ AttrName }) => {
            obj[AttrName] = CloneData.data[AttrName];
          });
          return obj; // Return the updated item
        }
        return item; // Return other rows unchanged
      });
      currentRowsRef.current = updatedData; // Update the ref's current value
    }

    setIsEditing(false);
    editingRows = [];
    setInvertebratesSelectedRows([]);
    setPlantsSelectedRows([]);
    setMammalsSelectedRows([]);
    setReptilesSelectedRows([]);
  };
  const getTabData = (tabs) => {
    if (tabs.includes(t("Plants"))) return PlantscurrentRows.current;
    if (tabs.includes(t("Invertebrates"))) return InvertebratescurrentRows.current;
    if (tabs.includes(t("Mammals"))) return MammalscurrentRows.current;
    if (tabs.includes(t("Reptiles"))) return ReptilescurrentRows.current;
    return null;
  };
  const updateCurrentRows = (data) => {
    if (activePendingtabs.includes(t("Plants"))) PlantscurrentRows.current = data;
    else if (activePendingtabs.includes(t("Invertebrates")))
      InvertebratescurrentRows.current = data;
    else if (activePendingtabs.includes(t("Mammals")))
      MammalscurrentRows.current = data;
    else if (activePendingtabs.includes(t("Reptiles")))
      ReptilescurrentRows.current = data;
  };

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
    let dataToFilter = originalData.length > 0 ? originalData : getTabData(activePendingtabs);
    setOriginalData(dataToFilter);
    if (value === "All" || value === "") {
      resetToOriginalData(key, value);
      return;
    }
    const filterRows = (item, domainValues) => {
      const valueLower = value.toLowerCase();
      if (domainValues[key]) {
        const DomainValue = domainValues[key]?.find(
          (name) => name.value.toLowerCase() === valueLower
        );
        return item[key]?.toLowerCase() === DomainValue?.value.toLowerCase();
      }
      else if (typeof item[key] === "string") {
        return item[key]?.toLowerCase().includes(value.toLowerCase());
      } else if (typeof item[key] === "number") {
        return item[key].toString().includes(value);
      }
      return true;
    };
    const tabDataMapping = {
      [t("Plants")]: {
        currentRows: PlantscurrentRows,
        domainValues: PlantsDomainValues[0] || {},
      },
      [t("Invertebrates")]: {
        currentRows: InvertebratescurrentRows,
        domainValues: InsectsDomainValues[0] || {},
      },
      [t("Mammals")]: {
        currentRows: MammalscurrentRows,
        domainValues: MammalsDomainValues[0] || {},
      },
      [t("Reptiles")]: {
        currentRows: ReptilescurrentRows,
        domainValues: ReptilesDomainValues[0] || {},
      },
    };
    const { currentRows, domainValues } = tabDataMapping[activePendingtabs];
    filteredData = dataToFilter.filter((item) => { return filterRows(item, domainValues); });

    updateCurrentRows(filteredData.length > 0 ? filteredData : []);
  };

  const applyFilters = () => {
    // Get dataToFilter based on originalData or tab-specific data
    let dataToFilter =
      originalData.length > 0 ? originalData : getTabData(activePendingtabs);

    // Save the original data for potential resets
    setOriginalData(dataToFilter);

    // Tab-specific data mapping
    const tabDataMapping = {
      [t("Plants")]: {
        currentRows: PlantscurrentRows,
        domainValues: PlantsDomainValues[0],
      },
      [t("Invertebrates")]: {
        currentRows: InvertebratescurrentRows,
        domainValues: InsectsDomainValues[0],
      },
      [t("Mammals")]: {
        currentRows: MammalscurrentRows,
        domainValues: MammalsDomainValues[0],
      },
      [t("Reptiles")]: {
        currentRows: ReptilescurrentRows,
        domainValues: ReptilesDomainValues[0],
      },
    };

    // Retrieve domain values for the active tab
    const { domainValues } = tabDataMapping[activePendingtabs];

    // Filter logic based on filters object
    filteredData = dataToFilter.filter((item) => {
      // Loop through all keys in the filters object
      return Object.keys(filters).every((key) => {
        const value = filters[key];

        // Check for "All" or empty values, which act as no filtering
        if (value === "All" || value === "") {
          return true; // Do not filter for this key
        }

        return mobFilterRows(item, domainValues, key, value);
      });
    });
    if (filteredData.length == 0) {
      setIsResetBtnShow(true)
    }
    else {
      setIsResetBtnShow(false)
    }
    // Update the current rows with the filtered data
    updateCurrentRows(filteredData.length > 0 ? filteredData : []);
  };
  const mobFilterRows = (item, domainValues, key, value) => {
    const valueLower = value.toLowerCase();
    if (domainValues[key]) {
      const DomainValue = domainValues[key]?.find(
        (name) => name.value.toLowerCase() === valueLower
      );
      return item[key]?.toLowerCase() === DomainValue?.value.toLowerCase();
    }
    else if (typeof item[key] === "string") {
      return item[key]?.toLowerCase().includes(value.toLowerCase());
    } else if (typeof item[key] === "number") {
      return item[key].toString().includes(value);
    }
    return true;
  };
  const handleFilterApply = () => {
    if (Object.keys(filters).length > 0) {
      applyFilters();
    }

  }
  const handleMobFilterChange = (key, value) => {
    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };

  const resetToOriginalData = (key, value) => {
    resetToOriginalDataRows = originalData.filter((item) => { return item[key]; });
    updateCurrentRows(resetToOriginalDataRows.length > 0 ? resetToOriginalDataRows : []);

    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };
  const resetMobFilters = () => {
    updateCurrentRows(originalData);
    setFilters({});
  };



  const handleClarFilter = () => {
    setFilters({});
    setShowFilter(false);
    setMobFilterShow(false)
    setIsResetBtnShow(false);
    if (originalData.length > 0) {
      if (activePendingtabs.includes(t("Plants"))) {
        PlantscurrentRows.current = originalData;
      } else if (activePendingtabs.includes(t("Invertebrates"))) {
        InvertebratescurrentRows.current = originalData;
      } else if (activePendingtabs.includes(t("Mammals"))) {
        MammalscurrentRows.current = originalData;
      } else if (activePendingtabs.includes(t("Reptiles"))) {
        ReptilescurrentRows.current = originalData;
      }
    }
  };

  // const fetchAttachments = async (results, layerUrl, type, concurrency = 5) => {
  //   //setLoading(true);
  //   if (!results || !results.features) {
  //     showAlert(t("noattach"), "error");
  //     setLoading(false);
  //     return;
  //   }

  //   const processedOBJECTIDs = new Set(); // Track processed OBJECTIDs
  //   const options = { f: "json", responseType: "json" };
  //   const draftAttachmentsArray = []; // Store draft attachment objects

  //   const fetchAttachment = async (objectId) => {
  //     const AttachmentsUrl = `${layerUrl}/${objectId}/attachments`;
  //     const url = new URL(AttachmentsUrl);
  //     Object.keys(options).forEach((key) =>
  //       url.searchParams.append(key, options[key])
  //     );

  //     try {
  //       const response = await fetch(url, {
  //         method: "GET",
  //         mode: "cors",
  //         credentials: "include",
  //       });

  //       if (!response.ok)
  //         throw new Error(`Failed to fetch for OBJECTID ${objectId}`);

  //       const data = await response.json();

  //       draftAttachmentsArray.push({
  //         OBJECTID: objectId,
  //         AttachmentsList: data.attachmentInfos,
  //       });
  //       processedOBJECTIDs.add(objectId);
  //     } catch (error) {
  //       console.log(`Error fetching attachments for OBJECTID ${objectId}:`, error);
  //       showAlert(t("errorattachments"), "error");
  //     }
  //   };

  //   const processQueue = async (items) => {
  //     const promises = items.map((item) =>
  //       fetchAttachment(item.attributes.OBJECTID)
  //     );
  //     await Promise.allSettled(promises); // Handle all promises, even if some fail
  //   };

  //   try {
  //     const tasks = results.features
  //       .filter((item) => !processedOBJECTIDs.has(item.attributes.OBJECTID))
  //       .reduce((groups, item, index) => {
  //         const groupIndex = Math.floor(index / concurrency); // Batch by concurrency
  //         if (!groups[groupIndex]) groups[groupIndex] = [];
  //         groups[groupIndex].push(item);
  //         return groups;
  //       }, []);

  //     for (let s = 0; s < tasks.length; s++) {
  //       await processQueue(tasks[s]);
  //       if (s === tasks.length - 1) {
  //         if (type === t("Invertebrates")) {
  //           setInsectsDraftAttachments(draftAttachmentsArray);
  //         } else if (type === t("Plants")) {
  //           setPlantsDraftAttachments(draftAttachmentsArray);
  //         } else if (type === t("Mammals")) {
  //           setMammalsDraftAttachments(draftAttachmentsArray);
  //         } else if (type === t("Reptiles")) {
  //           setReptilesDraftAttachments(draftAttachmentsArray);
  //         }
  //         //setLoading(false);
  //       }
  //     }
  //   } catch (error) {
  //     console.log("Error fetching attachments:", error);
  //     setLoading(false);
  //     showAlert(t("errorattachments"), "error");
  //   }
  // };






  const fetchAttachments = async (results, layerUrl, type, batchSize = 500, maxRetries = 3) => {
    //setLoading(true);
    if (!results || !results.features) {
      showAlert(t("noattach"), "error");
      setLoading(false);
      return;
    }

    const processedOBJECTIDs = new Set(); // Track processed OBJECTIDs
    const options = { f: "json", token: token, responseType: "json" };
    //const options = { f: "json", responseType: "json" };
    const draftAttachmentsArray = []; // Store draft attachment objects

    const fetchAttachmentBatch = async (objectIds, attempt = 1) => {
      // Create a batch request URL for multiple OBJECTIDs

      try {
        const batchAttachmentsUrl = `${layerUrl}/queryAttachments`;
        const url = new URL(batchAttachmentsUrl);
        Object.keys(options).forEach((key) =>
          url.searchParams.append(key, options[key])
        );
        url.searchParams.append('objectIds', objectIds.join(','));

        const response = await fetch(url, {
          method: "GET",
          mode: "cors",
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch batch for OBJECTIDs ${objectIds.join(',')}`);
        }

        const data = await response.json();

        // Process the batch response
        if (data.attachmentGroups) {
          data.attachmentGroups.forEach(group => {
            if (group.parentObjectId && group.attachmentInfos) {
              draftAttachmentsArray.push({
                OBJECTID: group.parentObjectId,
                AttachmentsList: group.attachmentInfos
              });
            }
          });
        }
      } catch (error) {
        if (attempt < maxRetries) {
          await new Promise((resolve) => setTimeout(resolve, 2000)); // Wait before retrying
          return fetchAttachmentBatch(objectIds, attempt + 1);
        } else {
          showAlert(t("errorattachments"), "error");
        }
      }
    };

    try {
      // Get all unique OBJECTIDs first
      const allObjectIds = results.features
        .map(item => item.attributes.OBJECTID)
        .filter((objectId, index, self) => self.indexOf(objectId) === index);

      // Process in batches
      for (let i = 0; i < allObjectIds.length; i += batchSize) {
        const batchIds = allObjectIds.slice(i, i + batchSize);
        await fetchAttachmentBatch(batchIds);
      }

      // Set the final state based on type
      if (type === t("Invertebrates")) {
        setInsectsDraftAttachments(draftAttachmentsArray);
        setGlobalData(prevData =>
          prevData.map(module =>
            module.moduleName === "Animal Sighting"
              ? {
                ...module,
                subTabs: module.subTabs.map(subTab =>
                  subTab.name === "PendingRecords"
                    ? {
                      ...subTab,
                      data: {
                        ...subTab.data,
                        InsectsDraftAttachments: draftAttachmentsArray
                      }
                    }
                    : subTab
                )
              }
              : module
          )
        );
      } else if (type === t("Plants")) {
        setPlantsDraftAttachments(draftAttachmentsArray);
        setGlobalData(prevData =>
          prevData.map(module =>
            module.moduleName === "Animal Sighting"
              ? {
                ...module,
                subTabs: module.subTabs.map(subTab =>
                  subTab.name === "PendingRecords"
                    ? {
                      ...subTab,
                      data: {
                        ...subTab.data,
                        PlantsDraftAttachments: draftAttachmentsArray
                      }
                    }
                    : subTab
                )
              }
              : module
          )
        );
      } else if (type === t("Mammals")) {
        setMammalsDraftAttachments(draftAttachmentsArray);
        setGlobalData(prevData =>
          prevData.map(module =>
            module.moduleName === "Animal Sighting"
              ? {
                ...module,
                subTabs: module.subTabs.map(subTab =>
                  subTab.name === "PendingRecords"
                    ? {
                      ...subTab,
                      data: {
                        ...subTab.data,
                        MammalsDraftAttachments: draftAttachmentsArray
                      }
                    }
                    : subTab
                )
              }
              : module
          )
        );
      } else if (type === t("Reptiles")) {
        setReptilesDraftAttachments(draftAttachmentsArray);
        setGlobalData(prevData =>
          prevData.map(module =>
            module.moduleName === "Animal Sighting"
              ? {
                ...module,
                subTabs: module.subTabs.map(subTab =>
                  subTab.name === "PendingRecords"
                    ? {
                      ...subTab,
                      data: {
                        ...subTab.data,
                        ReptilesDraftAttachments: draftAttachmentsArray
                      }
                    }
                    : subTab
                )
              }
              : module
          )
        );
      }

      //setLoading(false);
    } catch (error) {
      setLoading(false);
      showAlert(t("errorattachments"), "error");
    }
  };

  const GetFamilyRelationTableData = async () => {
    var AnimalSightingTab = globalData.find(module => module.moduleName === "Animal Sighting")
      .subTabs.find(subTab => subTab.name === "PendingRecords")
    if (AnimalSightingTab?.data && AnimalSightingTab?.data?.OrderFamilyNames && AnimalSightingTab?.data?.FamilySpeciesNames) {
      setOrderFamilyNames(AnimalSightingTab?.data?.OrderFamilyNames);
      setFamilySpeciesNames(AnimalSightingTab?.data?.FamilySpeciesNames);
    }
    else {
      try {
        const queryParams = new Query({
          where: "1=1",
          outFields: ["*"],
          orderByFields: ["Family ASC"],
          returnGeometry: false,
        });

        const requestOptions = {
          query: {
            token: token,
          },
        };
        const invertebrateSortedRecords = await query.executeQueryJSON(window.InvertiblesInfo.DomainNameUrl, queryParams, requestOptions);
        //const invertebrateSortedRecords = await query.executeQueryJSON(window.InvertiblesInfo.DomainNameUrl, queryParams);
        const resultCount = invertebrateSortedRecords.features || [];
        const speciesWithFamilyArray = [];
        const familyForOrderArray = [];

        resultCount.forEach((record) => {
          const attributes = record.attributes || {};
          const scientificName = attributes.Scientific_Name?.trim() || "";
          const familyName = attributes.Family?.trim();
          const speciesOrder = attributes.Order_?.trim();

          // Skip if order or family name is missing
          if (!speciesOrder || !familyName) return;

          // Handle FamilyForOrderArray
          let orderEntry = familyForOrderArray.find(
            (order) => order.SpeciesOrder === speciesOrder
          );
          if (!orderEntry) {
            orderEntry = {
              SpeciesOrder: speciesOrder,
              FamilyNames: [],
            };
            familyForOrderArray.push(orderEntry);
          }

          if (
            !orderEntry.FamilyNames.some((family) => family.value === familyName)
          ) {
            orderEntry.FamilyNames.push({ key: familyName, value: familyName });
          }

          // Handle SpeciesWithFamilyArray
          let familyEntry = speciesWithFamilyArray.find(
            (family) => family.FamilyName === familyName
          );
          if (!familyEntry) {
            familyEntry = {
              FamilyName: familyName,
              SpeciesNames: [],
            };
            speciesWithFamilyArray.push(familyEntry);
          }

          if (
            scientificName &&
            !familyEntry.SpeciesNames.some(
              (species) => species.value === scientificName
            )
          ) {
            familyEntry.SpeciesNames.push({
              key: scientificName,
              value: scientificName,
            });
          }
        });

        // Update state
        setOrderFamilyNames(familyForOrderArray);
        setFamilySpeciesNames(speciesWithFamilyArray);
        setGlobalData(prevData =>
          prevData.map(module =>
            module.moduleName === "Animal Sighting"
              ? {
                ...module,
                subTabs: module.subTabs.map(subTab =>
                  subTab.name === "PendingRecords"
                    ? {
                      ...subTab,
                      data: {
                        ...subTab.data,
                        OrderFamilyNames: familyForOrderArray,
                        FamilySpeciesNames: speciesWithFamilyArray
                      }
                    }
                    : subTab
                )
              }
              : module
          )
        );


      } catch (error) {
        showAlert(t("faileddomain"), "error");
      }
    }

  };


  const handleChange = (key, selectedOption, row) => {
    const tabConfig = {
      [t("Invertebrates")]: {
        currentRowsRef: InvertebratescurrentRows,
        setRows: setInvertebratesRows,
        specialKeys: [],
      },
      [t("Plants")]: {
        currentRowsRef: PlantscurrentRows,
        setRows: setPlantsRows,
        specialKeys: ["Precipitation"],
      },
      [t("Mammals")]: {
        currentRowsRef: MammalscurrentRows,
        setRows: setMammalsRows,
        specialKeys: ["Species"],
      },
      [t("Reptiles")]: {
        currentRowsRef: ReptilescurrentRows,
        setRows: setReptilesRows,
        specialKeys: ["Reptiles"],
      },
    };
    if (!activePendingtabs) {
      return;
    }
    const { currentRowsRef, setRows, specialKeys } = tabConfig[activePendingtabs];
    const updatedData = currentRowsRef.current.map((item) => {
      if (item.id === row.id) {
        return {
          ...item,
          [key]: specialKeys.includes(key) ? selectedOption.label : selectedOption.value,
        };
      }
      return item; // Return the item as is if it doesn't match  
    });
    currentRowsRef.current = updatedData; // Update the ref's current value  
    setRows([...updatedData]);
  };
  const handleOrderChange = (selectedOption, row) => {
    const updatedData = InvertebratescurrentRows.current.map((item) => {
      if (item.id === row.id) {
        return { ...item, InsectOrder: selectedOption.label, Family: null, SpeciesName: null };
      }
      return item;
    });
    InvertebratescurrentRows.current = updatedData;
    setInvertebratesRows([...updatedData]);
  };
  const handleFamilyChange = (selectedOption, row) => {
    const updatedData = InvertebratescurrentRows.current.map((item) => {
      if (item.id === row.id) {
        return { ...item, Family: selectedOption.value };
      }
      return item;
    });
    InvertebratescurrentRows.current = updatedData;
    setInvertebratesRows([...updatedData]);
  };

  const handleMammalsSpeciesChange = (selectedOption, row) => {
    const updatedData = MammalscurrentRows.current.map((item) => {
      if (item.id === row.id) {
        return { ...item, Species: selectedOption.label };
      }
      return item;
    });
    MammalscurrentRows.current = updatedData;
    setMammalsRows([...updatedData]);
  };

  const handleReptileChange = (selectedOption, row) => {
    const updatedData = ReptilescurrentRows.current.map((item) => {
      if (item.id === row.id) {
        return { ...item, Reptiles: selectedOption.label };
      }
      return item;
    });
    ReptilescurrentRows.current = updatedData;
    setReptilesRows([...updatedData]);
  };

  const handleInputChange = (id, key, value) => {
    if (!activePendingtabs) {
      return;
    }
    const { currentRows } = tabMapping[activePendingtabs];

    if (key === "SurveyDate" || key === "ObservationDate") {
      const today = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().slice(0, 5);
      if (value > today) {
        showAlert(t("Future dates are not allowed."), "error");
        setEditedRows((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            [key]: "",
          },
        }));
        return;
      }
    }
    setEditedRows((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [key]: value,
      },
    }));

    // Update the current rows
    const updatedData = currentRows.current.map((item) => {
      if (item.id === id) {
        return { ...item, [key]: value }; // Update only the matching row
      }
      return item; // Return other rows unchanged
    });
    currentRows.current = updatedData; // Update the ref's current value
  };
  const handleApplyEdits = async (layer, options) => {
    setLoading(true);
    if (!layer) return;

    try {
      //const result = await layer.applyEdits(options);
      const result = await layer.applyEdits({
        ...options,
        params: { token }
      });
      const editsApplied = result.updateFeatureResults.concat(
        result.addFeatureResults,
        result.deleteFeatureResults
      );
      setIsDataModified(true);
      if (editsApplied && editsApplied.length > 0) {
        showAlert(t("updatefeature"), "success");
        setIsEditing(!isEditing);
        setLoading(false);

        const tabConfig = {
          [t("Plants")]: {
            setSelectedRows: setPlantsSelectedRows,
            displayAttributes: window.PlantInfo.DisplayAttributes,
            url: window.PlantInfo.Url,
          },
          [t("Invertebrates")]: {
            setSelectedRows: setInvertebratesSelectedRows,
            displayAttributes: window.InvertiblesInfo.DisplayAttributes,
            url: window.InvertiblesInfo.Url,
          },
          [t("Mammals")]: {
            setSelectedRows: setMammalsSelectedRows,
            displayAttributes: window.MammalsInfo.DisplayAttributes,
            url: window.MammalsInfo.Url,
          },
          [t("Reptiles")]: {
            setSelectedRows: setReptilesSelectedRows,
            displayAttributes: window.ReptilesInfo.DisplayAttributes,
            url: window.ReptilesInfo.Url,
          },
        };
        if (activePendingtabs) {
          const { setSelectedRows, displayAttributes, url } = tabConfig[activePendingtabs];
          setActivePendingtab(activePendingtabs);
          setSelectedRows([]);
          fetchLayerRecords(activePendingtabs, displayAttributes, url);
        }
      } else {
        setIsDataModified(false);
        showAlert(t("unableupdatefeature"), "error");
      }
    } catch (error) {
      setLoading(false);
      let message = t('errorapplyedits');
      if (error.code && error.code === 400) {
        message = t('insufficientPortalPermission');
      }
      showAlert(message, "error");
    }
  };
  const reformatDate = (dateStr) => {
    if (!dateStr) return ""; // Handle null/undefined input   
    const [datePart, timePart = "00:00:00"] = dateStr.split("T"); // Split date and time, default time if missing  
    const [year, month, day] = datePart.split("-"); // Extract year, month, and day  
    const [hour = "00", minute = "00", second = "00"] = timePart.split(":"); // Handle missing time components   
    return `${day}-${month}-${year} ${hour}:${minute}:${second}`; // Return formatted date  
  };
  const handleSave = (mobileSelectedRow) => {
    setLoading(true);
    const handleLayerUpdates = (layerInfo, selectedRows, currentRows, domainValues) => {
      const layer = new FeatureLayer({ url: layerInfo.Url });
      const displayAttributes = layerInfo.DisplayAttributes;
      const featureUpdates = [];

      currentRows.current.forEach((item) => {
        if (selectedRows.includes(item.id)) {
          const obj = {};
          let longValue = "";
          let latValue = "";
          let invalidCoord = false;

          displayAttributes.forEach(({ AttrName }) => {
            if (AttrName === "OBJECTID" || layerInfo.SpecialAttributes?.includes(AttrName)) {
              obj[AttrName] = parseInt(item[AttrName]);
            } else if (
              AttrName === "Point_X" ||
              AttrName === "POINT_X" ||
              AttrName === "Point_Y" ||
              AttrName === "POINT_Y"
            ) {
              const isLongitude = AttrName === "Point_X" || AttrName === "POINT_X";
              const isLatitude = AttrName === "Point_Y" || AttrName === "POINT_Y";
              const coordValue = item[AttrName];

              if (
                (isLongitude && (coordValue > 51.303 && coordValue < 56.664)) ||
                (isLatitude && (coordValue > 22.455 && coordValue < 26.326))
              ) {
                obj[AttrName] = coordValue;
                if (isLongitude) longValue = coordValue;
                if (isLatitude) latValue = coordValue;
              } else {
                showAlert(
                  isLongitude ? t("invalidLong") : t("invalidLat"),
                  "error"
                );
                setIsEditing(true);
                setLoading(false);
                invalidCoord = true;
                return;
              }
            } else if (AttrName === "SurveyDate" || AttrName === "ObservationDate") {
              obj[AttrName] = formatDateToTimestamp(item[AttrName]);
            } else if (domainValues?.[AttrName]) {
              if (AttrName === "InsectOrder" || AttrName === "Species" || AttrName === "Reptiles") {
                const value = domainValues[AttrName].find(({ value }) => value === item[AttrName]);
                if (activePendingtabs === "Mammals" || AttrName === "Reptiles") {
                  if (value) obj[AttrName] = parseInt(value.key);
                } else {
                  if (value) obj[AttrName] = value.key;
                }
              } else {
                const value = domainValues[AttrName].find(({ value }) => value === item[AttrName]);
                if (value) obj[AttrName] = value.key;
              }
            } else {
              obj[AttrName] = item[AttrName];
            }
          });

          if (!invalidCoord && longValue && latValue) {
            const pointGeom = new Point({
              longitude: longValue,
              latitude: latValue,
            });
            const graphicDraft = new Graphic({
              geometry: pointGeom,
              attributes: obj,
            });
            featureUpdates.push(graphicDraft);
          }
        }
      });

      if (featureUpdates.length > 0) {
        handleApplyEdits(layer, { updateFeatures: featureUpdates }).finally(() => setLoading(false));
      } else {
        setLoading(false);
      }
    };

    const formatDateToTimestamp = (dateString) => {
      if (dateString.includes("T")) {
        const dateParts = reformatDate(dateString).split(" ");
        const [day, month, year] = dateParts[0].split("-");
        const [hour, minute, second] = dateParts[1].split(":");
        const date = new Date(year, parseInt(month, 10) - 1, day, hour, minute, second);
        date.setHours(date.getHours() + 4);
        return date.getTime();
      } else {
        const date = new Date(formatToDatetimeLocal(dateString));
        date.setHours(date.getHours() + 4);
        return date.getTime();
      }
    };


    const Activetabs = Array.isArray(activePendingtabs) ? activePendingtabs : [activePendingtabs];
    Activetabs.forEach((tab) => {
      var { layerInfo, selectedRows, currentRows, domainValues } = tabMapping[tab] || {};
      if (mobileSelectedRow !== undefined) {
        selectedRows = mobileSelectedRow;
      }
      if (layerInfo && selectedRows && currentRows) {
        setLoading(true);
        handleLayerUpdates(layerInfo, selectedRows, currentRows, domainValues);
      }
    });
  };

  const handleDeleteAttachment = async (attachmentId, objectId) => {
    setLoading(true);
    const tabConfig = {
      [t("Plants")]: {
        layerInfo: window.PlantInfo,
        draftAttachments: PlantsDrafAttachments,
        setDraftAttachments: setPlantsDraftAttachments
      },
      [t("Invertebrates")]: {
        layerInfo: window.InvertiblesInfo,
        draftAttachments: InsectsDrafAttachments,
        setDraftAttachments: setInsectsDraftAttachments
      },
      [t("Mammals")]: {
        layerInfo: window.MammalsInfo,
        draftAttachments: MammalsDrafAttachments,
        setDraftAttachments: setMammalsDraftAttachments
      },
      [t("Reptiles")]: {
        layerInfo: window.ReptilesInfo,
        draftAttachments: ReptilesDrafAttachments,
        setDraftAttachments: setReptilesDraftAttachments
      },
    };

    if (!activePendingtabs) return;

    const { layerInfo, draftAttachments, setDraftAttachments } = tabConfig[activePendingtabs];
    const layerUrl = layerInfo.Url; // URL of the layer
    const deleteAttachmentUrl = `${layerUrl}/${objectId}/deleteAttachments`;

    const params = new URLSearchParams();
    params.append("attachmentIds", attachmentId); // Pass attachment IDs as a comma-separated string
    params.append("f", "json"); // Specify the response format

    try {
      const response = await fetch(deleteAttachmentUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params,
      });
      const result = await response.json();

      if (result.deleteAttachmentResults[0].success) {
        //console.log("Attachments deleted successfully:", result.deleteAttachmentResults);
        setDraftAttachments((prevDraftAttachments) => {
          const updatedDraftAttachments = prevDraftAttachments.map((item) => {
            if (item.OBJECTID === objectId) {
              return {
                ...item,
                AttachmentsList: item.AttachmentsList.filter(
                  (attachment) => attachment.id !== attachmentId
                ),
              };
            }
            return { ...item };
          });
          const rowData = { OBJECTID: objectId };
          const updatedContent = renderAttachments(rowData, updatedDraftAttachments, layerInfo);
          const attachmentDetails = extractImageAttachments(updatedContent);
          const updatedAttachmentDetails = ImageAttachments(attachmentDetails, objectId);

          setAttachmentsContent(updatedAttachmentDetails); // ✅ Ensure new state is set
          return updatedDraftAttachments;
        });
        showAlert(t("attachmentdeleted"), "success");
        setLoading(false);
      } else {
        showAlert(t("failedtodeleteattachment"), "error");
        setLoading(false);
      }
    } catch (error) {
      showAlert(t("failedtodeleteattachment"), "error");
      setLoading(false);
    }
  };
  const extractImageAttachments = (content) => {
    const attachments = [];
    if (content?.props?.children) {
      const attachmentItems = Array.isArray(content.props.children)
        ? content.props.children
        : [content.props.children];

      attachmentItems.forEach((item) => {
        const { props } = item;
        const attachmentId = parseInt(item.key);
        if (props && props.children) {
          // Check for img element
          const imageElement = React.Children.toArray(props.children).find(
            (child) => child.type === "img"
          );

          // Check for video element
          const videoElement = React.Children.toArray(props.children).find(
            (child) => child.type === "video"
          );

          if (imageElement) {
            const imageProps = imageElement.props;

            attachments.push({
              id: attachmentId || null, // Extract id from the key if available
              src: imageProps.src,
              alt: imageProps.alt || "Image",
              title: props.children[1]?.props?.children[0]?.props?.title || "Unknown",
            });
          }

          if (videoElement) {
            const videoProps = videoElement.props;

            attachments.push({
              id: attachmentId || null, // Extract id from the key if available
              src: videoProps.children.props.src, // Get the src from the child source element
              type: videoProps.children.props.type || "video/mp4",
              alt: "Video",
              title: props.children[1]?.props?.children[0]?.props?.title || "Unknown",
            });
          }
        }
      });
    }

    return attachments;
  };
  const settings = {
    dots: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    swipeToSlide: false,
    touchMove: false,
    draggable: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 1000,
    initialSlide: 0,
    arrows: true,
  };
  const ImageAttachments = (attachments, ObjectID) => {
    return (
      <div className="animalSlickDyn attachments-container">
        {attachments.length > 0 ? (
          <Slider {...settings}>
            {attachments.map((attachment, index) => (
              <div key={index} className="attachment-item">
                {attachment.type === "video" ? (
                  <video width="80" height="60" controls>
                    <source src={attachment.src} type="video/mp4" />
                  </video>
                ) : (
                  <div className="animalAttachSlider">
                    <img src={attachment.src} alt={attachment.alt} className="imageThumb" />
                    {/* <button variant="danger" className="closeSightSlider" size="sm" onClick={() => handleDeleteAttachment(attachment.id, ObjectID)}>
                      <img
                        src={`${process.env.PUBLIC_URL}/images/close.svg`}
                        alt={t("close")}
                      />
                    </button> */}

                    <button
                      className="btn btn-outline closeSightSlider"
                      onClick={() => handleDeleteAttachment(attachment.id, ObjectID)}
                      data-tooltip-content={t("delete")}
                      data-tooltip-id={`tooltip-delete`}
                      data-tooltip-place="bottom"
                    >
                      <img src={`${process.env.PUBLIC_URL}/images/bincircle.png`} title="Delete" className="delAnimalIconP" />
                      {/* <MdOutlineDelete size={15}  className="delete-17" /> */}
                    </button>
                  </div>
                )}
                <div className="titleFileAnimal">
                  <span className="fileName" title={attachment.title}>
                    {attachment.title}
                  </span>

                </div>
              </div>
            ))}
          </Slider>
        ) : (
          <p>{t("noattachavailble")}</p>
        )}
      </div>
    );
  };

  const handleShow = (row, isMobileMode) => {
    const Activetabs = Array.isArray(activePendingtabs) ? activePendingtabs : [activePendingtabs];
    Activetabs.forEach((activeTab) => {
      const { currentRows, draftAttachments, layerInfo } = tabMapping[activeTab] || {};

      if (currentRows && draftAttachments && layerInfo) {
        if (isMobileMode) {
          handleAttchementContentForMobile(row, activeTab, currentRows, draftAttachments, layerInfo)
        }
        else {
          handleLayerShow(row, activeTab, currentRows, draftAttachments, layerInfo);
        }

      }
    });
  };
  const handleAttchementContentForMobile = (row, activeTab, currentRows, draftAttachments, layerInfo) => {
    const matchingRow = currentRows.current.find((item) => item.id === row.id);
    if (matchingRow) {
      const content = renderAttachments(row, draftAttachments, layerInfo);
      const attachmentDetails = extractImageAttachments(content);
      setAttachmentsContent(ImageAttachments(attachmentDetails, matchingRow.OBJECTID)); // Render attachments directly
      setModalObjectId(row.OBJECTID);
    }
  }
  const handleLayerShow = (row, activeTab, currentRows, draftAttachments, layerInfo) => {
    const matchingRow = currentRows.current.find((item) => item.id === row.id);
    if (matchingRow) {
      const content = renderAttachments(row, draftAttachments, layerInfo);
      const attachmentDetails = extractImageAttachments(content);
      setAttachmentsContent(ImageAttachments(attachmentDetails, matchingRow.OBJECTID)); // Render attachments directly
      setModalObjectId(row.OBJECTID);
      setShowPopover(true);
      setRowData(row);
      setShow(true); // Open the modal
    }
  };

  const renderAttachments = (row, draftAttachments, layerInfo) => {
    const filteredAttachments = draftAttachments.filter(
      (item) => item.OBJECTID === row.OBJECTID && item.AttachmentsList
    );

    return (
      <div className="attachments-container">
        {filteredAttachments.length > 0 ? (
          filteredAttachments.flatMap((item) =>
            item.AttachmentsList.map((attachment) => {
              const { id, name, contentType } = attachment;
              const fileName = name.length > 8 ? `${name.substring(0, 10)}...` : name;
              const attachmentUrl = `${layerInfo.Url}/${item.OBJECTID}/attachments/${id}`;
              return (
                <div key={id} className="attachment-item">
                  {contentType === "video/mp4" ? (
                    <video width="80" height="60" controls>
                      <source src={attachmentUrl} type="video/mp4" />
                    </video>
                  ) : (
                    <img src={attachmentUrl} alt={name} className="imageThumb" />
                  )}
                  <div className="attachment-info">
                    <span className="fileName" title={name} >
                      {fileName}
                    </span>
                    {/* <Button
                      variant="danger"
                      className="closepop-over"
                      size="sm"
                      onClick={() => handleDeleteAttachment(attachment.id, item.OBJECTID)}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/close.svg`}
                        alt={t("close")}
                      />
                    </Button> */}

                    <button
                      className="btn btn-outline closeSightSlider"
                      onClick={() => handleDeleteAttachment(attachment.id, item.OBJECTID)}
                      data-tooltip-content={t("delete")}
                      data-tooltip-id={`tooltip-delete`}
                      data-tooltip-place="bottom"
                    >
                      <MdOutlineDelete size={15} title="Delete" className="delete-17" />
                    </button>
                  </div>
                </div>
              );
            })
          )
        ) : (
          <p>{t("noattachavailble")}</p>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (showPopover) {
      const arrowElement = document.querySelector(".popover-arrow");
      const handleClickOnArrow = (event) => {
        handleClose();
      };
      if (arrowElement) {
        arrowElement.addEventListener("click", handleClickOnArrow);
      }
      return () => {
        if (arrowElement) {
          arrowElement.removeEventListener("click", handleClickOnArrow);
        }
      };
    }
  }, [showPopover]);

  useEffect(() => {
    if (modalVisible) {
      const arrowElement = document.querySelector(".popover-arrow");
      const handleClickOnArrow = (event) => {
        handleModalClose();
      };
      if (arrowElement) {
        arrowElement.addEventListener("click", handleClickOnArrow);
      }
      return () => {
        if (arrowElement) {
          arrowElement.removeEventListener("click", handleClickOnArrow);
        }
      };
    }
  }, [modalVisible]);

  const handleClose = () => {
    setShowPopover(false);
  };
  const formatToDatetimeLocal = (dateString) => {
    if (!dateString) return "";
    if (dateString.includes("T") === true) {
      const DateVal = dateString.split("T");
      const [year, month, day] = DateVal[0].split("-");
      return `${year}-${month}-${day}T${DateVal[1]}`;
    } else {
      const [day, month, yearAndTime] = dateString.split("-");
      const [year, time] = yearAndTime.split(" ");
      return `${year}-${month}-${day}T${time.slice(0, 5)}`;
    }
  };
  const GetFamilyDropdown = (value) => {
    const matchingOrder = SpeciesOrder?.find((order) => order.key === value || order.value === value);
    setDropdownFamilyValues([]);
    setDropdownSpeciesValues([]);
    if (matchingOrder) {
      setInsectsData((prevState) => ({
        ...prevState,
        insectOrder: { value: matchingOrder.key, label: matchingOrder.value }, // Correct format for react-select
        family: '',
        speciesName: '',
      }));
      const newFamilyNames = OrderFamilyNames.filter(
        (item) => item.SpeciesOrder === matchingOrder.value
      )
        .map((item) => item.FamilyNames)
        .flat(); // Flatten the array if multiple family names per order
      setDropdownFamilyValues(newFamilyNames);
    }
  };
  const GetSpeciesDropdown = (value) => {
    const matchingFamily = FamilyName?.find((family) => family.value === value);
    setDropdownSpeciesValues([]);
    if (matchingFamily) {
      setInsectsData((prevState) => ({
        ...prevState,
        family: { value: matchingFamily.key, label: matchingFamily.value }, // Correct format for react-select
        speciesName: '',
      }));
      const newSpeciesNames = FamilySpeciesNames.filter(
        (item) => item.FamilyName === matchingFamily.value
      )
        .map((item) => item.SpeciesNames)
        .flat(); // Flatten the array if multiple family names per order
      setDropdownSpeciesValues(newSpeciesNames);
    }

  };

  const GetMammalsSpeciesDropdown = (value) => {

    const matchingSpecies = MammalsDomainValues[0].Species?.find(
      (species) => species.key === value || species.value.trim() === value.trim()
    );
    if (matchingSpecies) {
      setMammalsDataObj((prevState) => ({
        ...prevState,
        mammalsSpecies: {
          value: matchingSpecies.key,
          label: matchingSpecies.value,
        },
      }));
      const newSpeciesNames = MammalsSpeciesNames.filter(
        (item) => item.Species === matchingSpecies.value
      )
        .map((item) => item.SpeciesNames)
        .flat(); // Flatten the array if multiple family names per order
      setDropdownMammalsSpeciesNames(newSpeciesNames);
    }
  };
  const GetReptilesSpeciesDropdown = (value) => {
    const matchingReptile = ReptilesDomainValues[0].Reptiles?.find(
      (species) => species.key === value || species.value === value
    );
    if (matchingReptile) {
      setReptilesDataObj((prevState) => ({
        ...prevState,
        reptiles: { value: matchingReptile.key, label: matchingReptile.value },
      }));
      const newSpeciesNames = ReptilesSpeciesNames.filter(
        (item) => item.Reptile === matchingReptile.value
      )
        .map((item) => item.Species)
        .flat(); // Flatten the array if multiple family names per order
      setDropdownReptileSpecies(newSpeciesNames);
    }
  };
  const handleIndputDropdownChange = (e, name) => {
    const tabConfig = {
      [t("Plants")]: {
        setSelectedRows: setPlantsDataObj
      },
      [t("Invertebrates")]: {
        setSelectedRows: setInsectsData
      },
      [t("Mammals")]: {
        setSelectedRows: setMammalsDataObj
      },
      [t("Reptiles")]: {
        setSelectedRows: setReptilesDataObj
      },
    };
    if (activePendingtabs) {
      const { setSelectedRows } = tabConfig[activePendingtabs];

      let value;
      if (e && e.target) {
        value = e.target.value; // For regular input fields
      } else if (e && "value" in e) {
        //value = e.value; // For react-select (e.value contains the selected value)
        value = e.value === 0 ? e.value.toString() : e.value;
      }

      if (name === "surveyDate" || name === "plantssurveyDate" || name === "mammalsSurveyDate" || name === "observationDate") {
        const selectedDate = value;
        const today = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().slice(0, 5);
        if (selectedDate > today) {
          showAlert(t("Future dates are not allowed."), "error");
          setSelectedRows((prevData) => ({
            ...prevData,
            [name]: ""
          }));
        } else {
          setSelectedRows((prevState) => ({
            ...prevState,
            [name]: value, // Update the correct field using the name
          }));
        }
      }
      else {
        setSelectedRows((prevState) => ({
          ...prevState,
          [name]: value, // Update the correct field using the name
        }));
      }
    }
  };
  const AddInsectsFeatures = () => {
    try {
      setLoading(true);
      const DisplayAttributes = window.InvertiblesInfo.DisplayAttributes.filter(
        (item) => item.Edit === true
      ).map((item) => item.AttrName);
      const layer = new FeatureLayer({ url: window.InvertiblesInfo.Url });
      const Feature_Add = [];
      let surveydatevalue = null;
      let insectoderkeyval = null;
      let LatValue = null;
      let LongValue = null;
      const validationRules = {
        SpeciesName: { value: InsectsData.speciesName },
        Family: { value: InsectsData.family },
        PhotoNumber: { value: InsectsData.photoNo },
        SpecimenNo: { value: InsectsData.specimenNo },
        SpecimenTaken: { value: InsectsData.specimenTaken },
        TrappingMethod: { value: InsectsData.trappingMethod },
        Habitat: { value: InsectsData.habitat },
        HabitatStatus: { value: InsectsData.habitatStatus },
        Location: { value: InsectsData.location },
        Recordedby: { value: InsectsData.recordedBy },
        ObservedNumber: { value: InsectsData.observedNumber },
        InsectOrder: { value: InsectsData.insectOrder },
        SurveyDate: { value: InsectsData.surveyDate },
        POINT_Y: { value: InsectsData.insectslatitude },
        POINT_X: { value: InsectsData.insectslongitude },
        Notes: { value: InsectsData.insectsnotes },
      };
      const hasValidationError = DisplayAttributes.some((AttrName) => {
        if (["Notes", "SpecimenNo", "PhotoNumber"].includes(AttrName)) {
          return false;
        }

        const rule = validationRules[AttrName];
        if (!rule || !rule.value || rule.value.toString().trim() === "") {
          //showAlert(t(AttrName), "error");
          showAlert(t("pleaseEnterfields", { attrName: AttrName }), "error");
          setLoading(false);
          return true; // Stop iteration on error
        }
        return false; // No error, continue iteration
      });

      if (hasValidationError) return; // Stop execution if validation fails

      if (selectedFormat === "DD") {
        LatValue = InsectsData.insectslatitude;
        LongValue = InsectsData.insectslongitude;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          //InsectsData.insectslatitude = "";
          //InsectsData.insectslongitude = "";
          setInsectsData((prevState) => ({
            ...prevState,
            insectslongitude: "",
            insectslatitude: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }
      } else {
        LatValue =
          parseInt(InsectsData.insectslatDegrees, 10) +
          parseInt(InsectsData.insectslatMinutes, 10) / 60 +
          parseInt(InsectsData.insectslatSeconds, 10) / 3600;
        LongValue =
          parseInt(InsectsData.insectslongDegrees, 10) +
          parseInt(InsectsData.insectslongMinutes, 10) / 60 +
          parseInt(InsectsData.insectslongSeconds, 10) / 3600;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          // InsectsData.insectslatDegrees = "";
          // InsectsData.insectslatMinutes = "";
          // InsectsData.insectslatSeconds = "";
          // InsectsData.insectslongDegrees = "";
          // InsectsData.insectslongMinutes = "";
          // InsectsData.insectslongSeconds = "";
          setInsectsData((prevState) => ({
            ...prevState,
            insectslatDegrees: "",
            insectslatMinutes: "",
            insectslatSeconds: "",
            insectslongDegrees: "",
            insectslongMinutes: "",
            insectslongSeconds: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }
      }

      if (InsectsData.insectsnotes.length > 500) {
        showAlert(t("noteslength"), "error");
        return; // Stop execution if notes are invalid
      }

      if (InsectsData.surveyDate !== undefined && InsectsData.surveyDate !== "") {
        const dateString = reformatDate(InsectsData.surveyDate);
        const dateTimeParts = dateString.split(" ");
        const timeParts = dateTimeParts[1].split(":");
        const dateParts = dateTimeParts[0].split("-");
        let date;
        date = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2]);
        date.setHours(date.getHours() + 4);
        surveydatevalue = date.getTime();
      }
      const pointGeom = new Point({
        longitude: LongValue,
        latitude: LatValue,
      });
      const attrs = {
        Location: InsectsData.location,
        Habitat: InsectsData.habitat,
        HabitatStatus: InsectsData.habitatStatus,
        SurveyDate: surveydatevalue,
        Recordedby: InsectsData.recordedBy,
        Notes: InsectsData.insectsnotes,
        ObservedNumber: parseInt(InsectsData.observedNumber),
        //"Family": InsectsData.family,
        Family: InsectsData.family.value,
        SpecimenTaken: InsectsData.specimenTaken,
        TrappingMethod: InsectsData.trappingMethod,
        // "InsectOrder": insectoderkeyval,
        InsectOrder: parseInt(InsectsData.insectOrder.value),
        SpeciesName: InsectsData.speciesName,
        created_date: new Date(),
        PhotoNumber: InsectsData.photoNo,
        SpecimenNo: InsectsData.specimenNo,
        POINT_X: LongValue,
        POINT_Y: LatValue,
        Status: "Draft",
        DataSource: 2,
      };
      const graphic_draft = new Graphic({
        geometry: pointGeom,
        attributes: attrs,
      });
      Feature_Add.push(graphic_draft);
      handleAddRecordApplyEdits(layer, { addFeatures: [graphic_draft] });
    } catch (error) {
      setLoading(false);
      showAlert(t("erroraddfeature"), "error");
    }
  };

  const AddPlantsFeatures = () => {
    try {
      setLoading(true);
      const DisplayAttributes = window.PlantInfo.DisplayAttributes.filter(
        (item) => item.Edit === true
      ).map((item) => item.AttrName);

      const layer = new FeatureLayer({
        url: window.PlantInfo.Url,
      });
      const Feature_Add = [];
      let surveydatevalue = null;
      let LatValue = null;
      let LongValue = null;

      const validationRules = {
        PlantSpecies: {
          value: PlantsDataObj.plantSpecies,
        },
        Phenology: {
          value: PlantsDataObj.phenology,
        },
        GeneralLocation: {
          value: PlantsDataObj.generalLocation,
        },
        Habitat: {
          value: PlantsDataObj.plantshabitat,
        },
        GrazingSigns: {
          value: PlantsDataObj.grazingSign,
        },
        Precipitation: {
          value: PlantsDataObj.precipitation,
        },
        PercentageCover: {
          value: PlantsDataObj.percentageCover,
        },
        SpecimenCollected: {
          value: PlantsDataObj.specimenCollected,
        },
        SurveyDate: {
          value: PlantsDataObj.plantssurveyDate,
        },
        Point_Y: {
          value: PlantsDataObj.plantslatitude,
        },
        Point_X: {
          value: PlantsDataObj.plantslongitude,
        },
        Notes: {
          value: PlantsDataObj.plantsNotes,
        },
      };

      const hasValidationError = DisplayAttributes.some((AttrName) => {
        if (["Notes"].includes(AttrName)) {
          return false;
        }

        const rule = validationRules[AttrName];
        if (!rule || !rule.value || rule.value.toString().trim() === "") {
          //showAlert(t(AttrName), "error");
          showAlert(t("pleaseEnterfields", { attrName: AttrName }), "error");
          setLoading(false);
          return true; // Stop iteration on error
        }

        return false; // No error, continue iteration
      });
      if (hasValidationError) return; // Stop execution if validation fails

      if (selectedFormat === "DD") {
        LatValue = PlantsDataObj.plantslatitude;
        LongValue = PlantsDataObj.plantslongitude;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          //PlantsDataObj.plantslatitude = "";          
          //InsectsData.plantslongitude = "";
          setPlantsDataObj((prevState) => ({
            ...prevState,
            plantslatitude: "",
            plantslongitude: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }

      } else {
        const LatLongValue =
          `${PlantsDataObj.plantslatDegrees}°${PlantsDataObj.plantslatMinutes}'${PlantsDataObj.plantslatSeconds}" N / ` +
          `${PlantsDataObj.plantslongDegrees}°${PlantsDataObj.plantslongMinutes}'${PlantsDataObj.plantslongSeconds}" E`;

        LatValue =
          parseInt(PlantsDataObj.plantslatDegrees, 10) +
          parseInt(PlantsDataObj.plantslatMinutes, 10) / 60 +
          parseInt(PlantsDataObj.plantslatSeconds, 10) / 3600;
        LongValue =
          parseInt(PlantsDataObj.plantslongDegrees, 10) +
          parseInt(PlantsDataObj.plantslongMinutes, 10) / 60 +
          parseInt(PlantsDataObj.plantslongSeconds, 10) / 3600;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          // PlantsDataObj.plantslatDegrees = "";
          // PlantsDataObj.plantslatMinutes = "";
          // PlantsDataObj.plantslatSeconds = "";
          // PlantsDataObj.plantslongDegrees = "";
          // PlantsDataObj.plantslongMinutes = "";
          // PlantsDataObj.plantslongSeconds = "";
          setPlantsDataObj((prevState) => ({
            ...prevState,
            plantslatDegrees: "",
            plantslatMinutes: "",
            plantslatSeconds: "",
            plantslongDegrees: "",
            plantslongMinutes: "",
            plantslongSeconds: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }
      }

      if (PlantsDataObj.plantsNotes.length > 500) {
        showAlert(t("noteslength"), "error");
        return false;
      }
      if (
        PlantsDataObj.plantssurveyDate !== undefined &&
        PlantsDataObj.plantssurveyDate !== ""
      ) {
        const dateString = reformatDate(PlantsDataObj.plantssurveyDate);
        const dateTimeParts = dateString.split(" ");
        const timeParts = dateTimeParts[1].split(":");
        const dateParts = dateTimeParts[0].split("-");
        let date;
        date = new Date(dateParts[2], parseInt(dateParts[1], 10) - 1, dateParts[0], timeParts[0], timeParts[1], timeParts[2]);
        date.setHours(date.getHours() + 4);
        surveydatevalue = date.getTime();
      }
      const pointGeom = new Point({
        longitude: LongValue, //PlantsDataObj.plantslongitude,
        latitude: LatValue, //PlantsDataObj.plantslatitude,
      });
      const attr = {
        PlantSpecies: PlantsDataObj.plantSpecies,
        Phenology: PlantsDataObj.phenology,
        GeneralLocation: PlantsDataObj.generalLocation,
        Habitat: PlantsDataObj.plantshabitat,
        GrazingSigns: PlantsDataObj.grazingSign,
        Precipitation: PlantsDataObj.precipitation,
        PercentageCover: PlantsDataObj.percentageCover,
        Notes: PlantsDataObj.plantsNotes,
        SurveyDate: surveydatevalue,
        SpecimenCollected: PlantsDataObj.specimenCollected,
        Point_X: LongValue, //PlantsDataObj.plantslongitude
        Point_Y: LatValue, //PlantsDataObj.plantslatitude,
        created_date: new Date(),
        Status: "Draft",
        DataSource: 2,
      };
      const graphic_draft = new Graphic({
        geometry: pointGeom,
        attributes: attr,
      });
      Feature_Add.push(graphic_draft);
      handleAddRecordApplyEdits(layer, { addFeatures: [graphic_draft] });
    } catch (error) {
      setLoading(false);
      showAlert(t("erroraddfeature"), "error");
    }
  };

  const AddMammalsFeatures = () => {
    try {
      setLoading(true);
      const Url = window.MammalsInfo.Url;
      const DisplayAttributes = window.MammalsInfo.DisplayAttributes.filter(
        (item) => item.Edit === true
      ).map((item) => item.AttrName);
      const layer = new FeatureLayer({
        url: window.MammalsInfo.Url,
      });
      const Feature_Add = [];
      let surveydatevalue = null;
      let mammalSpecieskeyValue = null;
      let LatValue = null;
      let LongValue = null;

      const validationRules = {
        Species: {
          value: MammalsDataObj.mammalsSpecies,
        },
        SpeciesName: {
          value: MammalsDataObj.mammalsSpeciesName,
        },
        SpeciesNumber: {
          value: MammalsDataObj.mammalsSpeciesNumber,
        },
        Habitat: {
          value: MammalsDataObj.mammalsHabitat,
        },
        SightingType: {
          value: MammalsDataObj.mammalsSightingType,
        },
        Location: {
          value: MammalsDataObj.mammalsLocation,
        },
        Collector: {
          value: MammalsDataObj.mammalsCollector,
        },
        SurveyDate: {
          value: MammalsDataObj.mammalsSurveyDate,
        },
        Point_Y: {
          value: MammalsDataObj.mammalsLatitude,
        },
        Point_X: {
          value: MammalsDataObj.mammalsLongitude,
        },
        Notes: {
          value: MammalsDataObj.mammalsNotes,
        },
      };

      const hasValidationError = DisplayAttributes.some((AttrName) => {
        if (["Notes"].includes(AttrName)) {
          return false;
        }

        const rule = validationRules[AttrName];
        if (!rule || !rule.value || rule.value.toString().trim() === "") {
          //showAlert(t(AttrName), "error");
          showAlert(t("pleaseEnterfields", { attrName: AttrName }), "error");
          setLoading(false);
          return true; // Stop iteration on error
        }

        return false; // No error, continue iteration
      });
      if (hasValidationError) return; // Stop execution if validation fails

      if (selectedFormat === "DD") {
        LatValue = MammalsDataObj.mammalsLatitude;
        LongValue = MammalsDataObj.mammalsLongitude;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          //MammalsDataObj.mammalsLatitude = "";
          //MammalsDataObj.mammalsLongitude = "";
          setMammalsDataObj((prevState) => ({
            ...prevState,
            mammalsLatitude: "",
            mammalsLongitude: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }
      } else {
        const LatLongValue =
          `${MammalsDataObj.mammalslatDegrees}°${MammalsDataObj.mammalslatMinutes}'${MammalsDataObj.mammalslatSeconds}" N / ` +
          `${MammalsDataObj.mammalslongDegrees}°${MammalsDataObj.mammalslongMinutes}'${MammalsDataObj.mammalslongSeconds}" E`;

        LatValue =
          parseInt(MammalsDataObj.mammalslatDegrees, 10) +
          parseInt(MammalsDataObj.mammalslatMinutes, 10) / 60 +
          parseInt(MammalsDataObj.mammalslatSeconds, 10) / 3600;
        LongValue =
          parseInt(MammalsDataObj.mammalslongDegrees, 10) +
          parseInt(MammalsDataObj.mammalslongMinutes, 10) / 60 +
          parseInt(MammalsDataObj.mammalslongSeconds, 10) / 3600;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          // MammalsDataObj.mammalslatDegrees = "";
          // MammalsDataObj.mammalslatMinutes = "";
          // MammalsDataObj.mammalslatSeconds = "";
          // MammalsDataObj.mammalslongDegrees = "";
          // MammalsDataObj.mammalslongMinutes = "";
          // MammalsDataObj.mammalslongSeconds = "";
          setMammalsDataObj((prevState) => ({
            ...prevState,
            mammalslatDegrees: "",
            mammalslatMinutes: "",
            mammalslatSeconds: "",
            mammalslongDegrees: "",
            mammalslongMinutes: "",
            mammalslongSeconds: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }
      }

      if (MammalsDataObj.mammalsNotes.length > 500) {
        showAlert(t("noteslength"), "error");
        return false;
      }
      if (
        MammalsDataObj.mammalsSurveyDate !== undefined &&
        MammalsDataObj.mammalsSurveyDate !== ""
      ) {
        const dateString = reformatDate(MammalsDataObj.mammalsSurveyDate);
        const dateTimeParts = dateString.split(" ");
        const timeParts = dateTimeParts[1].split(":");
        const dateParts = dateTimeParts[0].split("-");
        let date;
        date = new Date(
          dateParts[2],
          parseInt(dateParts[1], 10) - 1,
          dateParts[0],
          timeParts[0],
          timeParts[1],
          timeParts[2]
        );
        date.setHours(date.getHours() + 4);
        surveydatevalue = date.getTime();
      }
      const pointGeom = new Point({
        longitude: LongValue, //MammalsDataObj.mammalsLongitude,
        latitude: LatValue, //MammalsDataObj.mammalsLatitude,
      });
      const attr = {
        SpeciesName: MammalsDataObj.mammalsSpeciesName,
        SpeciesNumber: MammalsDataObj.mammalsSpeciesNumber,
        SightingType: MammalsDataObj.mammalsSightingType,
        Habitat: MammalsDataObj.mammalsHabitat,
        Location: MammalsDataObj.mammalsLocation,
        Collector: MammalsDataObj.mammalsCollector,
        //"Species": mammalSpecieskeyValue,
        Species: parseInt(MammalsDataObj.mammalsSpecies.value),
        Notes: MammalsDataObj.mammalsNotes,
        SurveyDate: surveydatevalue,
        Point_X: LongValue, //MammalsDataObj.mammalsLongitude,
        Point_Y: LatValue, // MammalsDataObj.mammalsLatitude,
        created_date: new Date(),
        Status: "Draft",
        DataSource: 2,
      };
      const graphic_draft = new Graphic({
        geometry: pointGeom,
        attributes: attr,
      });
      Feature_Add.push(graphic_draft);
      handleAddRecordApplyEdits(layer, { addFeatures: [graphic_draft] });
    } catch (error) {
      setLoading(false);
      showAlert(t("erroraddfeature"), "error");
    }
  };

  const AddReptileFeatures = () => {
    try {
      setLoading(true);
      const Url = window.ReptilesInfo.Url;
      const DisplayAttributes = window.ReptilesInfo.DisplayAttributes.filter(
        (item) => item.Edit === true
      ).map((item) => item.AttrName);
      const layer = new FeatureLayer({
        url: window.ReptilesInfo.Url,
      });
      const Feature_Add = [];
      let surveydatevalue = null;
      let ReptilekeyValue = null;
      let LatValue = null;
      let LongValue = null;

      const validationRules = {
        Reptiles: {
          value: ReptilesDataObj.reptiles,
        },
        Species: {
          value: ReptilesDataObj.reptileSpecies,
        },
        NumberObserved: {
          value: ReptilesDataObj.observationNumber,
        },
        SightingType: {
          value: ReptilesDataObj.reptileSightingType,
        },
        Habitat: {
          value: ReptilesDataObj.reptileHabitat,
        },
        MicroHabitat: {
          value: ReptilesDataObj.microHabitat,
        },
        LocationName: {
          value: ReptilesDataObj.reptileLocation,
        },
        Collector: {
          value: ReptilesDataObj.reptileCollector,
        },
        ObservationDate: {
          value: ReptilesDataObj.observationDate,
        },
        Point_Y: {
          value: ReptilesDataObj.reptileLatitude,
        },
        Point_X: {
          value: ReptilesDataObj.reptileLongitude,
        },
        Notes: {
          value: ReptilesDataObj.reptileNotes,
        },
      };

      const hasValidationError = DisplayAttributes.some((AttrName) => {
        // Skip validation for specific attributes
        if (["Notes"].includes(AttrName)) {
          return false;
        }

        const rule = validationRules[AttrName];
        if (!rule || !rule.value || rule.value.toString().trim() === "") {
          //showAlert(t(AttrName), "error");
          showAlert(t("pleaseEnterfields", { attrName: AttrName }), "error");
          setLoading(false);
          return true; // Stop iteration on error
        }

        return false; // No error, continue iteration
      });

      if (hasValidationError) return; // Stop execution if validation fails

      if (selectedFormat === "DD") {
        LatValue = ReptilesDataObj.reptileLatitude;
        LongValue = ReptilesDataObj.reptileLongitude;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          // ReptilesDataObj.reptileLatitude = "";
          // ReptilesDataObj.reptileLongitude = "";
          setReptilesDataObj((prevState) => ({
            ...prevState,
            reptileLatitude: "",
            reptileLongitude: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }
      } else {
        LatValue =
          parseInt(ReptilesDataObj.reptilelatDegrees, 10) +
          parseInt(ReptilesDataObj.reptilelatMinutes, 10) / 60 +
          parseInt(ReptilesDataObj.reptilelatSeconds, 10) / 3600;
        LongValue =
          parseInt(ReptilesDataObj.reptilelongDegrees, 10) +
          parseInt(ReptilesDataObj.reptilelongMinutes, 10) / 60 +
          parseInt(ReptilesDataObj.reptilelongSeconds, 10) / 3600;

        if (!((LongValue > 51.303 && LongValue < 56.664) && (LatValue > 22.455 && LatValue < 26.326))) {
          // ReptilesDataObj.reptilelatDegrees = "";
          // ReptilesDataObj.reptilelatMinutes = "";
          // ReptilesDataObj.reptilelatSeconds = "";
          // ReptilesDataObj.reptilelongDegrees = "";
          // ReptilesDataObj.reptilelongMinutes = "";
          // ReptilesDataObj.reptilelongSeconds = "";
          setReptilesDataObj((prevState) => ({
            ...prevState,
            reptilelatDegrees: "",
            reptilelatMinutes: "",
            reptilelatSeconds: "",
            reptilelongDegrees: "",
            reptilelongMinutes: "",
            reptilelongSeconds: "",
          }));
          showAlert(t("mapPoint"), "error");
          setLoading(false);
          return; // Stop iteration on error
        }
      }

      if (ReptilesDataObj.reptileNotes.length > 500) {
        showAlert(t("noteslength"), "error");
        return false;
      }
      if (
        ReptilesDataObj.observationDate !== undefined &&
        ReptilesDataObj.observationDate !== ""
      ) {
        const dateString = reformatDate(ReptilesDataObj.observationDate);
        const dateTimeParts = dateString.split(" ");
        const timeParts = dateTimeParts[1].split(":");
        const dateParts = dateTimeParts[0].split("-");
        let date;
        date = new Date(
          dateParts[2],
          parseInt(dateParts[1], 10) - 1,
          dateParts[0],
          timeParts[0],
          timeParts[1],
          timeParts[2]
        );
        date.setHours(date.getHours() + 4);
        surveydatevalue = date.getTime();
      }
      const pointGeom = new Point({
        longitude: LongValue, //ReptilesDataObj.reptileLongitude,
        latitude: LatValue, // ReptilesDataObj.reptileLatitude,
      });
      const attr = {
        //"Reptiles": ReptilekeyValue,
        Reptiles: parseInt(ReptilesDataObj.reptiles.value),
        Species: ReptilesDataObj.reptileSpecies,
        NumberObserved: ReptilesDataObj.observationNumber,
        SightingType: ReptilesDataObj.reptileSightingType,
        MicroHabitat: ReptilesDataObj.microHabitat,
        Habitat: ReptilesDataObj.reptileHabitat,
        LocationName: ReptilesDataObj.reptileLocation,
        Collector: ReptilesDataObj.reptileCollector,
        Notes: ReptilesDataObj.reptileNotes,
        ObservationDate: surveydatevalue,
        Point_X: LongValue, //ReptilesDataObj.reptileLongitude,
        Point_Y: LatValue, // ReptilesDataObj.reptileLatitude,
        created_date: new Date(),
        Status: "Draft",
        DataSource: 2,
      };
      const graphic_draft = new Graphic({
        geometry: pointGeom,
        attributes: attr,
      });
      Feature_Add.push(graphic_draft);
      handleAddRecordApplyEdits(layer, { addFeatures: [graphic_draft] });
    } catch (error) {
      setLoading(false);
      showAlert(t("erroraddfeature"), "error");
    }
  };

  const handleFileChange = (files) => {
    if (files) {
      const validFiles = Array.from(files).filter((file) => {
        const isValidType =
          ["image/jpeg", "image/png", "application/pdf", "video/mp4"].includes(
            file.type
          );
        const isValidSize = file.size <= 5 * 1024 * 1024; // 5MB
        return isValidType && isValidSize;
      });

      if (validFiles.length !== files.length) {
        showAlert(t("fileexceeds", { maxSize: '5' }), "error");
        //alert("Some files were invalid (unsupported format or size > 5MB).");
      }

      setSelectedFiles((prev) => [...prev, ...validFiles]);
    }
  };

  const handleRemoveFile = (fileName) => {
    setSelectedFiles((prev) => prev.filter((file) => file.name !== fileName));
  };
  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleFileChange(event.dataTransfer.files);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };



  const AddGraphicToMap = async (featureGraphics) => {
    if (!isUnmounted.current) {
      if (!featureGraphics || featureGraphics.length === 0) return;
      if (divSpatialEdit.current) {
        const spatialEditElement = document.getElementById("divSpatialEdit");
        mapview.ui.remove(divSpatialEdit.current);
        if (spatialEditElement) mapview.ui.remove(spatialEditElement);
        mapview.ui.add(divSpatialEdit.current, "top-left");
      }
      mapview.graphics.removeAll();
      let targetGeometry = null;
      let zoomLevel = 8; // Default zoom level for multiple graphics

      if (featureGraphics.length === 1) {
        targetGeometry = featureGraphics[0].geometry;
        zoomLevel = 15; // Zoom closer for a single feature
      } else {
        const geometries = featureGraphics.map((feature) => feature.geometry);
        const unionGeometry = geometryEngine.union(geometries);
        if (unionGeometry) {
          targetGeometry = unionGeometry.extent.center;
        }
      }

      // Zoom to the target geometry
      if (targetGeometry) {
        await mapview
          .goTo({ target: targetGeometry, zoom: zoomLevel })
          .catch((error) =>
            showAlert("Error during map zoom", "error")
          );
      }

      // Add graphics to the map
      featureGraphics.forEach((feature) => {
        const graphic = new Graphic({
          geometry: feature.geometry,
          symbol: SelectionSymbol,
          attributes: feature.attributes,
        });
        mapview.graphics.add(graphic);
      });
    }
  };
  const ViewFeatureonMap = () => {
    const selectedFeatures = [];
    if (activePendingtabs) {
      const { currentRows, selectedRows, data } = tabMapping[activePendingtabs];
      if (selectedRows.length > 0) {
        if (fullView === "fullView") {
          divSpatialEdit.current.style.display = "none";
          showAlert(t('viewfeatures'), "error");
          if (isMobileView) {
            onClose();
          }
        }
        else {
          divSpatialEdit.current.style.display = "flex";
          const processSelectedFeatures = (currentRows, selectedRows, data) => {
            currentRows.current.forEach((item) => {
              if (selectedRows.includes(item.id)) {
                const objid = item.OBJECTID;
                const feature = data.find((feature) => feature.attributes["OBJECTID"] === objid);
                if (feature) {
                  selectedFeatures.push(feature);
                }
              }
            });
          };
          processSelectedFeatures(currentRows, selectedRows, data);
          AddGraphicToMap(selectedFeatures);
          setIsToggled(false);
        }
      }
      else {
        showAlert(t('viewfeatures'), "error");
      }
    }
  };
  const highlightFeatureOnMap = async (layerType, defaultImage, imageWithAttachment, graphicLayer, layerInfo) => {
    const layer = new FeatureLayer({ url: layerInfo.Url });
    const queryparams = new Query({
      where: "Status = 'Draft'",
      outFields: ["*"],
      returnGeometry: true,
    });
    const requestOptions = {
      query: {
        token: token,
      },
    };
    let featureSet;
    featureSet = await query.executeQueryJSON(layerInfo.Url, queryparams, requestOptions);
    //featureSet = await query.executeQueryJSON(layerInfo.Url, queryparams);
    setGlobalData(prevData =>
      prevData.map(module =>
        module.moduleName === "Animal Sighting"
          ? {
            ...module,
            subTabs: module.subTabs.map(subTab =>
              subTab.name === "PendingRecords"
                ? {
                  ...subTab,
                  data: {
                    ...subTab.data,
                    featureSets: {
                      ...subTab.data.featureSets,
                      [layerType]: featureSet // Storing feature set based on layerType
                    },
                  }
                }
                : subTab
            )
          }
          : module
      )
    );

    if (!featureSet.features.length) return;

    const objectIds = featureSet.features.map(f => f.attributes.OBJECTID);
    let attachmentInfos;
    attachmentInfos = await layer.queryAttachments({ objectIds });
    setGlobalData(prevData =>
      prevData.map(module =>
        module.moduleName === "Animal Sighting"
          ? {
            ...module,
            subTabs: module.subTabs.map(subTab =>
              subTab.name === "PendingRecords"
                ? {
                  ...subTab,
                  data: {
                    ...subTab.data,
                    attachmentInfos: {
                      ...subTab.data.attachmentInfos,
                      [layerType]: attachmentInfos // Storing attachments based on layerType
                    }
                  }
                }
                : subTab
            )
          }
          : module
      )
    );
    const graphics = featureSet.features.map((feature) => {
      const { geometry, attributes } = feature;
      const objID = attributes.OBJECTID;

      let symbolUrl = `${process.env.PUBLIC_URL}/images/AnimalSighting/${defaultImage}`;
      let infoContent = "<div>";

      Object.entries(attributes).forEach(([key, value]) => {
        infoContent += `<b>${key}</b>: ${value}<br>`;
      });

      if (attachmentInfos[objID] && attachmentInfos[objID].length > 0) {
        symbolUrl = `${process.env.PUBLIC_URL}/images/AnimalSighting/${imageWithAttachment}`;
        infoContent += "<br>Attachments:<br>";
        attachmentInfos[objID].forEach((attachment) => {
          infoContent += `<a target='_blank' href="${attachment.url}">${attachment.name}</a><br>`;
        });
      }
      infoContent += "</div>";

      return new Graphic({
        geometry,
        symbol: new PictureMarkerSymbol({
          url: symbolUrl,
          height: 15,
          width: 15,
        }),
        attributes,
        popupTemplate: new PopupTemplate({
          title: `${layerType} Info`,
          content: infoContent,
        }),
      });
    });

    const getCoordinates = () => {
      if (activePendingtabs.includes(t("Invertebrates"))) {
        return {
          longitude: InsectsData.insectslongitude,
          latitude: InsectsData.insectslatitude,
        };
      } else if (activePendingtabs.includes(t("Reptiles"))) {
        return {
          longitude: ReptilesDataObj.reptileLongitude,
          latitude: ReptilesDataObj.reptileLatitude,
        };
      } else if (activePendingtabs.includes(t("Mammals"))) {
        return {
          longitude: MammalsDataObj.mammalsLongitude,
          latitude: MammalsDataObj.mammalsLatitude,
        };
      } else if (activePendingtabs.includes(t("Plants"))) {
        return {
          longitude: PlantsDataObj.plantslongitude,
          latitude: PlantsDataObj.plantslatitude,
        };
      }
      return null;
    };

    const coordinates = getCoordinates();
    if (!coordinates) {
      showAlert(t('data with missing or invalid coordinates'), "error");
      return;
    }

    const point = new Point({
      ...coordinates,
      spatialReference: { wkid: 4326 },
    });

    const symbol = new SimpleMarkerSymbol({
      style: "circle",
      size: 20,
      color: new Color([0, 230, 169, 0.65]),
      outline: new SimpleLineSymbol({
        style: "solid",
        color: new Color([0, 230, 169, 1]),
        width: 2,
      }),
    });

    const graphic = new Graphic({
      geometry: point,
      symbol: symbol,
    });
    mapview.graphics.removeAll();
    mapview.map.remove(graphicLayer);
    mapview.graphics.add(graphic);
    graphicLayer.removeAll();
    graphicLayer.addMany(graphics);
    mapview.map.add(graphicLayer);
    await mapview
      .goTo({
        target: point,
        zoom: 15,
      })
      .catch((error) => {
        showAlert("Error during view.goTo", "error")
      });
  };

  const highlightFeatureOnMap1 = async () => {
    const getCoordinates = () => {
      if (activePendingtabs.includes(t("Invertebrates"))) {
        return {
          longitude: InsectsData.insectslongitude,
          latitude: InsectsData.insectslatitude,
        };
      } else if (activePendingtabs.includes(t("Reptiles"))) {
        return {
          longitude: ReptilesDataObj.reptileLongitude,
          latitude: ReptilesDataObj.reptileLatitude,
        };
      } else if (activePendingtabs.includes(t("Mammals"))) {
        return {
          longitude: MammalsDataObj.mammalsLongitude,
          latitude: MammalsDataObj.mammalsLatitude,
        };
      } else if (activePendingtabs.includes(t("Plants"))) {
        return {
          longitude: PlantsDataObj.plantslongitude,
          latitude: PlantsDataObj.plantslatitude,
        };
      }
      return null;
    };

    const coordinates = getCoordinates();
    if (!coordinates) {
      showAlert(t('data with missing or invalid coordinates'), "error");
      return;
    }
    const point = new Point({
      ...coordinates,
      spatialReference: { wkid: 4326 },
    });

    const symbol = new SimpleMarkerSymbol({
      style: "circle",
      size: 20,
      color: new Color([0, 230, 169, 0.65]),
      outline: new SimpleLineSymbol({
        style: "solid",
        color: new Color([0, 230, 169, 1]),
        width: 2,
      }),
    });

    const graphic = new Graphic({
      geometry: point,
      symbol: symbol,
    });
    mapview.graphics.removeAll();
    mapview.graphics.add(graphic);
    await mapview
      .goTo({
        target: point,
        zoom: 15,
      })
      .catch((error) => {
        showAlert("Error during view.goTo", "error")
      });
  };

  const uploadAttachments = async (objectId, editupload) => {

    if (!objectId) {
      showAlert(t("invalidobjid"), "error");
      return;
    }
    setLoading(true);
    const uploadToAttachmentUrl = (url, files) => {
      const promises = files.map((file) => {
        const formData = new FormData();
        formData.append("attachment", file);
        formData.append("f", "json");
        formData.append("token", token);

        return fetch(url, {
          method: "POST",
          body: formData,
        });
      });

      return Promise.all(promises);
    };

    const fetchAttachments = async (url) => {
      const response = await fetch(url, { method: "GET", mode: "cors", credentials: "include" });
      if (!response.ok) throw new Error("Failed to fetch attachments");
      return response.json();
    };
    const processAttachments = async (url, objectId, editUploadFlag, currentRows, Attachments, contentType, setDraftAttachments) => {
      if (editUploadFlag) {
        const attachmentsArray = [];
        const draftArray = [];
        const options = { f: "json", responseType: "json", token: token, };
        //const options = { f: "json", responseType: "json" };
        const fetchPromises = currentRows.map(async (item) => {
          if (item.OBJECTID === objectId) {
            try {
              //const attachmentsUrl = `${contentType.Url}/${item.OBJECTID}/attachments`;
              const attachmentsUrl = `${contentType.Url}/${item.OBJECTID}/attachments?f=json`;
              const urlWithParams = new URL(attachmentsUrl);
              Object.keys(options).forEach((key) =>
                urlWithParams.searchParams.append(key, options[key])
              );
              const data = await fetchAttachments(urlWithParams);
              if (!attachmentsArray.some((entry) => entry.objectId === objectId)) {
                attachmentsArray.push(data);
                draftArray.push({
                  OBJECTID: objectId,
                  AttachmentsList: data.attachmentInfos,
                });
              }
            } catch (error) {
              showAlert(`Error fetching attachments for OBJECTID ${objectId}`, "error")
            }
          }
        });
        await Promise.all(fetchPromises);

        const content = draftArray[0];
        // const existingContent = contentType.DrafAttachments.find(
        //   (item) => item.OBJECTID === objectId
        // );
        // if (existingContent) {
        //   existingContent.AttachmentsList = content.AttachmentsList;
        // }

        const updatedDrafAttachments = [...contentType.DrafAttachments];
        const index = updatedDrafAttachments.findIndex(
          (item) => item.OBJECTID === objectId
        );

        if (index !== -1) {
          updatedDrafAttachments[index] = {
            ...updatedDrafAttachments[index],
            AttachmentsList: content.AttachmentsList,
          };
        } else {
          updatedDrafAttachments.push({
            OBJECTID: objectId,
            AttachmentsList: content.AttachmentsList,
          });
        }

        setDraftAttachments(updatedDrafAttachments); // Important state update


        if (content && content.AttachmentsList) {

          const rowData = { OBJECTID: objectId }
          //const updatedContent = renderAttachments(rowData, contentType.DrafAttachments, contentType);
          const updatedContent = renderAttachments(rowData, updatedDrafAttachments, contentType);
          const attachmentDetails = extractImageAttachments(updatedContent);
          const updatedAttachmentDetails = ImageAttachments(attachmentDetails, objectId);
          setAttachmentsContent(updatedAttachmentDetails);
          setSelectedFiles([]);
          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Reset the input
          }
          setLoading(false);
        }
        else {
          setLoading(false);
        }
      }
    };

    try {
      // let attachmentUrl;
      // let contentType;
      // if (activePendingtabs.includes(t("Plants"))) {
      //   attachmentUrl = `${window.PlantInfo.Url}/${objectId}/addAttachment`;
      //   contentType = { Url: window.PlantInfo.Url, DrafAttachments: PlantsDrafAttachments };
      // }
      // else if (activePendingtabs.includes(t("Invertebrates"))) {
      //   attachmentUrl = `${window.InvertiblesInfo.Url}/${objectId}/addAttachment`;
      //   contentType = { Url: window.InvertiblesInfo.Url, DrafAttachments: InsectsDrafAttachments };
      // }
      // else if (activePendingtabs.includes(t("Mammals"))) {
      //   attachmentUrl = `${window.MammalsInfo.Url}/${objectId}/addAttachment`;
      //   contentType = { Url: window.MammalsInfo.Url, DrafAttachments: MammalsDrafAttachments };
      // }
      // else if (activePendingtabs.includes(t("Reptiles"))) {
      //   attachmentUrl = `${window.ReptilesInfo.Url}/${objectId}/addAttachment`;
      //   contentType = { Url: window.ReptilesInfo.Url, DrafAttachments: ReptilesDrafAttachments };
      // }
      // else {
      //   throw new Error("Invalid tab selected");
      // }


      const AttachmenttabConfig = {
        [t("Plants")]: {
          attachmentUrl: `${window.PlantInfo.Url}/${objectId}/addAttachment`,
          contentType: { Url: window.PlantInfo.Url, DrafAttachments: PlantsDrafAttachments },
          currentRows: PlantscurrentRows.current,
          setDraftAttachments: setPlantsDraftAttachments
        },
        [t("Invertebrates")]: {
          attachmentUrl: `${window.InvertiblesInfo.Url}/${objectId}/addAttachment`,
          contentType: { Url: window.InvertiblesInfo.Url, DrafAttachments: InsectsDrafAttachments },
          currentRows: InvertebratescurrentRows.current,
          setDraftAttachments: setInsectsDraftAttachments
        },
        [t("Mammals")]: {
          attachmentUrl: `${window.MammalsInfo.Url}/${objectId}/addAttachment`,
          contentType: { Url: window.MammalsInfo.Url, DrafAttachments: MammalsDrafAttachments },
          currentRows: MammalscurrentRows.current,
          setDraftAttachments: setMammalsDraftAttachments
        },
        [t("Reptiles")]: {
          attachmentUrl: `${window.ReptilesInfo.Url}/${objectId}/addAttachment`,
          contentType: { Url: window.ReptilesInfo.Url, DrafAttachments: ReptilesDrafAttachments },
          currentRows: ReptilescurrentRows.current,
          setDraftAttachments: setReptilesDraftAttachments
        },
      };


      if (selectedFiles.length > 0) {
        const { attachmentUrl, contentType, currentRows, setDraftAttachments } = AttachmenttabConfig[activePendingtabs];
        const results = await uploadToAttachmentUrl(attachmentUrl, Array.from(selectedFiles));

        const responses = await Promise.all(
          results.map(async (res) => {
            if (!res.ok) {
              const errorData = await res.json();
              throw new Error(`Error: ${errorData.message || "Unknown error"}`);
            }
            return res.json();
          })
        );
        await processAttachments(attachmentUrl, objectId, editupload, currentRows, contentType.DrafAttachments, contentType, setDraftAttachments);
      }
      else {
        //showAlert(t('invalidFileExtensionMessage'), "error");
        setLoading(false);
      }
    } catch (error) {
      showAlert(t("erroraddingattachment"), "error");
      setLoading(false);
    }
  };
  const clearControls = () => {
    setInsectsData(initialInsectState);
    setPlantsDataObj(initialPlantState);
    setMammalsDataObj(initialMammalsState);
    setReptilesDataObj(initialReptilesState);
  };

  const handleAddRecordApplyEdits = async (layer, options) => {
    if (!layer) return;

    try {
      //const result = await layer.applyEdits(options);

      const result = await layer.applyEdits(options, {
        query: { token }
      });
      const editsApplied = result.addFeatureResults.concat(
        result.updateFeatureResults,
        result.deleteFeatureResults
      );
      if (editsApplied && editsApplied.length > 0) {
        const objectId = editsApplied[0]?.objectId;
        await uploadAttachments(objectId, false);
        showAlert("Data has been addded to feature service", "success");
        clearControls();
        //highlightFeatureOnMap();
        setShowForm(false);
        setSelectedFiles([]);
        setBulkfile([]);
        setModalVisible(false);
        if (activePendingtabs.includes(t("Plants"))) {
          setActivePendingtab(t("Plants"));
          setPlantsSelectedRows([]);
          fetchLayerRecords(t("Plants"), window.PlantInfo.DisplayAttributes, window.PlantInfo.Url);
          highlightFeatureOnMap(t("Plants"), "PlantsWithoutImage.png", "PlantsWithImage.png", AnimalSightsGraphicLayers.Plants, window.PlantInfo);
        } else if (activePendingtabs.includes(t("Invertebrates"))) {
          setActivePendingtab(t("Invertebrates"));
          setInvertebratesSelectedRows([]);
          fetchLayerRecords(t("Invertebrates"), window.InvertiblesInfo.DisplayAttributes, window.InvertiblesInfo.Url);
          highlightFeatureOnMap(t("Invertebrates"), "InsectsWithoutImage.png", "InsectsWithImage.png", AnimalSightsGraphicLayers.Insects, window.InvertiblesInfo);
        } else if (activePendingtabs.includes(t("Mammals"))) {
          setActivePendingtab(t("Mammals"));
          setMammalsSelectedRows([]);
          fetchLayerRecords(t("Mammals"), window.MammalsInfo.DisplayAttributes, window.MammalsInfo.Url);
          highlightFeatureOnMap(t("Mammals"), "MammalsWithoutImage.png", "MammalsWithImage.png", AnimalSightsGraphicLayers.Mammals, window.MammalsInfo);
        } else if (activePendingtabs.includes(t("Reptiles"))) {
          setActivePendingtab(t("Reptiles"));
          setReptilesSelectedRows([]);
          fetchLayerRecords(t("Reptiles"), window.ReptilesInfo.DisplayAttributes, window.ReptilesInfo.Url);
          highlightFeatureOnMap(t("Reptiles"), "ReptileWithoutImage.png", "ReptileWithImage.png", AnimalSightsGraphicLayers.Reptiles, window.ReptilesInfo);
        }
        //setLoading(false);
      } else {
        showAlert(t("unableupdatefeature"), "error");
      }
    } catch (error) {
      showAlert(t("errorapplyedits"), "error");
    }
    finally {
      setLoading(false);
    }
  };
  const handleAttachClick = () => {
    fileInputRef.current.click();
  };

  const handleBulkUploadClick = () => {
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const handleImportFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx)$/;
      if (!regex.test(selectedFile.name.toLowerCase())) {
        showAlert(t("uploadvalidfile"), "error");
        setBulkfile([]);
        if (fileUploadRef.current) {
          fileUploadRef.current.value = ""; // Reset the input
        }
        return;
      }
      setBulkfile([selectedFile]);
    } else {
      showAlert(t("selectexcelfile"), "info");
    }
  };

  const handleImportFileSubmit = async () => {
    const validFileTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (bulkfile.length > 0) {
      const file = bulkfile[0];
      if (!validFileTypes.includes(file.type)) {
        showAlert(t("InvalidExcel"), "error");
        setBulkfile([]);
        return;
      }
      try {
        const reader = new FileReader();
        reader.onload = (event) => {
          const data = event.target.result;
          const binaryData = event.target.result;
          processExcelData(binaryData);
        };
        reader.onerror = () => {
          showAlert(t("fileread"), "error");
          setBulkfile([]);
        };
        reader.readAsBinaryString(file);
      } catch (error) {
        showAlert(t("errorupload"), "error");
        setBulkfile([]);
      }
    } else {
      showAlert(t("PleaseSelectFile"), "error"); // Localized message
    }
  };
  const processExcelData = (data) => {
    let validatedData = null;
    const workbook = XLSX.read(data, { type: "binary", cellDates: true });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

    // Define a lookup table for categories
    const categories = {
      [t("Invertebrates")]: {
        DisplayAttributes: window.InvertiblesInfo.DisplayAttributes,
        domainValues: InsectsDomainValues[0],
      },
      [t("Reptiles")]: {
        DisplayAttributes: window.ReptilesInfo.DisplayAttributes,
        domainValues: ReptilesDomainValues[0],
      },
      [t("Mammals")]: {
        DisplayAttributes: window.MammalsInfo.DisplayAttributes,
        domainValues: MammalsDomainValues[0],
      },
      [t("Plants")]: {
        DisplayAttributes: window.PlantInfo.DisplayAttributes,
        domainValues: PlantsDomainValues[0],
      },
    };

    if (categories[activePendingtabs]) {
      const { DisplayAttributes, domainValues } = categories[activePendingtabs];
      // Validate headers for the current category
      if (!validateHeaders(rows[0], DisplayAttributes)) {
        return; // Exit if headers are invalid
      }
      // Validate row data
      const rowData = XLSX.utils.sheet_to_json(sheet);
      validatedData = validateData(rowData, DisplayAttributes, domainValues);
    }
    if (validatedData !== undefined || validatedData !== null) {
      AddUploadedFeaturestoFDCService(validatedData);
    }
  };
  const validateHeaders = (headers, DisplayAttributes) => {
    for (const attribute of DisplayAttributes) {
      if (activePendingtabs.includes("Mammals")) {
        if (["OBJECTID", "created_date", "Status", "DataSource", "GlobalID", "CollectionMethod", "Phase", "Moon_Phase", "Activity_phase"].includes(attribute)) {
          continue;
        }
      }
      else {
        if (["OBJECTID", "created_date", "Status", "DataSource", "GlobalID"].includes(attribute)) {
          continue;
        }
      }

      const attrName = attribute.AttrName === "Point_X" ? "POINT_X" : attribute.AttrName === "Point_Y" ? "POINT_Y" : attribute.AttrName;
      if (activePendingtabs.includes("Mammals")) {
        if (attrName === "OBJECTID" || attrName === "created_date" || attrName === "DataSource" || attrName === "Status" || attrName === "GlobalID" || attrName === "CollectionMethod" || attrName === "Phase" || attrName === "Moon_Phase" || attrName === "Activity_phase") {
          continue;
        }
        else {
          if (attribute.Mandatory && !headers.includes(attrName)) {
            showAlert(
              `The file does not contain the mandatory column ${attrName}`,
              "error"
            );
            setBulkfile([]);
            return false;
          }
        }
      }
      else {
        if (attrName === "OBJECTID" || attrName === "created_date" || attrName === "DataSource" || attrName === "Status" || attrName === "GlobalID") {
          continue;
        } else {
          if (attribute.Mandatory && !headers.includes(attrName)) {
            showAlert(
              `The file does not contain the mandatory column ${attrName}`,
              "error"
            );
            setBulkfile([]);
            return false;
          }
        }
      }
    }
    return true;
  };
  const validateData = (rows, DisplayAttributes, domainValues) => {
    const validatedRows = [];

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      for (const attribute of DisplayAttributes) {
        const attrName = attribute.AttrName === "Point_X" ? "POINT_X" : attribute.AttrName === "Point_Y" ? "POINT_Y" : attribute.AttrName;


        if (activePendingtabs.includes("Mammals")) {
          if (attrName === "OBJECTID" || attrName === "created_date" || attrName === "DataSource" || attrName === "Status" || attrName === "GlobalID" || attrName === "Phase" || attrName === "Moon_Phase" || attrName === "Activity_phase" || attrName === "CollectionMethod") {
            continue;
          }
          else {
            const value = row[attrName];

            if (attribute.Mandatory && (value == null || value === undefined)) {
              showAlert(
                `The file contains invalid ${attrName} in row ${i + 2}`,
                "error"
              );
              setBulkfile([]);
              return null;
            }
            // Check dropdown values if any
            if (
              attribute.ControllerType === "Dropdown" &&
              domainValues[attrName]
            ) {
              const isValidValue = domainValues[attrName].some((item) => {
                return item.value.trim().toLowerCase() === value?.trim()?.toLowerCase();
              });
              if (!isValidValue) {
                showAlert(
                  `The file contains invalid ${attrName} in row ${i + 2}`,
                  "error"
                );
                setBulkfile([]);
                return null;
              }
            }
          }
        }
        else {
          if (attrName === "OBJECTID" || attrName === "created_date" || attrName === "DataSource" || attrName === "Status" || attrName === "GlobalID") {
            continue;
          }
          else {
            const value = row[attrName];

            if (attribute.Mandatory && (value == null || value === undefined)) {
              showAlert(
                `The file contains invalid ${attrName} in row ${i + 2}`,
                "error"
              );
              setBulkfile([]);
              return null;
            }
            // Check dropdown values if any
            if (
              attribute.ControllerType === "Dropdown" &&
              domainValues[attrName]
            ) {
              let isValidValue;
              if (attrName === "PercentageCover") {
                isValidValue = domainValues[attrName].some((item) => {
                  return item.value === value;
                });
              }
              else {
                isValidValue = domainValues[attrName].some((item) => {
                  return item.value.toLowerCase() === value?.trim()?.toLowerCase();
                });
              }
              if (!isValidValue) {
                showAlert(
                  `The file contains invalid ${attrName} in row ${i + 2}`,
                  "error"
                );
                setBulkfile([]);
                return null;
              }
            }
          }
        }

      }
      validatedRows.push(row);
    }
    return validatedRows;
  };



  const AddUploadedFeaturestoFDCService = (features) => {
    const tabMappings = {
      [t("Invertebrates")]: {
        url: window.InvertiblesInfo.Url,
        domainValues: InsectsDomainValues[0].InsectOrder,
        specialKey: "InsectOrder",
      },
      [t("Reptiles")]: {
        url: window.ReptilesInfo.Url,
        domainValues: ReptilesDomainValues[0].Reptiles,
        specialKey: "Reptiles",
      },
      [t("Mammals")]: {
        url: window.MammalsInfo.Url,
        domainValues: MammalsDomainValues[0].Species,
        specialKey: "Species",
      },
      [t("Plants")]: {
        url: window.PlantInfo.Url,
        specialKey: null,
      },
    };

    const processDate = (dateString) => {
      if (!dateString) return null;
      const dateParsed = new Date(dateString);
      dateParsed.setHours(dateParsed.getHours() + 4);
      return dateParsed.getTime();
    };

    const createFeatureAttributes = (feature, specialKey, domainValues) => {
      const attr = { Status: "Draft", DataSource: 3 };

      Object.keys(feature).forEach((key) => {
        if (["POINT_X", "POINT_Y", "OBJECTID"].includes(key)) return;

        if (key === specialKey && domainValues) {
          const domainValue = domainValues.find(
            (item) => item.value === feature[key]?.trim()
          );
          if (domainValue) attr[key] = parseInt(domainValue.key);
        } else if (key === "SurveyDate" || key === "ObservationDate") {
          const parsedDate = processDate(feature[key]);
          if (parsedDate !== null) attr[key] = parsedDate;
        } else {
          attr[key] = feature[key];
        }
      });

      return attr;
    };

    const createGraphic = (feature, attr) => {
      const pointGeom = new Point({
        longitude: feature.POINT_X,
        latitude: feature.POINT_Y,
      });

      return new Graphic({
        geometry: pointGeom,
        attributes: attr,
      });
    };

    Object.entries(tabMappings).forEach(([tabName, config]) => {
      if (activePendingtabs.includes(tabName)) {
        const FDC_FL = new FeatureLayer(config.url);
        const Feature_Add = features.map((feature) => {
          const attr = createFeatureAttributes(
            feature,
            config.specialKey,
            config.domainValues
          );
          return createGraphic(feature, attr);
        });

        handleAddRecordApplyEdits(FDC_FL, { addFeatures: Feature_Add });
      }
    });
  };

  const handleToggle = () => {
    setIsToggled((prevState) => !prevState);
    setIsEditingEnabled((prevEnabled) => !prevEnabled);
    // Ensure the class is always present on <body>
    if (!document.body.classList.contains("SpatialEditPerform")) {
      document.body.classList.add("SpatialEditPerform");
    }
  };

  const handleCloseSpatialEdit = () => {
    setIsToggled(false);
    setIsEditingEnabled(false);
    divSpatialEdit.current.style.display = "none";
    document.body.classList.remove("SpatialEditPerform");
  };

  useEffect(() => {
    const initializeSketchLayer = (layer, url) => {
      sketch = new Sketch({
        view: mapview,
        layer: layer,
        creationMode: "update",
      });
      setEditingLayer(new FeatureLayer(url));
      sketch.on("update", function (event) {
        if (event.state === "complete") {
          handleEditComplete(event.graphics[0]); // Handling the completion of the edit
        }
      });
    };
    const handleLayerChange = () => {
      if (activePendingtabs.includes(t("Plants"))) {
        initializeSketchLayer(AnimalSightsGraphicLayers.Plants, window.PlantInfo.Url);
      } else if (activePendingtabs.includes(t("Mammals"))) {
        initializeSketchLayer(AnimalSightsGraphicLayers.Mammals, window.MammalsInfo.Url);
      } else if (activePendingtabs.includes(t("Reptiles"))) {
        initializeSketchLayer(AnimalSightsGraphicLayers.Reptiles, window.ReptilesInfo.Url);
      } else if (activePendingtabs.includes(t("Invertebrates"))) {
        initializeSketchLayer(AnimalSightsGraphicLayers.Insects, window.InvertiblesInfo.Url);
      }
    };

    if (isEditingEnabled) {
      showAlert(t("selectfeaturetoedit"), "info");
      handleLayerChange();
    } else {
      if (sketch) {
        sketch.cancel();
        sketch.destroy();
        sketch = null;
      }
      if (divSpatialEdit?.current) {
        divSpatialEdit.current.style.display = "none";
      }
    }

    return () => {
      // Cleanup when component unmounts or when dependencies change
      if (sketch) {
        sketch.cancel();
        sketch.destroy();
        sketch = null;
      }
    };
  }, [isEditingEnabled]); // Added activePendingtabs to dependency array for better tracking

  const handleEditComplete = async (graphic) => {
    setLoading(true);
    const pointGeom = new Point(graphic.geometry);
    const geographicPoint = webMercatorUtils.webMercatorToGeographic(pointGeom);

    // Check if the geographic point is within the allowed region
    //if (geographicPoint.x > 51.303 && geographicPoint.x < 56.664 && geographicPoint.y > 22.455 && geographicPoint.y < 26.326) {
    if (((geographicPoint.x > 51.303 && geographicPoint.x < 56.664) && (geographicPoint.y > 22.455 && geographicPoint.y < 26.326))) {
      const updateFeatureLayer = async (layerUrl, resetRowsCallback) => {
        try {
          const layer = new FeatureLayer(layerUrl);
          const result = await layer.applyEdits({
            updateFeatures: [graphic],
             params: { token }
          });
          showAlert(t("updatefeature"), "success");
          resetRowsCallback();
          //setIsEditingEnabled(false);
          RefreshData();
          setLoading(false);
          //divSpatialEdit.current.style.display = "none";
        } catch (error) {
          setLoading(false);
          divSpatialEdit.current.style.display = "none";
        }
      };

      if (activePendingtabs.includes(t("Plants"))) {
        updateFeatureLayer(window.PlantInfo.Url, () => setPlantsSelectedRows([]));
      } else if (activePendingtabs.includes(t("Reptiles"))) {
        updateFeatureLayer(window.ReptilesInfo.Url, () => setReptilesSelectedRows([]));
      } else if (activePendingtabs.includes(t("Mammals"))) {
        updateFeatureLayer(window.MammalsInfo.Url, () => setMammalsSelectedRows([]));
      } else if (activePendingtabs.includes(t("Invertebrates"))) {
        updateFeatureLayer(window.InvertiblesInfo.Url, () => setInvertebratesSelectedRows([]));
      }
    } else {
      showAlert(t("selectregion"), "error");
      setIsEditingEnabled(false);
      setLoading(false);
      divSpatialEdit.current.style.display = "none";
    }
  };
  const handleRadioChange = (format) => {
    setSelectedFormat(format);
  };

  useEffect(() => {
    if (showForm === true) {
      const graphicsLayer = new GraphicsLayer();
      mapview.map.add(graphicsLayer);
      graphicsLayerRef.current = graphicsLayer;

      const sketchViewModel = new SketchViewModel({
        view: mapview,
        layer: graphicsLayer, // Use the graphics layer for drawing
        availableCreateTools: ["polygon", "point", "polyline"],
      });
      sketchViewModelRef.current = sketchViewModel;
      return () => {
        if (graphicsLayer) {
          mapview.map.remove(graphicsLayer); // Remove the graphics layer on cleanup
        }
        sketchViewModelRef.current = null;
        graphicsLayerRef.current = null;
      };
    }
  }, [showForm]);
  const handleAddPoint = () => {
    showAlert(t("clickToAddPoint"), "info");

    sketchViewModelRef.current.create("point");
    const createHandle = sketchViewModelRef.current.on("create", handleCreate);
    return () => {
      if (createHandle) {
        createHandle.remove();
      }
    };
  };

  const isValidGeography = (graphic) => {
    const { longitude, latitude } = graphic.geometry;
    return (
      longitude >= 51.303 &&
      longitude <= 56.664 &&
      latitude >= 22.455 &&
      latitude <= 26.326
    );
  };

  const handleCoordinatesFormat = (graphic, selectedFormat, setStateCallback) => {
    const { latitude, longitude } = graphic.geometry;

    if (selectedFormat === "DD") {

      let tabName =
        activePendingtabs === t("Invertebrates")
          ? "Insects"
          : activePendingtabs === t("Reptiles")
            ? "Reptile"
            : activePendingtabs;

      if (activePendingtabs === t("Invertebrates") || activePendingtabs === t("Plants")) {
        setStateCallback((prevState) => ({
          ...prevState,
          [`${`${tabName.toLowerCase()}latitude`}`]: latitude, // Lowercase the full key
          [`${`${tabName.toLowerCase()}longitude`}`]: longitude, // Lowercase the full key
        }));
      }
      if (activePendingtabs === t("Mammals") || activePendingtabs === t("Reptiles")) {
        setStateCallback((prevState) => ({
          ...prevState,
          [`${`${tabName.toLowerCase()}Latitude`}`]: latitude, // Lowercase the full key
          [`${`${tabName.toLowerCase()}Longitude`}`]: longitude, // Lowercase the full key
        }));
      }
    } else {
      const lat = convertToDMS(latitude, "lat");
      const lon = convertToDMS(longitude, "long");

      const [longDeg, longMin, longSec] = lat.split(/[^\d\w\.]+/);
      const [latDeg, latMin, latSec] = lon.split(/[^\d\w\.]+/);

      //let tabName = activePendingtabs === "Invertebrates" ? "Insects" : activePendingtabs;
      let tabName =
        activePendingtabs === t("Invertebrates")
          ? "Insects"
          : activePendingtabs === t("Reptiles")
            ? "Reptile"
            : activePendingtabs;
      setStateCallback((prevState) => ({
        ...prevState,
        [`${`${tabName.toLowerCase()}latDegrees`}`]: latDeg,
        [`${`${tabName.toLowerCase()}latMinutes`}`]: latMin,
        [`${`${tabName.toLowerCase()}latSeconds`}`]: latSec,
        [`${`${tabName.toLowerCase()}longDegrees`}`]: longDeg,
        [`${`${tabName.toLowerCase()}longMinutes`}`]: longMin,
        [`${`${tabName.toLowerCase()}longSeconds`}`]: longSec,
      }));
    }
  };
  const handleCreate = (event) => {
    if (event.aborted) return;
    if (event.state === "complete") {
      const graphic = event.graphic;
      // Add marker to map
      const pointGraphic = new Graphic({
        geometry: {
          type: "point",
          latitude: graphic.geometry.latitude,
          longitude: graphic.geometry.longitude,
        },
        symbol: {
          type: "simple-marker",
          style: "circle",
          color: "red",
          size: "0.75rem",
          outline: { color: "white", width: 1 },
        },
      });
      mapview.graphics.add(pointGraphic);

      if (!isValidGeography(graphic)) {
        showAlert(t("mapPoint"), "error");
        return;
      }
      // Common logic for setting data objects based on the active tab
      const dataObj = {
        [t("Plants")]: setPlantsDataObj,
        [t("Mammals")]: setMammalsDataObj,
        [t("Reptiles")]: setReptilesDataObj,
        [t("Invertebrates")]: setInsectsData,
      };

      const Activetabs = Array.isArray(activePendingtabs) ? activePendingtabs : [activePendingtabs];

      Activetabs.forEach((tab) => {
        if (dataObj[tab]) {
          handleCoordinatesFormat(graphic, selectedFormat, dataObj[tab]);
        }
      });
    }
  };
  const convertToDMS = (decimal, type) => {
    const degrees = Math.floor(decimal);
    const minutesDecimal = Math.abs(decimal - degrees) * 60;
    const minutes = Math.floor(minutesDecimal);
    const seconds = ((minutesDecimal - minutes) * 60).toFixed(2);

    return `${Math.abs(degrees)}° ${minutes}' ${seconds}" ${type === "lat" ? (decimal >= 0 ? "N" : "S") : decimal >= 0 ? "E" : "W"
      }`;
  };

  const RefreshData = () => {
    setIsEditing(!isEditing);
    editingRows = [];
    setInvertebratesSelectedRows([]);
    setPlantsSelectedRows([]);
    setMammalsSelectedRows([]);
    setReptilesSelectedRows([]);
    mapview.graphics.removeAll();
    //setIsEditingEnabled(false);
    //setIsToggled(false);
    //divSpatialEdit.current.style.display = "none";
    const tableIds = {
      [t("Plants")]: "tblPlants",
      [t("Mammals")]: "tblMammals",
      [t("Reptiles")]: "tblReptiles",
      [t("Invertebrates")]: "tblInsects",
    };
    const grid = document.getElementById(tableIds[activePendingtabs]);
    const rows = grid.querySelectorAll("tr");
    rows.forEach((row) => row.classList.remove("colorcoding"));
    //rows.forEach((row) => (row.style.background = "none"));

    if (window.sketchVM) {
      const sketchLayer = window.sketchVM.layer;
      if (sketchLayer && sketchLayer.graphics) {
        const polygonGraphics = sketchLayer.graphics.filter(
          (graphic) => graphic.geometry.type === "polygon"
        );
        polygonGraphics.forEach((graphic) => sketchLayer.graphics.remove(graphic));
      }
      window.sketchVM.cancel(); // Cancel any ongoing drawing operation
    }
    clearControls();
    setModalVisible(false);
    setShowModal(false);
    setShowForm(false);

    const tabMappings = {
      [t("Invertebrates")]: {
        url: window.InvertiblesInfo.Url,
        displayAttributes: window.InvertiblesInfo.DisplayAttributes,
        specialKey: t("Invertebrates"),
      },
      [t("Reptiles")]: {
        url: window.ReptilesInfo.Url,
        displayAttributes: window.ReptilesInfo.DisplayAttributes,
        specialKey: t("Reptiles"),
      },
      [t("Mammals")]: {
        url: window.MammalsInfo.Url,
        displayAttributes: window.MammalsInfo.DisplayAttributes,
        specialKey: t("Mammals"),
      },
      [t("Plants")]: {
        url: window.PlantInfo.Url,
        displayAttributes: window.PlantInfo.DisplayAttributes,
        specialKey: t("Plants"),
      },
    };
    if (activePendingtabs) {
      const { specialKey, displayAttributes, url } = tabMappings[activePendingtabs];
      fetchLayerRecords(specialKey, displayAttributes, url);
    }
  };

  const handleTabChange = (param) => {
    setActivePendingtab(param);
    clearControls();
    divSpatialEdit.current.style.display = "none";
    setIsToggled(false);
    setIsEditingEnabled(false);
    setOriginalData([]);
    setIsDataModified(false);
    setMobFilterShow(false);
    setShowFilter(false);
    document.body.classList.remove("SpatialEditPerform");
    // if (window.sketchVM) {
    //   const sketchLayer = window.sketchVM.layer;
    //   if (sketchLayer && sketchLayer.graphics) {
    //     const polygonGraphics = sketchLayer.graphics.filter(
    //       (graphic) => graphic.geometry.type === "polygon"
    //     );
    //     polygonGraphics.forEach((graphic) => sketchLayer.graphics.remove(graphic));
    //   }
    // }
  };

  // const sortTable = (colIndex, tableId) => {
  //   const table = document.getElementById(tableId);
  //   const rows = Array.from(table.rows).slice(1); // Skip the header row
  //   const sortedRows = rows.sort((a, b) =>
  //     a.cells[colIndex].innerText.localeCompare(b.cells[colIndex])
  //   );
  //   table.tBodies[0].append(...sortedRows); // Append sorted rows back to the table body
  // };
  const sortTable = (columnName, tableId) => {
    const table = document.getElementById(tableId);
    const rows = Array.from(table.querySelectorAll("tbody tr"));
    const isAscending = table.getAttribute("data-sort-asc") === "true";
    const headers = Array.from(table.querySelectorAll("thead tr:nth-child(1) th"));
    let headerIndex = headers.findIndex(th => th.innerText.trim() === columnName);
    if (headerIndex === -1) return; // Exit if column not found
    let actualColumnIndex = -1;
    rows.some(row => {
      let visibleIndex = -1;
      Array.from(row.cells).forEach((td, i) => {
        if (td.style.display !== "none") {
          visibleIndex++;
        }
        if (visibleIndex === headerIndex) {
          actualColumnIndex = i;
          return true; // Stop iteration once we find the correct index
        }
      });
      return actualColumnIndex !== -1; // Exit loop once we get the correct index
    });
    if (actualColumnIndex === -1) return; // Ensure we found a valid index
    const sortedRows = rows.sort((rowA, rowB) => {
      let cellA = rowA.cells[actualColumnIndex]?.innerText.trim().toLowerCase() || "";
      let cellB = rowB.cells[actualColumnIndex]?.innerText.trim().toLowerCase() || "";

      // Sanitize cell values before comparing
      cellA = DOMPurify.sanitize(cellA);
      cellB = DOMPurify.sanitize(cellB);
      return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
    });
    rows.forEach(row => table.tBodies[0].removeChild(row));
    sortedRows.forEach(row => table.tBodies[0].appendChild(row));
    table.setAttribute("data-sort-asc", !isAscending);
  };

  const modalProps = {
    attachmentsContent,
    uploadAttachments,
    handleFileChange,
    selectedFiles,
    handleShow,
    handleAttachClick,
    handleDrop,
    handleDragOver,
    handleRemoveFile,
    fileInputRef
  };
  const commonProps = {
    handleSave,
    handleIndputDropdownChange,
    handleRowSelection,
    handleInputChange,
    ApproveFeatures,
    activePendingtabs,
    modalObjectId,
    showPopover,
    fileUpload: handleBulkUploadClick,
    handleDelete,
    ViewFeatureonMap
  }
  const [mobFilterShow, setMobFilterShow] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);

  const handleMobFilterClose = () => {
    setMobFilterShow(false)
  };
  const handleMobFilterReset = () => {
    resetMobFilters()
  };
  const handleMobFilterShow = () => {
    setMobFilterShow(true);
  }

  const speciesOrder = [
    { id: 1, name: "Mammals" },
    { id: 2, name: "Birds" },
    { id: 3, name: "Reptiles" },
    { id: 4, name: "Amphibians" },
    { id: 5, name: "Fish" },
  ];

  useEffect(() => {
    const updateView = () => setIsMobileView(window.innerWidth <= 767);
    updateView();
    window.addEventListener("resize", updateView);
    return () => window.removeEventListener("resize", updateView);
  }, []);

  return (
    <>
      {!showForm && (
        <>
          {loading && <DivLoader />}
          <div id="" className="animal-approved-container h-100">
            <AlertMessage
              message={alertmessage}
              closeMessage={() => setAlertMessage(null)}
            />
            <AnimalModalPopups
              forData="deleteConfirm"
              show={showModal}
              onClose={handleCloseModal}
              onConfirm={handleConfirm}
              data={idToDelete}
            />
            <AnimalModalPopups
              forData="deleteSuccess"
              show={showSuccessModal}
              onClose={handleCloseModal}
            />
            {scriptLoaded ? (
              <>
                <Tabs className="animTab"
                  selectedTabClassName="pollutantsfilterTab"
                  selectedIndex={filteredPendingRecordList.indexOf(activePendingtabs)}
                  forceRenderTabPanel
                >
                  <div className="row">
                    <div className="col-12 ani-pending">
                      <TabList className="animalSubTab">
                        {filteredPendingRecordList.map((param) => (
                          <Tab
                            key={t("DeleteAlertMessage", { attrName: param })}
                            onClick={() => handleTabChange(param)}
                          >
                            {`${param} (${param === t("Plants")
                              ? PlantsData.length
                              : param === t("Invertebrates")
                                ? InvertebratesData.length
                                : param === t("Mammals")
                                  ? MammalsData.length
                                  : ReptilesData.length
                              })`}
                            {/* {param} */}
                          </Tab>
                        ))}
                      </TabList>
                    </div>
                  </div>
                  {
                    groupNames.includes(window.userGroups.invertebrates) &&
                    (

                      <TabPanel>
                        <div className="pendingrecord-container pendingSvgEql">
                          <div className="animalFilterGrid animalFilterGrid--pending">
                            <h6 className="mb-3 mt-1 me-2" style={{ fontSize: '0.8rem' }}><b>{t('pendingInsects')}</b></h6>
                            <div className="gap5 animalFilterBlk">
                              <button
                                className={`btn btn-outline approvedrecord-button ${showfilter ? "active" : ""
                                  }`}
                                onClick={() => {
                                  isMobileView ? handleMobFilterShow() : onFilterClick()
                                }
                                }

                                data-tooltip-content={t('filter')}
                                data-tooltip-id={`tooltip-filter`}
                                data-tooltip-place="bottom"
                              >
                                <span
                                  className="filter-text"
                                  ref={(el) => { if (el) elementInstances["span1"] = el; }}
                                  style={{
                                    color:
                                      theme === "dark"
                                        ? "#fff"
                                        : showfilter
                                          ? "#179075"
                                          : "#000",
                                  }}
                                >
                                  {t("filter")}
                                </span>
                                <BiFilterAlt className="filter-icon" size={15} title="Filter" />
                              </button>
                              {/* <Tooltip id={`tooltip-filter`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              {showfilter && (
                                <button
                                  className="btn clearfilter-btn ms-0"
                                  onClick={handleClarFilter}
                                >
                                  <span>{t("Clear Filters")}</span>
                                  <ImCancelCircle size={15} />
                                </button>
                              )}
                            </div>

                            <div className="gap5">
                              <button
                                className={`btn btn-outline ${activeButton === "approve" ? "active" : ""}`}
                                onClick={() => handleButtonClick("approve", ApproveFeatures)}
                                data-tooltip-content={t("Approve")}
                                data-tooltip-id={`tooltip-approve`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("Approve")}</span>
                                <LuCheck size={15} title="Approve" />
                              </button>
                              {/* <Tooltip id={`tooltip-approve`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "view" && activePendingtabs) ? "active" : ""}`}
                                onClick={() => {
                                  handleButtonClick("view", ViewFeatureonMap);
                                  if (fullView === "fullView") {
                                    onClose();
                                  }
                                }}
                                data-tooltip-content={t("view")}
                                data-tooltip-id={`tooltip-view`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("view")}</span>
                                <FiEye size={15} title="View" />
                              </button>
                              {/* <Tooltip id={`tooltip-view`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "clear" && activePendingtabs) ? "active" : ""}`}
                                onClick={() => handleButtonClick("clear", RefreshData)}
                              >{t("Clear")}
                              </button>
                              <button
                                className={`btn btn-outline ${(activeButton === "delete" && showModal) ? "active" : ""}`}
                                onClick={() => handleButtonClick("delete", handleDelete)}
                                data-tooltip-content={t("delete")}
                                data-tooltip-id={`tooltip-delete`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("delete")}</span>
                                <MdOutlineDelete size={15} title="Delete" className="delete-17" />
                              </button>
                              {/* <Tooltip id={`tooltip-delete`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "edit" && isEditing) ? "active" : ""}`}
                                onClick={() => handleButtonClick("edit", handleEditSelectedRows)}
                                data-tooltip-content={t("edit")}
                                data-tooltip-id={`tooltip-edit`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("edit")}</span>
                                <FiEdit2 size={15} title="Edit" />
                              </button>
                              {/* <Tooltip id={`tooltip-edit`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "upload" && modalVisible) ? "active" : ""}`}
                                onClick={() => handleButtonClick("upload", handleBulkUploadClick)}
                                data-tooltip-content={t("Upload")}
                                data-tooltip-id={`tooltip-upload`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("Upload")}</span>
                                <FiUpload size={15} title="Upload" />
                              </button>
                              {/* <Tooltip id={`tooltip-upload`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            </div>

                            {modalVisible && (
                              <Modal show={modalVisible} centered size="sm">
                                <Modal.Body className="animalModalBody pb-0">
                                  <h5>{t("Upload File")}</h5>
                                  <Form>
                                    <Form.Group
                                      controlId="formFile"
                                      className="mb-3"
                                    >
                                      <Form.Control
                                        type="file"
                                        id="aniFileUpload-inv"
                                        ref={fileUploadRef}
                                        onChange={handleImportFileChange}
                                        accept=".xls,.xlsx"
                                      />
                                      <Form.Label for="aniFileUpload-inv" className="fileUploadCustomLabel">
                                        <div className="fileUploadBlk">
                                          <FiUpload size={20} className="mb-2" />
                                          <div className="my-2">
                                            {t("DragDrop")} <br />{t("Or")}<br />
                                            <span className="d-block fileUpBrowse">{t("BrowseFiles")}</span>
                                          </div>
                                          <div className="text-black-50">({t("uploadexcel")})</div>
                                        </div>
                                        {bulkfile.length > 0 && (
                                          <div className="selected-file">
                                            <span>{bulkfile[0].name}</span>
                                          </div>
                                        )}
                                      </Form.Label>
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>
                                <Modal.Footer className="border-0 animalModalFooter">
                                  <Button variant="outline flex-fill" onClick={handleModalClose}>
                                    {t("cancel")}
                                  </Button>
                                  <Button variant="primary flex-fill" onClick={handleImportFileSubmit}>
                                    {t("save")}
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            )}
                            {/* Filter on mobile view  -- start*/}
                            {mobFilterShow &&
                              <Modal show={mobFilterShow} className="aniFilterModal" onHide={handleMobFilterClose} centered>
                                <Modal.Header closeButton>
                                  <Modal.Title>{t("filter")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className="aniMobFilterContent">
                                    <div>
                                      <>
                                        {(() => {
                                          // Define tabMappings to dynamically get currentRows based on activePendingtabs
                                          const tabMappings = {
                                            [t("Invertebrates")]: {
                                              currentRows: InvertebratescurrentRows,
                                              domainValues: InsectsDomainValues,
                                              displayAttributes: window.InvertiblesInfo.DisplayAttributes,
                                            },
                                            [t("Plants")]: {
                                              currentRows: PlantscurrentRows,
                                              domainValues: PlantsDomainValues,
                                              displayAttributes: window.PlantInfo.DisplayAttributes,
                                            },
                                            [t("Mammals")]: {
                                              currentRows: MammalscurrentRows,
                                              domainValues: MammalsDomainValues,
                                              displayAttributes: window.MammalsInfo.DisplayAttributes,
                                            },
                                            [t("Reptiles")]: {
                                              currentRows: ReptilescurrentRows,
                                              domainValues: ReptilesDomainValues,
                                              displayAttributes: window.ReptilesInfo.DisplayAttributes,
                                            },
                                          };

                                          // Dynamically get the currentRows and related data for the active tab
                                          const { currentRows, domainValues, displayAttributes } =
                                            tabMappings[activePendingtabs] || {};

                                          const formatKeyLabel = (key) => {
                                            // if (/^[A-Z0-9_]+$/.test(key)) {
                                            //   return key;
                                            // }

                                            const fixedLabels = {
                                              "point_x": "Point_X",
                                              "point_y": "Point_Y",
                                            };
                                            const lowerKey = key.toLowerCase();
                                            if (fixedLabels[lowerKey]) {
                                              return fixedLabels[lowerKey];
                                            }
                                            return key
                                              .replace(/_/g, ' ')                          // Replace underscores with spaces
                                              .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                                              .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

                                            // return key
                                            //   .replace(/([a-z])([A-Z])/g, '$1 $2')  // insert space between lowercase and uppercase
                                            //   .replace(/_/g, ' ')                   // optional: replace underscores with spaces too
                                            //   .trim();
                                          };

                                          return (
                                            mobFilterShow &&
                                            currentRows &&
                                            currentRows.current &&
                                            currentRows.current[0] &&
                                            Object.keys(currentRows.current[0] || originalData)
                                              .filter(
                                                (key) =>
                                                  key !== "OBJECTID" &&
                                                  key !== "id" &&
                                                  key !== "Status" &&
                                                  key !== "DataSource" &&
                                                  key !== "created_date" &&
                                                  key !== "GlobalID"
                                              )
                                              .map((key) => {
                                                const filteredAttributes = displayAttributes.filter(
                                                  (attr) =>
                                                    attr.AttrName !== "id" &&
                                                    attr.AttrName !== "SurveyDate" &&
                                                    attr.AttrName !== "OBJECTID" &&
                                                    attr.AttrName !== "Status" &&
                                                    attr.AttrName !== "DataSource" &&
                                                    attr.AttrName !== "GlobalID" &&
                                                    attr.AttrName !== "created_date" &&
                                                    attr.AttrName === key
                                                );

                                                return (
                                                  <div className="card-container mb-3" key={`${key}-filter`}>
                                                    <div className="card-row" key={key}>
                                                      {filteredAttributes.length > 0 &&
                                                        filteredAttributes[0].Domains === true ? (
                                                        <>
                                                          <label>{formatKeyLabel(key)}</label>
                                                          <Select
                                                            options={[
                                                              { value: "All", label: "All" },
                                                              ...(domainValues[0]?.[key]?.map((domain) => ({
                                                                value: domain.key,
                                                                label: domain.value,
                                                              })) || []),
                                                            ]}
                                                            value={
                                                              filters[key]
                                                                ? {
                                                                  value: filters[key],
                                                                  label: filters[key],
                                                                }
                                                                : {
                                                                  value: "All",
                                                                  label: "All",
                                                                }
                                                            }
                                                            onChange={(selectedOption) =>
                                                              handleMobFilterChange(
                                                                key,
                                                                selectedOption?.label || "All"
                                                              )
                                                            }
                                                            components={{
                                                              DropdownIndicator: CustomDropdownIndicator,
                                                            }}
                                                            className={`react-select-container`}
                                                            classNamePrefix="react-select"
                                                            placeholder={`Select ${key}`}
                                                          />
                                                        </>
                                                      ) : (
                                                        <div className="aniMobEditInputBlk">
                                                          <label>{formatKeyLabel(key)}</label>
                                                          <input
                                                            type="text"
                                                            value={filters[key] || ""}
                                                            className="form-control InputTextHolder"
                                                            onChange={(e) =>
                                                              handleMobFilterChange(key, e.target.value)
                                                            }
                                                          />
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                )
                                              })
                                          )
                                        })()}
                                      </>
                                    </div>
                                  </div>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="outline" onClick={handleMobFilterReset}>
                                    {t("reset")}
                                  </Button>
                                  <Button
                                    variant="primary"
                                    onClick={() => {
                                      setMobFilterShow(false);
                                      handleFilterApply();
                                    }}
                                  >
                                    {t("ApplyFilter")}
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                            }


                            {isResetBtnShow && (
                              <button
                                className="btn clearfilter-btn ms-0"
                                onClick={handleClarFilter}
                              >
                                <span>{t("Clear Filters")}</span>
                                <ImCancelCircle size={15} />
                              </button>
                            )}
                            {/* Filter on mobile view  -- end*/}
                          </div>
                          <div className="table-responsive Animalapprovedtable">
                            <div className="TableScrollDiv desktopOnly">
                              <table
                                id="tblInsects"
                                ref={tableRefs["Invertebrates"]}
                                className="table textwrap"
                                data-sort-asc="true"
                              >
                                <thead className="thead-dark">
                                  <tr>
                                    <th>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={
                                          InvertebratesSelectedRows.length > 0 &&
                                          InvertebratesSelectedRows.length === (InvertebratescurrentRows?.current || []).length
                                        }
                                        disabled={isEditing && editingRows.length > 0}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            const allRowIds = (InvertebratescurrentRows?.current || []).map(
                                              (row) => row.id // Assuming `id` is the unique identifier
                                            );
                                            setInvertebratesSelectedRows(allRowIds);
                                          } else {
                                            setInvertebratesSelectedRows([]);
                                          }
                                        }}
                                      />
                                    </th>
                                    {invertebrateheaders.map((key, index) => (
                                      <th key={key} onClick={() => sortTable(key, "tblInsects")}>{key}</th>
                                    ))}
                                  </tr>
                                  {showfilter && (
                                    <tr>
                                      <th></th>
                                      {InvertebratescurrentRows &&
                                        (InvertebratescurrentRows.current.length > 0 || window.InvertiblesInfo.DisplayAttributes.length > 0) ? (
                                        (InvertebratescurrentRows.current.length > 0 ?
                                          Object.keys(InvertebratescurrentRows.current[0]) : window.InvertiblesInfo.DisplayAttributes.map((attr) => attr.AttrName)
                                        ).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                          const filteredAttributes = window.InvertiblesInfo.DisplayAttributes.filter(
                                            (attr) =>
                                              attr.AttrName !== "id" &&
                                              attr.AttrName !== "SurveyDate" &&
                                              attr.AttrName !== "OBJECTID" &&
                                              attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                              attr.AttrName !== "created_date" &&
                                              attr.AttrName === key
                                          );
                                          return (
                                            <th key={`${key}-filter`}>
                                              {filteredAttributes.length > 0 &&
                                                filteredAttributes[0].Domains ===
                                                true ? (
                                                <Select
                                                  options={[
                                                    { value: "All", label: "All" },
                                                    ...(InsectsDomainValues[0]?.[
                                                      key
                                                    ]?.map((domain) => ({
                                                      value: domain.key,
                                                      label: domain.value,
                                                    })) || []),
                                                  ]}
                                                  value={
                                                    filters[key]
                                                      ? {
                                                        value: filters[key],
                                                        label: filters[key],
                                                      }
                                                      : {
                                                        value: "All",
                                                        label: "All",
                                                      }
                                                  }
                                                  onChange={(selectedOption) =>
                                                    handleFilterChange(
                                                      key,
                                                      selectedOption?.label || "All"
                                                    )
                                                  }
                                                  components={{
                                                    DropdownIndicator: CustomDropdownIndicator,
                                                  }}
                                                  className={`react-select-container`}
                                                  classNamePrefix="react-select"
                                                  placeholder={t("selectvalue", { attrName: key })}   //t(`Select ${key}`)
                                                />
                                              ) : (
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  value={filters[key] || ""}
                                                  onChange={(e) =>
                                                    handleFilterChange(
                                                      key,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              )}
                                            </th>
                                          );
                                        })
                                      ) : (
                                        <td colSpan={Object.keys(InvertebratescurrentRows.current[0] || {}).length}>
                                          {t('No data available')}
                                        </td>
                                      )}
                                    </tr>
                                  )}
                                </thead>
                                <tbody>
                                  {Array.isArray(
                                    InvertebratescurrentRows.current
                                  ) ? (

                                    InvertebratescurrentRows.current.map((row) => (
                                      <tr key={row.id}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={InvertebratesSelectedRows.includes(
                                              row.id
                                            )}
                                            onChange={() =>
                                              handleRowSelection(row.id)
                                            }
                                            disabled={isEditing}
                                          />
                                        </td>
                                        <td style={{ display: "none" }} data-objectid={row.OBJECTID}>
                                          {row.OBJECTID}
                                        </td>
                                        {Object.keys(row).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                          const filteredAttributes = window.InvertiblesInfo.DisplayAttributes.filter(
                                            (attr) =>
                                              attr.AttrName !== "id" && attr.AttrName !== "created_date" && attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                              attr.AttrName === key
                                          );
                                          let domainValues = [];

                                          if (key === "Family") {
                                            const matchingOrder = SpeciesOrder?.find(
                                              (order) =>
                                                order.value === row["InsectOrder"]
                                            );
                                            if (matchingOrder) {
                                              domainValues =
                                                OrderFamilyNames.find(
                                                  (item) =>
                                                    item.SpeciesOrder ===
                                                    matchingOrder.value
                                                )?.FamilyNames || [];
                                            }
                                          } else if (key === "SpeciesName") {
                                            const matchingFamily = FamilyName?.find(
                                              //(family) => family.value.toLowerCase() === row["Family"].toLowerCase()
                                              (family) => family.value.toLowerCase() === row?.Family?.toLowerCase()
                                            );
                                            if (matchingFamily) {
                                              domainValues =
                                                FamilySpeciesNames.find(
                                                  (item) =>
                                                    item.FamilyName ===
                                                    matchingFamily.value
                                                )?.SpeciesNames || [];
                                            }
                                          } else {
                                            domainValues =
                                              InsectsDomainValues[0][key] || [];
                                          }
                                          return (
                                            <React.Fragment key={key}>
                                              <td>
                                                {isEditing &&
                                                  editingRows.includes(row.id) &&
                                                  InvertebratesSelectedRows.includes(
                                                    row.id
                                                  ) &&
                                                  filteredAttributes.length > 0 ? (
                                                  filteredAttributes[0].Domains ===
                                                    false ? (
                                                    key === "SurveyDate" ||
                                                      key === "created_date" ? (
                                                      <div className="dateInputBlk">
                                                        <input
                                                          //ref={dateInputRef}
                                                          type="datetime-local"
                                                          className="form-control"
                                                          value={
                                                            editedRows[row.id]?.[
                                                              key
                                                            ] !== undefined
                                                              ? formatToDatetimeLocal(
                                                                editedRows[row.id][
                                                                key
                                                                ]
                                                              )
                                                              : formatToDatetimeLocal(
                                                                row[key]
                                                              )
                                                          }
                                                          max={new Date()
                                                            .toISOString()
                                                            .slice(0, 16)} // Restrict future dates
                                                          //defaultValue={editedRows[row.id]?.[key] !== undefined ? editedRows[row.id][key] : row[key]}
                                                          onChange={(e) =>
                                                            handleInputChange(
                                                              row.id,
                                                              key,
                                                              e.target.value
                                                            )
                                                          } // Handle datetime input change
                                                        />
                                                        <RxCalendar onClick={handleCalendarClick} />
                                                      </div>
                                                    ) : (
                                                      <input
                                                        type="text"
                                                        value={
                                                          editedRows[row.id]?.[
                                                            key
                                                          ] !== undefined // Check if value is defined
                                                            ? editedRows[row.id][
                                                            key
                                                            ]
                                                            : row[key]
                                                        }
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            row.id,
                                                            key,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    )
                                                  ) : key === "InsectOrder" ? (
                                                    <Select
                                                      options={domainValues.map(
                                                        (option) => ({
                                                          value: option.key,
                                                          label: option.value,
                                                        })
                                                      )}
                                                      value={
                                                        row.InsectOrder
                                                          ? {
                                                            value:
                                                              row.InsectOrder,
                                                            label:
                                                              domainValues.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  row.InsectOrder
                                                              )?.value ||
                                                              `Select ${key}`,
                                                          }
                                                          : null
                                                      }
                                                      onChange={(selectedOption) =>
                                                        handleOrderChange(
                                                          selectedOption,
                                                          row
                                                        )
                                                      }
                                                      components={{
                                                        DropdownIndicator: CustomDropdownIndicator,
                                                      }}
                                                      className={`react-select-container`}
                                                      classNamePrefix="react-select"
                                                      placeholder={t(
                                                        "Select Insect Order"
                                                      )}
                                                    />
                                                  ) : key === "Family" ? (
                                                    <Select
                                                      options={domainValues.map(
                                                        (option) => ({
                                                          value: option.key,
                                                          label: option.value,
                                                        })
                                                      )}
                                                      value={
                                                        row.Family
                                                          ? {
                                                            value: row.Family,
                                                            label:
                                                              domainValues.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  row.Family
                                                              )?.value ||
                                                              `Select ${key}`,
                                                          }
                                                          : null
                                                      }
                                                      onChange={(selectedOption) =>
                                                        handleFamilyChange(
                                                          selectedOption,
                                                          row
                                                        )
                                                      }
                                                      components={{
                                                        DropdownIndicator: CustomDropdownIndicator,
                                                      }}
                                                      className={`react-select-container`}
                                                      classNamePrefix="react-select"
                                                      placeholder={t(
                                                        "Select Family"
                                                      )}
                                                    />
                                                  ) : (
                                                    <Select
                                                      options={domainValues.map(
                                                        (option) => ({
                                                          value: option.key,
                                                          label: option.value,
                                                        })
                                                      )}
                                                      value={
                                                        row[key]
                                                          ? {
                                                            value: row[key],
                                                            label:
                                                              domainValues.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  row[key]
                                                              )?.value ||
                                                              `Select ${key}`,
                                                          }
                                                          : null
                                                      }
                                                      onChange={(selectedOption) =>
                                                        handleChange(
                                                          key,
                                                          selectedOption,
                                                          row
                                                        )
                                                      }
                                                      components={{
                                                        DropdownIndicator: CustomDropdownIndicator,
                                                      }}
                                                      className={`react-select-container`}
                                                      classNamePrefix="react-select"
                                                      placeholder={`Select ${key}`}
                                                    />
                                                  )
                                                ) : (
                                                  <div className="tableTxtTruncate">{row[key]}</div>
                                                )}
                                              </td>
                                              {key === "created_date" && (
                                                <td
                                                  colSpan={3}
                                                  valign="middle"
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <div className="col-md-12 popover-container">
                                                    <>
                                                      <img
                                                        src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                                        className="uploadicon mb-1"
                                                        ref={IconAttachtarget}
                                                        onClick={() =>
                                                          handleShow(row)
                                                        } // Show modal on click
                                                        alt="Attachment Icon"
                                                        style={{
                                                          cursor: "pointer",
                                                          width: "1.25rem",
                                                        }}
                                                      />
                                                      {showPopover &&
                                                        modalObjectId ===
                                                        row.OBJECTID && (
                                                          <Popover
                                                            show={showPopover}
                                                            target={
                                                              IconAttachtarget.current
                                                            }
                                                          >
                                                            <Popover.Body>
                                                              {attachmentsContent}
                                                              <Form>
                                                                <Form.Group
                                                                  controlId="formFile"
                                                                  className="mb-3"
                                                                >
                                                                  <Form.Label>
                                                                    Upload
                                                                    Attachment
                                                                  </Form.Label>
                                                                  <Form.Control
                                                                    type="file"
                                                                    ref={
                                                                      fileInputRef
                                                                    }
                                                                    onChange={(e) =>
                                                                      handleFileChange(
                                                                        e.target
                                                                          .files
                                                                      )
                                                                    }
                                                                  />
                                                                </Form.Group>
                                                              </Form>
                                                              <Button
                                                                variant="primary"
                                                                onClick={() =>
                                                                  uploadAttachments(
                                                                    row.OBJECTID,
                                                                    true
                                                                  )
                                                                }
                                                              >
                                                                Add Attachment
                                                              </Button>
                                                            </Popover.Body>
                                                          </Popover>
                                                        )}
                                                    </>
                                                  </div>
                                                </td>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="12">{t("No data available")}</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {InvertebratescurrentRows && InvertebratescurrentRows.current &&
                              <AnimalSightingMobilePending
                                data={InvertebratescurrentRows}
                                className="mobileOnly"
                                t={t}
                                OrderFamilyNames={OrderFamilyNames}
                                SpeciesOrder={SpeciesOrder}
                                modalProps={modalProps}
                                IsDataModified={isDataModified}
                                GetFamilyDropdown={GetFamilyDropdown}
                                GetSpeciesDropdown={GetSpeciesDropdown}
                                DropdownFamilyValues={DropdownFamilyValues}
                                DropdownSpeciesValues={DropdownSpeciesValues}
                                domainValues={InsectsDomainValues[0]}
                                InsectsData={InsectsData}
                                commonProps={commonProps}
                                fullView={fullView}
                              />
                            }
                          </div>
                        </div>
                        {isEditing && editingRows.length > 0 && (
                          <div className="d-flex gap-2 panelfooter abs edit-footer">
                            <button
                              className="btn btn-outline"
                              onClick={handleCanceledting}
                            >
                              {t("cancel")}
                            </button>
                            <button
                              className="btn btn-primary"
                              onClick={() => handleSave()}
                            >
                              {t("save")}
                            </button>
                          </div>
                        )}
                      </TabPanel>
                    )
                  }
                  {
                    groupNames.includes(window.userGroups.plants) && (
                      <TabPanel>
                        <div className="pendingrecord-container">
                          <div className="animalFilterGrid animalFilterGrid--pending">
                            <h6 className="mb-3 mt-1 me-2" style={{ fontSize: '0.8rem' }}><b>{t('pendingPlants')}</b></h6>
                            <div className="gap5 animalFilterBlk">
                              <button
                                className={`btn btn-outline approvedrecord-button ${showfilter ? "active" : ""
                                  }`}
                                onClick={() => {
                                  isMobileView ? handleMobFilterShow() : onFilterClick()
                                }}
                                data-tooltip-content={t('filter')}
                                data-tooltip-id={`tooltip-filter`}
                                data-tooltip-place="bottom"
                              >
                                <span
                                  className="filter-text"
                                  ref={(el) => { if (el) elementInstances["span2"] = el; }}
                                  style={{
                                    color:
                                      theme === "dark"
                                        ? "#fff"
                                        : showfilter
                                          ? "#179075"
                                          : "#000",
                                  }}
                                >
                                  {t("filter")}
                                </span>
                                <BiFilterAlt className="filter-icon" size={15} title="Filter" />
                              </button>
                              {/* <Tooltip id={`tooltip-filter`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              {showfilter && (
                                <button
                                  className="btn clearfilter-btn ms-0"
                                  onClick={handleClarFilter}
                                >
                                  <span>{t("Clear Filters")}</span>
                                  <ImCancelCircle size={15} />
                                </button>
                              )}
                            </div>
                            <div className="gap5">
                              <button
                                className={`btn btn-outline ${activeButton === "approve" ? "active" : ""}`}
                                onClick={() => handleButtonClick("approve", ApproveFeatures)}
                                data-tooltip-content={t("Approve")}
                                data-tooltip-id={`tooltip-approve`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("Approve")}</span>
                                <LuCheck size={15} title="Approve" />
                              </button>
                              {/* <Tooltip id={`tooltip-approve`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "view" && activePendingtabs) ? "active" : ""}`}
                                onClick={() => {
                                  handleButtonClick("view", ViewFeatureonMap);
                                  if (fullView === "fullView") {
                                    onClose();
                                  }
                                }}
                                data-tooltip-content={t("view")}
                                data-tooltip-id={`tooltip-view`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("view")}</span>
                                <FiEye size={15} title="View" />
                              </button>
                              {/* <Tooltip id={`tooltip-view`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "clear" && activePendingtabs) ? "active" : ""}`}
                                onClick={() => handleButtonClick("clear", RefreshData)}
                              >{t("Clear")}
                              </button>
                              <button
                                className={`btn btn-outline ${(activeButton === "delete" && showModal) ? "active" : ""}`}
                                onClick={() => handleButtonClick("delete", handleDelete)}
                                data-tooltip-content={t("delete")}
                                data-tooltip-id={`tooltip-delete`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("delete")}</span>
                                <MdOutlineDelete size={15} title="Delete" />
                              </button>
                              {/* <Tooltip id={`tooltip-delete`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "edit" && isEditing) ? "active" : ""}`}
                                onClick={() => handleButtonClick("edit", handleEditSelectedRows)}
                                data-tooltip-content={t("edit")}
                                data-tooltip-id={`tooltip-edit`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("edit")}</span>
                                <FiEdit2 size={15} title="Edit" />
                              </button>
                              {/* <Tooltip id={`tooltip-edit`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "upload" && modalVisible) ? "active" : ""}`}
                                onClick={() => handleButtonClick("upload", handleBulkUploadClick)}
                                data-tooltip-content={t("Upload")}
                                data-tooltip-id={`tooltip-upload`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("Upload")}</span>
                                <FiUpload size={15} title="Upload" />
                              </button>
                              {/* <Tooltip id={`tooltip-upload`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            </div>

                            {modalVisible && (
                              <Modal show={modalVisible} centered size="sm">
                                <Modal.Body className="animalModalBody pb-0">
                                  <h5>{t("Upload File")}</h5>
                                  <Form>
                                    <Form.Group
                                      controlId="formFile"
                                      className="mb-3"
                                    >
                                      <Form.Control
                                        type="file"
                                        id="aniFileUpload-plants"
                                        ref={fileUploadRef}
                                        onChange={handleImportFileChange}
                                        accept=".xls,.xlsx"
                                      />
                                      <Form.Label for="aniFileUpload-plants" className="fileUploadCustomLabel">
                                        <div className="fileUploadBlk">
                                          <FiUpload size={20} className="mb-2" />
                                          <div className="my-2">
                                            {t("DragDrop")} <br />{t("Or")}<br />
                                            <span className="d-block fileUpBrowse">{t("BrowseFiles")}</span>
                                          </div>
                                          <div className="text-black-50">({t("uploadexcel")})</div>
                                        </div>
                                        {bulkfile.length > 0 && (
                                          <div className="selected-file">
                                            <span>{bulkfile[0].name}</span>
                                          </div>
                                        )}
                                      </Form.Label>
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>
                                <Modal.Footer className="border-0 animalModalFooter">
                                  <Button variant="outline flex-fill" onClick={handleModalClose}>
                                    {t("cancel")}
                                  </Button>
                                  <Button variant="primary flex-fill" onClick={handleImportFileSubmit}>
                                    {t("save")}
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            )}
                            {mobFilterShow &&
                              <Modal show={mobFilterShow} className="aniFilterModal" onHide={handleMobFilterClose} centered>
                                <Modal.Header closeButton>
                                  <Modal.Title>{t("filter")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className="aniMobFilterContent">
                                    <div>
                                      <>
                                        {(() => {
                                          // Define tabMappings to dynamically get currentRows based on activePendingtabs
                                          const tabMappings = {
                                            [t("Invertebrates")]: {
                                              currentRows: InvertebratescurrentRows,
                                              domainValues: InsectsDomainValues,
                                              displayAttributes: window.InvertiblesInfo.DisplayAttributes,
                                            },
                                            [t("Plants")]: {
                                              currentRows: PlantscurrentRows,
                                              domainValues: PlantsDomainValues,
                                              displayAttributes: window.PlantInfo.DisplayAttributes,
                                            },
                                            [t("Mammals")]: {
                                              currentRows: MammalscurrentRows,
                                              domainValues: MammalsDomainValues,
                                              displayAttributes: window.MammalsInfo.DisplayAttributes,
                                            },
                                            [t("Reptiles")]: {
                                              currentRows: ReptilescurrentRows,
                                              domainValues: ReptilesDomainValues,
                                              displayAttributes: window.ReptilesInfo.DisplayAttributes,
                                            },
                                          };

                                          // Dynamically get the currentRows and related data for the active tab
                                          const { currentRows, domainValues, displayAttributes } =
                                            tabMappings[activePendingtabs] || {};

                                          const formatKeyLabel = (key) => {
                                            // if (/^[A-Z0-9_]+$/.test(key)) {
                                            //   return key;
                                            // }
                                            const fixedLabels = {
                                              "point_x": "Point_X",
                                              "point_y": "Point_Y",
                                            };
                                            const lowerKey = key.toLowerCase();
                                            if (fixedLabels[lowerKey]) {
                                              return fixedLabels[lowerKey];
                                            }
                                            return key
                                              .replace(/_/g, ' ')                          // Replace underscores with spaces
                                              .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                                              .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                          };

                                          return (
                                            mobFilterShow &&
                                            currentRows &&
                                            currentRows.current &&
                                            currentRows.current[0] &&
                                            Object.keys(currentRows.current[0])
                                              .filter(
                                                (key) =>
                                                  key !== "OBJECTID" &&
                                                  key !== "id" &&
                                                  key !== "Status" &&
                                                  key !== "DataSource" &&
                                                  key !== "created_date" &&
                                                  key !== "GlobalID"
                                              )
                                              .map((key) => {
                                                const filteredAttributes = displayAttributes.filter(
                                                  (attr) =>
                                                    attr.AttrName !== "id" &&
                                                    attr.AttrName !== "SurveyDate" &&
                                                    attr.AttrName !== "OBJECTID" &&
                                                    attr.AttrName !== "Status" &&
                                                    attr.AttrName !== "DataSource" &&
                                                    attr.AttrName !== "GlobalID" &&
                                                    attr.AttrName !== "created_date" &&
                                                    attr.AttrName === key
                                                );

                                                return (
                                                  <div className="card-container mb-3" key={`${key}-filter`}>
                                                    <div className="card-row" key={key}>
                                                      {filteredAttributes.length > 0 &&
                                                        filteredAttributes[0].Domains === true ? (
                                                        <>
                                                          <label>{formatKeyLabel(key)}</label>
                                                          <Select
                                                            options={[
                                                              { value: "All", label: "All" },
                                                              ...(domainValues[0]?.[key]?.map((domain) => ({
                                                                value: domain.key,
                                                                label: domain.value,
                                                              })) || []),
                                                            ]}
                                                            value={
                                                              filters[key]
                                                                ? {
                                                                  value: filters[key],
                                                                  label: filters[key],
                                                                }
                                                                : {
                                                                  value: "All",
                                                                  label: "All",
                                                                }
                                                            }
                                                            onChange={(selectedOption) =>
                                                              handleMobFilterChange(
                                                                key,
                                                                selectedOption?.label || "All"
                                                              )
                                                            }
                                                            components={{
                                                              DropdownIndicator: CustomDropdownIndicator,
                                                            }}
                                                            className={`react-select-container`}
                                                            classNamePrefix="react-select"
                                                            placeholder={`Select ${key}`}
                                                          />
                                                        </>
                                                      ) : (
                                                        <div className="aniMobEditInputBlk">
                                                          <label>{formatKeyLabel(key)}</label>
                                                          <input
                                                            type="text"
                                                            value={filters[key] || ""}
                                                            className="form-control InputTextHolder"
                                                            onChange={(e) =>
                                                              handleMobFilterChange(key, e.target.value)
                                                            }
                                                          />
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                )
                                              })
                                          )
                                        })()}
                                      </>
                                    </div>
                                  </div>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="outline" onClick={handleMobFilterReset}>
                                    {t("reset")}
                                  </Button>
                                  <Button
                                    variant="primary"
                                    onClick={() => {
                                      setMobFilterShow(false);
                                      handleFilterApply();
                                    }}
                                  >
                                    {t("ApplyFilter")}
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                            }


                            {isResetBtnShow && (
                              <button
                                className="btn clearfilter-btn ms-0"
                                onClick={handleClarFilter}
                              >
                                <span>{t("Clear Filters")}</span>
                                <ImCancelCircle size={15} />
                              </button>
                            )}
                          </div>
                          <div className="table-responsive Animalapprovedtable">
                            <div className="TableScrollDiv desktopOnly">
                              <table
                                id="tblPlants"
                                ref={tableRefs["Plants"]}
                                className="table textwrap"
                                data-sort-asc="true"
                              >
                                <thead className="thead-dark">
                                  <tr>
                                    <th>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={
                                          PlantsSelectedRows.length > 0 &&
                                          PlantsSelectedRows.length === (PlantscurrentRows?.current || []).length
                                        }
                                        disabled={isEditing && editingRows.length > 0}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            const allRowIds = (PlantscurrentRows?.current || []).map(
                                              (row) => row.id // Assuming `id` is the unique identifier
                                            );
                                            setPlantsSelectedRows(allRowIds);
                                          } else {
                                            setPlantsSelectedRows([]);
                                          }
                                        }}
                                      />
                                    </th>
                                    {plantsheaders.map((key, index) => (
                                      <th key={key} onClick={() => sortTable(key, "tblPlants")}>{key}</th>
                                    ))}
                                  </tr>
                                  {showfilter && (
                                    <tr>
                                      <th></th>
                                      {PlantscurrentRows &&
                                        (PlantscurrentRows.current.length > 0 || window.PlantInfo.DisplayAttributes.length > 0) ? (
                                        (PlantscurrentRows.current.length > 0 ?
                                          Object.keys(
                                            PlantscurrentRows.current[0]) : window.PlantInfo.DisplayAttributes.map((attr) => attr.AttrName)
                                        ).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                          const filteredAttributes = window.PlantInfo.DisplayAttributes.filter(
                                            (attr) =>
                                              attr.AttrName !== "id" &&
                                              attr.AttrName !== "SurveyDate" &&
                                              attr.AttrName !== "OBJECTID" && attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                              attr.AttrName !== "created_date" &&
                                              attr.AttrName === key
                                          );
                                          return (
                                            <th key={`${key}-filter`}>
                                              {filteredAttributes.length > 0 &&
                                                filteredAttributes[0].Domains ===
                                                true ? (
                                                <Select
                                                  options={[
                                                    { value: "All", label: "All" },
                                                    ...(PlantsDomainValues[0]?.[
                                                      key
                                                    ]?.map((domain) => ({
                                                      value: domain.key,
                                                      label: domain.value,
                                                    })) || []),
                                                  ]}
                                                  value={
                                                    filters[key]
                                                      ? {
                                                        value: filters[key],
                                                        label: filters[key],
                                                      }
                                                      : {
                                                        value: "All",
                                                        label: "All",
                                                      }
                                                  }
                                                  onChange={(selectedOption) =>
                                                    handleFilterChange(
                                                      key,
                                                      selectedOption?.label || "All"
                                                    )
                                                  }
                                                  components={{
                                                    DropdownIndicator: CustomDropdownIndicator,
                                                  }}
                                                  className={`react-select-container`}
                                                  classNamePrefix="react-select"
                                                  placeholder={t("selectvalue", { attrName: key })}
                                                //placeholder={t(`Select ${key}`)}
                                                />
                                              ) : (
                                                <input
                                                  type="text"
                                                  value={filters[key] || ""}
                                                  onChange={(e) =>
                                                    handleFilterChange(
                                                      key,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              )}
                                            </th>
                                          );
                                        })
                                      ) : (
                                        <td colSpan={Object.keys(PlantscurrentRows.current[0] || {}).length}>
                                          {t('No data available')}
                                        </td>
                                      )}
                                    </tr>
                                  )}
                                </thead>
                                <tbody>
                                  {Array.isArray(PlantscurrentRows.current) ? (
                                    PlantscurrentRows.current.map((row) => (
                                      <tr key={row.id}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={PlantsSelectedRows.includes(
                                              row.id
                                            )}
                                            onChange={() =>
                                              handleRowSelection(row.id)
                                            }
                                            disabled={isEditing}
                                          />
                                        </td>
                                        <td style={{ display: "none" }} data-objectid={row.OBJECTID}>
                                          {row.OBJECTID}
                                        </td>
                                        {Object.keys(row).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                          const filteredAttributes = window.PlantInfo.DisplayAttributes.filter(
                                            (attr) =>
                                              attr.AttrName !== "id" &&
                                              attr.AttrName !== "created_date" && attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                              attr.AttrName === key
                                          );
                                          const domainValues =
                                            PlantsDomainValues[0][key] || [];
                                          return (
                                            <React.Fragment key={key}>
                                              <td>
                                                {isEditing &&
                                                  PlantsSelectedRows.includes(
                                                    row.id
                                                  ) &&
                                                  filteredAttributes.length > 0 ? (
                                                  filteredAttributes[0].Domains ===
                                                    false ? (
                                                    key === "SurveyDate" ||
                                                      key === "created_date" ? (
                                                      <div className="dateInputBlk">
                                                        <input
                                                          //ref={dateInputRef}
                                                          type="datetime-local"
                                                          className="form-control"
                                                          value={
                                                            editedRows[row.id]?.[
                                                              key
                                                            ] !== undefined
                                                              ? formatToDatetimeLocal(
                                                                editedRows[row.id][
                                                                key
                                                                ]
                                                              )
                                                              : formatToDatetimeLocal(
                                                                row[key]
                                                              )
                                                          }
                                                          max={new Date()
                                                            .toISOString()
                                                            .slice(0, 16)} // Restrict future dates
                                                          onChange={(e) =>
                                                            handleInputChange(
                                                              row.id,
                                                              key,
                                                              e.target.value
                                                            )
                                                          } // Handle datetime input change
                                                        />
                                                        <RxCalendar onClick={handleCalendarClick} />
                                                      </div>
                                                    ) : (
                                                      <input
                                                        type="text"
                                                        value={
                                                          editedRows[row.id]?.[
                                                            key
                                                          ] !== undefined // Check if value is defined
                                                            ? editedRows[row.id][
                                                            key
                                                            ]
                                                            : row[key]
                                                        }
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            row.id,
                                                            key,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    )
                                                  ) : (
                                                    <Select
                                                      options={domainValues.map(
                                                        (option) => ({
                                                          value: option.key,
                                                          label: option.value,
                                                        })
                                                      )}
                                                      value={
                                                        // row[key]
                                                        //   ? {
                                                        //     value: row[key],
                                                        //     label:
                                                        //       domainValues.find(
                                                        //         (option) =>
                                                        //           option.value ===
                                                        //           row[key]
                                                        //       )?.value ||
                                                        //       `Select ${key}`,
                                                        //   }
                                                        //   : null

                                                        row[key] !== undefined && row[key] !== null // ✅ Explicit check to allow 0
                                                          ? {
                                                            value: row[key],
                                                            label:
                                                              domainValues.find(option => option.value === row[key])?.value ??
                                                              `Select ${key}`,
                                                          }
                                                          : null
                                                      }
                                                      onChange={(selectedOption) =>
                                                        handleChange(
                                                          key,
                                                          selectedOption,
                                                          row
                                                        )
                                                      }
                                                      components={{
                                                        DropdownIndicator: CustomDropdownIndicator,
                                                      }}
                                                      className={`react-select-container`}
                                                      classNamePrefix="react-select"
                                                      placeholder={`Select ${key}`}
                                                    />
                                                  )
                                                ) : (
                                                  <div className="tableTxtTruncate">{row[key]}</div>
                                                )}
                                              </td>
                                              {key === "created_date" && (
                                                <td
                                                  colSpan={3}
                                                  valign="middle"
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <div className="col-md-12 popover-container">
                                                    <>
                                                      <img
                                                        src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                                        className="uploadicon mb-1"
                                                        ref={IconAttachtarget}
                                                        onClick={() =>
                                                          handleShow(row)
                                                        } // Show modal on click
                                                        alt="Attachment Icon"
                                                        style={{
                                                          cursor: "pointer",
                                                          width: "1.25rem",
                                                        }}
                                                      />
                                                      {showPopover &&
                                                        modalObjectId ===
                                                        row.OBJECTID && (
                                                          <Popover
                                                            show={showPopover}
                                                            target={
                                                              IconAttachtarget.current
                                                            }
                                                          >
                                                            <Popover.Body>
                                                              {attachmentsContent}
                                                              <Form>
                                                                <Form.Group
                                                                  controlId="formFile"
                                                                  className="mb-3"
                                                                >
                                                                  <Form.Label>
                                                                    Upload
                                                                    Attachment
                                                                  </Form.Label>
                                                                  <Form.Control
                                                                    type="file"
                                                                    ref={
                                                                      fileInputRef
                                                                    }
                                                                    onChange={(e) =>
                                                                      handleFileChange(
                                                                        e.target
                                                                          .files
                                                                      )
                                                                    }
                                                                  />
                                                                </Form.Group>
                                                              </Form>
                                                              <Button
                                                                variant="primary"
                                                                onClick={() =>
                                                                  uploadAttachments(
                                                                    row.OBJECTID,
                                                                    true
                                                                  )
                                                                }
                                                              >
                                                                Add Attachment
                                                              </Button>
                                                            </Popover.Body>
                                                          </Popover>
                                                        )}
                                                    </>
                                                  </div>
                                                </td>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="12">No data available</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>

                            </div>
                            <AnimalSightingMobilePending
                              data={PlantscurrentRows}
                              className="mobileOnly"
                              modalProps={modalProps}
                              t={t}
                              domainValues={PlantsDomainValues[0]}
                              OrderFamilyNames={OrderFamilyNames}
                              SpeciesOrder={SpeciesOrder}
                              IsDataModified={isDataModified}
                              GetFamilyDropdown={GetFamilyDropdown}
                              GetSpeciesDropdown={GetSpeciesDropdown}
                              DropdownFamilyValues={DropdownFamilyValues}
                              DropdownSpeciesValues={DropdownSpeciesValues}
                              commonProps={commonProps}
                              fullView={fullView}
                            />
                          </div>

                        </div>
                        {isEditing && editingRows.length > 0 && (
                          <div className="d-flex gap-2 panelfooter abs edit-footer">
                            <button
                              className="btn btn-outline"
                              onClick={handleCanceledting}
                            >
                              {t("cancel")}
                            </button>
                            <button
                              className="btn btn-primary"
                              onClick={() => handleSave()}
                            >
                              {t("save")}
                            </button>
                          </div>
                        )}
                      </TabPanel>
                    )
                  }
                  {
                    groupNames.includes(window.userGroups.mammals) && (
                      <TabPanel>
                        <div className="pendingrecord-container">
                          <div className="animalFilterGrid animalFilterGrid--pending">
                            <h6 className="mb-3 mt-1 me-2" style={{ fontSize: '0.8rem' }}><b>{t('pendingMammals')}</b></h6>
                            <div className="gap5 animalFilterBlk">
                              <button
                                className={`btn btn-outline approvedrecord-button ${showfilter ? "active" : ""
                                  }`}
                                onClick={() => {
                                  isMobileView ? handleMobFilterShow() : onFilterClick()
                                }}
                                data-tooltip-content={t('filter')}
                                data-tooltip-id={`tooltip-filter`}
                                data-tooltip-place="bottom"
                              >
                                <span
                                  className="filter-text"
                                  ref={(el) => { if (el) elementInstances["span3"] = el; }}
                                  style={{
                                    color:
                                      theme === "dark"
                                        ? "#fff"
                                        : showfilter
                                          ? "#179075"
                                          : "#000",
                                  }}
                                >
                                  {t("filter")}
                                </span>
                                <BiFilterAlt className="filter-icon" size={15} title="Filter" />
                              </button>
                              {/* <Tooltip id={`tooltip-filter`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              {showfilter && (
                                <button
                                  className="btn clearfilter-btn ms-0"
                                  onClick={handleClarFilter}
                                >
                                  <span>{t("Clear Filters")}</span>
                                  <ImCancelCircle size={15} />
                                </button>
                              )}
                            </div>
                            <div className="gap5">
                              <button
                                className={`btn btn-outline ${activeButton === "approve" ? "active" : ""}`}
                                onClick={() => handleButtonClick("approve", ApproveFeatures)}
                                data-tooltip-content={t("Approve")}
                                data-tooltip-id={`tooltip-approve`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("Approve")}</span>
                                <LuCheck size={15} title="Approve" />
                              </button>
                              {/* <Tooltip id={`tooltip-approve`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "view" && activePendingtabs) ? "active" : ""}`}
                                onClick={() => {
                                  handleButtonClick("view", ViewFeatureonMap);
                                  if (fullView === "fullView") {
                                    onClose();
                                  }
                                }}
                                data-tooltip-content={t("view")}
                                data-tooltip-id={`tooltip-view`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("view")}</span>
                                <FiEye size={15} title="View" />
                              </button>
                              {/* <Tooltip id={`tooltip-view`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "clear" && activePendingtabs) ? "active" : ""}`}
                                onClick={() => handleButtonClick("clear", RefreshData)}
                              >{t("Clear")}
                              </button>
                              <button
                                className={`btn btn-outline ${(activeButton === "delete" && showModal) ? "active" : ""}`}
                                onClick={() => handleButtonClick("delete", handleDelete)}
                                data-tooltip-content={t("delete")}
                                data-tooltip-id={`tooltip-delete`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("delete")}</span>
                                <MdOutlineDelete size={15} title="Delete" />
                              </button>
                              {/* <Tooltip id={`tooltip-delete`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "edit" && isEditing) ? "active" : ""}`}
                                onClick={() => handleButtonClick("edit", handleEditSelectedRows)}
                                data-tooltip-content={t("edit")}
                                data-tooltip-id={`tooltip-edit`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("edit")}</span>
                                <FiEdit2 size={15} title="Edit" />
                              </button>
                              {/* <Tooltip id={`tooltip-edit`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                              <button
                                className={`btn btn-outline ${(activeButton === "upload" && modalVisible) ? "active" : ""}`}
                                onClick={() => handleButtonClick("upload", handleBulkUploadClick)}
                                data-tooltip-content={t("Upload")}
                                data-tooltip-id={`tooltip-upload`}
                                data-tooltip-place="bottom"
                              >
                                <span>{t("Upload")}</span>
                                <FiUpload size={15} title="Upload" />
                              </button>
                              {/* <Tooltip id={`tooltip-upload`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            </div>

                            {modalVisible && (
                              <Modal show={modalVisible} centered size="sm">
                                <Modal.Body className="animalModalBody pb-0">
                                  <h5>{t("Upload File")}</h5>
                                  <Form>
                                    <Form.Group
                                      controlId="formFile"
                                      className="mb-3"
                                    >
                                      <Form.Control
                                        type="file"
                                        id="aniFileUpload-mam"
                                        ref={fileUploadRef}
                                        onChange={handleImportFileChange}
                                        accept=".xls,.xlsx"
                                      />
                                      <Form.Label for="aniFileUpload-mam" className="fileUploadCustomLabel">
                                        <div className="fileUploadBlk">
                                          <FiUpload size={20} className="mb-2" />
                                          <div className="my-2">
                                            {t("DragDrop")} <br />{t("Or")}<br />
                                            <span className="d-block fileUpBrowse">{t("BrowseFiles")}</span>
                                          </div>
                                          <div className="text-black-50">({t("uploadexcel")})</div>
                                        </div>
                                        {bulkfile.length > 0 && (
                                          <div className="selected-file">
                                            <span>{bulkfile[0].name}</span>
                                          </div>
                                        )}
                                      </Form.Label>
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>
                                <Modal.Footer className="border-0 animalModalFooter">
                                  <Button variant="outline flex-fill" onClick={handleModalClose}>
                                    {t("cancel")}
                                  </Button>
                                  <Button variant="primary flex-fill" onClick={handleImportFileSubmit}>
                                    {t("save")}
                                  </Button>
                                </Modal.Footer>
                              </Modal>
                            )}
                            {mobFilterShow &&
                              <Modal show={mobFilterShow} className="aniFilterModal" onHide={handleMobFilterClose} centered>
                                <Modal.Header closeButton>
                                  <Modal.Title>{t("filter")}</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className="aniMobFilterContent">
                                    <div>
                                      <>
                                        {(() => {
                                          // Define tabMappings to dynamically get currentRows based on activePendingtabs
                                          const tabMappings = {
                                            [t("Invertebrates")]: {
                                              currentRows: InvertebratescurrentRows,
                                              domainValues: InsectsDomainValues,
                                              displayAttributes: window.InvertiblesInfo.DisplayAttributes,
                                            },
                                            [t("Plants")]: {
                                              currentRows: PlantscurrentRows,
                                              domainValues: PlantsDomainValues,
                                              displayAttributes: window.PlantInfo.DisplayAttributes,
                                            },
                                            [t("Mammals")]: {
                                              currentRows: MammalscurrentRows,
                                              domainValues: MammalsDomainValues,
                                              displayAttributes: window.MammalsInfo.DisplayAttributes,
                                            },
                                            [t("Reptiles")]: {
                                              currentRows: ReptilescurrentRows,
                                              domainValues: ReptilesDomainValues,
                                              displayAttributes: window.ReptilesInfo.DisplayAttributes,
                                            },
                                          };

                                          // Dynamically get the currentRows and related data for the active tab
                                          const { currentRows, domainValues, displayAttributes } =
                                            tabMappings[activePendingtabs] || {};

                                          const formatKeyLabel = (key) => {
                                            // if (/^[A-Z0-9_]+$/.test(key)) {
                                            //   return key;
                                            // }
                                            const fixedLabels = {
                                              "point_x": "Point_X",
                                              "point_y": "Point_Y",
                                            };
                                            const lowerKey = key.toLowerCase();
                                            if (fixedLabels[lowerKey]) {
                                              return fixedLabels[lowerKey];
                                            }
                                            return key
                                              .replace(/_/g, ' ')                          // Replace underscores with spaces
                                              .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                                              .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                          };

                                          return (
                                            mobFilterShow &&
                                            currentRows &&
                                            currentRows.current &&
                                            currentRows.current[0] &&
                                            Object.keys(currentRows.current[0] || originalData)
                                              .filter(
                                                (key) =>
                                                  key !== "OBJECTID" &&
                                                  key !== "id" &&
                                                  key !== "Status" &&
                                                  key !== "DataSource" &&
                                                  key !== "created_date" &&
                                                  key !== "GlobalID"
                                              )
                                              .map((key) => {
                                                const filteredAttributes = displayAttributes.filter(
                                                  (attr) =>
                                                    attr.AttrName !== "id" &&
                                                    attr.AttrName !== "SurveyDate" &&
                                                    attr.AttrName !== "OBJECTID" &&
                                                    attr.AttrName !== "Status" &&
                                                    attr.AttrName !== "DataSource" &&
                                                    attr.AttrName !== "GlobalID" &&
                                                    attr.AttrName !== "created_date" &&
                                                    attr.AttrName === key
                                                );

                                                return (
                                                  <div className="card-container mb-3" key={`${key}-filter`}>
                                                    <div className="card-row" key={key}>
                                                      {filteredAttributes.length > 0 &&
                                                        filteredAttributes[0].Domains === true ? (
                                                        <>
                                                          <label>{formatKeyLabel(key)}</label>
                                                          <Select
                                                            options={[
                                                              { value: "All", label: "All" },
                                                              ...(domainValues[0]?.[key]?.map((domain) => ({
                                                                value: domain.key,
                                                                label: domain.value,
                                                              })) || []),
                                                            ]}
                                                            value={
                                                              filters[key]
                                                                ? {
                                                                  value: filters[key],
                                                                  label: filters[key],
                                                                }
                                                                : {
                                                                  value: "All",
                                                                  label: "All",
                                                                }
                                                            }
                                                            onChange={(selectedOption) =>
                                                              handleMobFilterChange(
                                                                key,
                                                                selectedOption?.label || "All"
                                                              )
                                                            }
                                                            components={{
                                                              DropdownIndicator: CustomDropdownIndicator,
                                                            }}
                                                            className={`react-select-container`}
                                                            classNamePrefix="react-select"
                                                            placeholder={`Select ${key}`}
                                                          />
                                                        </>
                                                      ) : (
                                                        <div className="aniMobEditInputBlk">
                                                          <label>{formatKeyLabel(key)}</label>
                                                          <input
                                                            type="text"
                                                            value={filters[key] || ""}
                                                            className="form-control InputTextHolder"
                                                            onChange={(e) =>
                                                              handleMobFilterChange(key, e.target.value)
                                                            }
                                                          />
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                )
                                              })
                                          )
                                        })()}
                                      </>
                                    </div>
                                  </div>
                                </Modal.Body>
                                <Modal.Footer>
                                  <Button variant="outline" onClick={handleMobFilterReset}>
                                    {t("reset")}
                                  </Button>
                                  <Button
                                    variant="primary"
                                    onClick={() => {
                                      setMobFilterShow(false);
                                      handleFilterApply();
                                    }}
                                  >
                                    {t("ApplyFilter")}
                                  </Button>
                                </Modal.Footer>
                              </Modal>

                            }

                            {isResetBtnShow && (
                              <button
                                className="btn clearfilter-btn ms-0"
                                onClick={handleClarFilter}
                              >
                                <span>{t("Clear Filters")}</span>
                                <ImCancelCircle size={15} />
                              </button>
                            )}
                          </div>
                          <div className="table-responsive Animalapprovedtable">
                            <div className="TableScrollDiv desktopOnly">
                              <table id="tblMammals" ref={tableRefs["Mammals"]} className="table textwrap" data-sort-asc="true">
                                <thead className="thead-dark">
                                  <tr>
                                    <th>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        checked={
                                          MammalsSelectedRows.length > 0 &&
                                          MammalsSelectedRows.length === (MammalscurrentRows?.current || []).length
                                        }
                                        disabled={isEditing && editingRows.length > 0}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            const allRowIds = (MammalscurrentRows?.current || []).map(
                                              (row) => row.id // Assuming `id` is the unique identifier
                                            );
                                            setMammalsSelectedRows(allRowIds);
                                          } else {
                                            setMammalsSelectedRows([]);
                                          }
                                        }}
                                      />
                                    </th>
                                    {mammalsheaders.map((key, index) => (
                                      <th key={key} onClick={() => sortTable(key, "tblMammals")}>{key}</th>
                                    ))}
                                  </tr>
                                  {showfilter && (
                                    <tr>
                                      <th></th>
                                      {MammalscurrentRows &&
                                        (MammalscurrentRows.current.length > 0 || window.MammalsInfo.DisplayAttributes.length > 0) ? (
                                        (MammalscurrentRows.current.length > 0 ?
                                          Object.keys(
                                            MammalscurrentRows.current[0]) : window.MammalsInfo.DisplayAttributes.map((attr) => attr.AttrName)
                                        ).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                          const filteredAttributes = window.MammalsInfo.DisplayAttributes.filter(
                                            (attr) =>
                                              attr.AttrName !== "id" &&
                                              attr.AttrName !== "SurveyDate" &&
                                              attr.AttrName !== "OBJECTID" && attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                              attr.AttrName !== "created_date" &&
                                              attr.AttrName === key
                                          );
                                          return (
                                            <th key={`${key}-filter`}>
                                              {filteredAttributes.length > 0 &&
                                                filteredAttributes[0].Domains ===
                                                true ? (
                                                <Select
                                                  options={[
                                                    { value: "All", label: "All" },
                                                    ...(MammalsDomainValues[0]?.[
                                                      key
                                                    ]?.map((domain) => ({
                                                      value: domain.key,
                                                      label: domain.value,
                                                    })) || []),
                                                  ]}
                                                  value={
                                                    filters[key]
                                                      ? {
                                                        value: filters[key],
                                                        label: filters[key],
                                                      }
                                                      : {
                                                        value: "All",
                                                        label: "All",
                                                      }
                                                  }
                                                  onChange={(selectedOption) =>
                                                    handleFilterChange(
                                                      key,
                                                      selectedOption?.label || "All"
                                                    )
                                                  }
                                                  components={{
                                                    DropdownIndicator: CustomDropdownIndicator,
                                                  }}
                                                  className={`react-select-container`}
                                                  classNamePrefix="react-select"
                                                  placeholder={t("selectvalue", { attrName: key })}
                                                //placeholder={t(`Select ${key}`)}
                                                />
                                              ) : (
                                                <input
                                                  type="text"
                                                  value={filters[key] || ""}
                                                  onChange={(e) =>
                                                    handleFilterChange(
                                                      key,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              )}
                                            </th>
                                          );
                                        })
                                      ) : (
                                        <td colSpan={Object.keys(MammalscurrentRows.current[0] || {}).length}>
                                          {t('No data available')}
                                        </td>
                                      )}
                                    </tr>
                                  )}
                                </thead>
                                <tbody>
                                  {Array.isArray(MammalscurrentRows.current) ? (
                                    MammalscurrentRows.current.map((row) => (
                                      <tr key={row.id}>
                                        <td>
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={MammalsSelectedRows.includes(
                                              row.id
                                            )}
                                            onChange={() =>
                                              handleRowSelection(row.id)
                                            }
                                            disabled={isEditing}
                                          />
                                        </td>
                                        <td style={{ display: "none" }} data-objectid={row.OBJECTID}>
                                          {row.OBJECTID}
                                        </td>
                                        {Object.keys(row).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                          const filteredAttributes = window.MammalsInfo.DisplayAttributes.filter(
                                            (attr) =>
                                              attr.AttrName !== "id" &&
                                              attr.AttrName !== "created_date" &&
                                              attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                              attr.AttrName === key
                                          );
                                          let domainValues = [];
                                          if (key === "SpeciesName") {
                                            const matchingOrder = MammalsDomainValues[0].Species?.find(
                                              (order) =>
                                                order.value === row["Species"]
                                            );
                                            if (matchingOrder) {
                                              domainValues =
                                                MammalsSpeciesNames.find(
                                                  (item) =>
                                                    item.Species ===
                                                    matchingOrder.value
                                                )?.SpeciesNames || [];
                                            }
                                          } else {
                                            domainValues =
                                              MammalsDomainValues[0][key] || [];
                                          }
                                          return (
                                            <React.Fragment key={key}>
                                              <td>
                                                {isEditing &&
                                                  MammalsSelectedRows.includes(
                                                    row.id
                                                  ) &&
                                                  filteredAttributes.length > 0 ? (
                                                  filteredAttributes[0].Domains ===
                                                    false ? (
                                                    key === "SurveyDate" ||
                                                      key === "created_date" ? (
                                                      <div className="dateInputBlk">
                                                        <input
                                                          //ref={dateInputRef}
                                                          type="datetime-local"
                                                          className="form-control"
                                                          value={
                                                            editedRows[row.id]?.[
                                                              key
                                                            ] !== undefined
                                                              ? formatToDatetimeLocal(
                                                                editedRows[row.id][
                                                                key
                                                                ]
                                                              )
                                                              : formatToDatetimeLocal(
                                                                row[key]
                                                              )
                                                          }
                                                          max={new Date()
                                                            .toISOString()
                                                            .slice(0, 16)} // Restrict future dates
                                                          onChange={(e) =>
                                                            handleInputChange(
                                                              row.id,
                                                              key,
                                                              e.target.value
                                                            )
                                                          } // Handle datetime input change
                                                        />
                                                        <RxCalendar onClick={handleCalendarClick} />
                                                      </div>
                                                    ) : (
                                                      <input
                                                        type="text"
                                                        value={
                                                          editedRows[row.id]?.[
                                                            key
                                                          ] !== undefined // Check if value is defined
                                                            ? editedRows[row.id][
                                                            key
                                                            ]
                                                            : row[key]
                                                        }
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            row.id,
                                                            key,
                                                            e.target.value
                                                          )
                                                        }
                                                      />
                                                    )
                                                  ) : key === "Species" ? (
                                                    <Select
                                                      options={domainValues.map(
                                                        (option) => ({
                                                          value: option.key,
                                                          label: option.value,
                                                        })
                                                      )}
                                                      value={
                                                        row.Species
                                                          ? {
                                                            value: row.Species,
                                                            label:
                                                              domainValues.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  row.Species
                                                              )?.value ||
                                                              `Select ${key}`,
                                                          }
                                                          : null
                                                      }
                                                      onChange={(selectedOption) =>
                                                        handleMammalsSpeciesChange(
                                                          selectedOption,
                                                          row
                                                        )
                                                      }
                                                      components={{
                                                        DropdownIndicator: CustomDropdownIndicator,
                                                      }}
                                                      className={`react-select-container`}
                                                      classNamePrefix="react-select"
                                                      placeholder={t(
                                                        "Select Family"
                                                      )}
                                                    />
                                                  ) : (
                                                    <Select
                                                      options={domainValues.map(
                                                        (option) => ({
                                                          value: option.key,
                                                          label: option.value,
                                                        })
                                                      )}
                                                      value={
                                                        row[key]
                                                          ? {
                                                            value: row[key],
                                                            label:
                                                              domainValues.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  row[key]
                                                              )?.value ||
                                                              `Select ${key}`,
                                                          }
                                                          : null
                                                      }
                                                      onChange={(selectedOption) =>
                                                        handleChange(
                                                          key,
                                                          selectedOption,
                                                          row
                                                        )
                                                      }
                                                      components={{
                                                        DropdownIndicator: CustomDropdownIndicator,
                                                      }}
                                                      className={`react-select-container`}
                                                      classNamePrefix="react-select"
                                                      placeholder={`Select ${key}`}
                                                    />
                                                  )
                                                ) : (
                                                  <div className="tableTxtTruncate">{row[key]}</div>
                                                )}
                                              </td>
                                              {key === "created_date" && (
                                                <td
                                                  colSpan={3}
                                                  valign="middle"
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <div className="col-md-12 popover-container">
                                                    <img
                                                      src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                                      className="uploadicon mb-1"
                                                      ref={IconAttachtarget}
                                                      onClick={() =>
                                                        handleShow(row)
                                                      }
                                                      alt="Attachment Icon"
                                                      style={{
                                                        cursor: "pointer",
                                                        width: "1.25rem",
                                                      }}
                                                    />
                                                    {showPopover &&
                                                      modalObjectId ===
                                                      row.OBJECTID && (
                                                        <Popover
                                                          show={showPopover}
                                                          target={
                                                            IconAttachtarget.current
                                                          }
                                                          placement="right"
                                                        >
                                                          <Popover.Body>
                                                            {attachmentsContent}
                                                            <Form>
                                                              <Form.Group
                                                                controlId="formFile"
                                                                className="mb-3"
                                                              >
                                                                <Form.Label>
                                                                  Upload Attachment
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="file"
                                                                  ref={fileInputRef}
                                                                  onChange={(e) =>
                                                                    handleFileChange(
                                                                      e.target.files
                                                                    )
                                                                  }
                                                                />
                                                              </Form.Group>
                                                            </Form>
                                                            <Button
                                                              variant="primary"
                                                              onClick={() =>
                                                                uploadAttachments(
                                                                  row.OBJECTID,
                                                                  true
                                                                )
                                                              }
                                                            >
                                                              Add Attachment
                                                            </Button>
                                                          </Popover.Body>
                                                        </Popover>
                                                      )}
                                                  </div>
                                                </td>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="12">No data available</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>

                            </div>
                            <AnimalSightingMobilePending
                              data={MammalscurrentRows}
                              className="mobileOnly"
                              modalProps={modalProps}
                              t={t}
                              // InsectsData={InsectsData}
                              IsDataModified={isDataModified}
                              OrderFamilyNames={OrderFamilyNames}
                              SpeciesOrder={SpeciesOrder}
                              GetFamilyDropdown={GetFamilyDropdown}
                              GetSpeciesDropdown={GetMammalsSpeciesDropdown}
                              DropdownFamilyValues={DropdownFamilyValues}
                              DropdownSpeciesValues={DropdownMammalsSpeciesNames}
                              domainValues={MammalsDomainValues[0]}
                              commonProps={commonProps}
                              fullView={fullView}
                            />
                          </div>

                        </div>
                        {isEditing && editingRows.length > 0 && (
                          <div className="d-flex gap-2 panelfooter abs edit-footer">
                            <button
                              className="btn btn-outline"
                              onClick={handleCanceledting}
                            >
                              {t("cancel")}
                            </button>
                            <button
                              className="btn btn-primary"
                              onClick={() => handleSave()}
                            >
                              {t("save")}
                            </button>
                          </div>
                        )}
                      </TabPanel>
                    )
                  }
                  {groupNames.includes(window.userGroups.reptiles) && (
                    <TabPanel>
                      <div className="pendingrecord-container">
                        <div className="animalFilterGrid animalFilterGrid--pending">
                          <h6 className="mb-3 mt-1 me-2" style={{ fontSize: '0.8rem' }}><b>{t('pendingReptiles')}</b></h6>
                          <div className="gap5 animalFilterBlk">
                            <button
                              className={`btn btn-outline approvedrecord-button ${showfilter ? "active" : ""
                                }`}
                              onClick={() => {
                                isMobileView ? handleMobFilterShow() : onFilterClick()
                              }}
                              data-tooltip-content={t('filter')}
                              data-tooltip-id={`tooltip-filter`}
                              data-tooltip-place="bottom"
                            >
                              <span
                                className="filter-text"
                                ref={(el) => { if (el) elementInstances["span4"] = el; }}
                                style={{
                                  color:
                                    theme === "dark"
                                      ? "#fff"
                                      : showfilter
                                        ? "#179075"
                                        : "#000",
                                }}
                              >
                                {t("filter")}
                              </span>
                              <BiFilterAlt className="filter-icon" size={15} title="Filter" />
                            </button>
                            {/* <Tooltip id={`tooltip-filter`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            {showfilter && (
                              <button
                                className="btn clearfilter-btn ms-0"
                                onClick={handleClarFilter}
                              >
                                <span>{t("Clear Filters")}</span>
                                <ImCancelCircle size={15} />
                              </button>
                            )}
                          </div>
                          <div className="gap5">
                            <button
                              className={`btn btn-outline ${activeButton === "approve" ? "active" : ""}`}
                              onClick={() => handleButtonClick("approve", ApproveFeatures)}
                              data-tooltip-content={t("Approve")}
                              data-tooltip-id={`tooltip-approve`}
                              data-tooltip-place="bottom"
                            >
                              <span>{t("Approve")}</span>
                              <LuCheck size={15} title="Approve" />
                            </button>
                            {/* <Tooltip id={`tooltip-approve`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            <button
                              className={`btn btn-outline ${(activeButton === "view" && activePendingtabs) ? "active" : ""}`}
                              onClick={() => {
                                handleButtonClick("view", ViewFeatureonMap);
                                if (fullView === "fullView") {
                                  onClose();
                                }
                              }}
                              data-tooltip-content={t("view")}
                              data-tooltip-id={`tooltip-view`}
                              data-tooltip-place="bottom"
                            >
                              <span>{t("view")}</span>
                              <FiEye size={15} title="View" />
                            </button>
                            {/* <Tooltip id={`tooltip-view`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            <button
                              className={`btn btn-outline ${(activeButton === "clear" && activePendingtabs) ? "active" : ""}`}
                              onClick={() => handleButtonClick("clear", RefreshData)}
                            >{t("Clear")}
                            </button>
                            <button
                              className={`btn btn-outline ${(activeButton === "delete" && showModal) ? "active" : ""}`}
                              onClick={() => handleButtonClick("delete", handleDelete)}
                              data-tooltip-content={t("delete")}
                              data-tooltip-id={`tooltip-delete`}
                              data-tooltip-place="bottom"
                            >
                              <span>{t("delete")}</span>
                              <MdOutlineDelete size={15} title="Delete" />
                            </button>
                            {/* <Tooltip id={`tooltip-delete`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            <button
                              className={`btn btn-outline ${(activeButton === "edit" && isEditing) ? "active" : ""}`}
                              onClick={() => handleButtonClick("edit", handleEditSelectedRows)}
                              data-tooltip-content={t("edit")}
                              data-tooltip-id={`tooltip-edit`}
                              data-tooltip-place="bottom"
                            >
                              <span>{t("edit")}</span>
                              <FiEdit2 size={15} title="Edit" />
                            </button>
                            {/* <Tooltip id={`tooltip-edit`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                            <button
                              className={`btn btn-outline ${(activeButton === "upload" && modalVisible) ? "active" : ""}`}
                              onClick={() => handleButtonClick("upload", handleBulkUploadClick)}
                              data-tooltip-content={t("Upload")}
                              data-tooltip-id={`tooltip-upload`}
                              data-tooltip-place="bottom"
                            >
                              <span>{t("Upload")}</span>
                              <FiUpload size={15} title="Upload" />
                            </button>
                            {/* <Tooltip id={`tooltip-upload`} className="ToolTipEnvi" border="1px solid #2d787f" /> */}
                          </div>

                          {modalVisible && (
                            <Modal show={modalVisible} centered size="sm">
                              <Modal.Body className="animalModalBody pb-0">
                                <h5>{t("Upload File")}</h5>
                                <Form>
                                  <Form.Group
                                    controlId="formFile"
                                    className="mb-3"
                                  >
                                    <Form.Control
                                      type="file"
                                      id="aniFileUpload-rep"
                                      ref={fileUploadRef}
                                      onChange={handleImportFileChange}
                                      accept=".xls,.xlsx"
                                    />
                                    <Form.Label for="aniFileUpload-rep" className="fileUploadCustomLabel">
                                      <div className="fileUploadBlk">
                                        <FiUpload size={20} className="mb-2" />
                                        <div className="my-2">
                                          {t("DragDrop")} <br />{t("Or")}<br />
                                          <span className="d-block fileUpBrowse">{t("BrowseFiles")}</span>
                                        </div>
                                        <div className="text-black-50">({t("uploadexcel")})</div>
                                        {/* <div className="text-black-50">(.jpeg or .mp4 with max size 10 mb)</div> */}
                                      </div>
                                      {bulkfile.length > 0 && (
                                        <div className="selected-file">
                                          <span>{bulkfile[0].name}</span>
                                        </div>
                                      )}
                                    </Form.Label>
                                  </Form.Group>
                                </Form>
                              </Modal.Body>
                              <Modal.Footer className="border-0 animalModalFooter">
                                <Button variant="outline flex-fill" onClick={handleModalClose}>
                                  {t("cancel")}
                                </Button>
                                <Button variant="primary flex-fill" onClick={handleImportFileSubmit}>
                                  {t("save")}
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          )}
                          {mobFilterShow &&
                            <Modal show={mobFilterShow} className="aniFilterModal" onHide={handleMobFilterClose} centered>
                              <Modal.Header closeButton>
                                <Modal.Title>{t("filter")}</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="aniMobFilterContent">
                                  <div>
                                    <>
                                      {(() => {
                                        // Define tabMappings to dynamically get currentRows based on activePendingtabs
                                        const tabMappings = {
                                          [t("Invertebrates")]: {
                                            currentRows: InvertebratescurrentRows,
                                            domainValues: InsectsDomainValues,
                                            displayAttributes: window.InvertiblesInfo.DisplayAttributes,
                                          },
                                          [t("Plants")]: {
                                            currentRows: PlantscurrentRows,
                                            domainValues: PlantsDomainValues,
                                            displayAttributes: window.PlantInfo.DisplayAttributes,
                                          },
                                          [t("Mammals")]: {
                                            currentRows: MammalscurrentRows,
                                            domainValues: MammalsDomainValues,
                                            displayAttributes: window.MammalsInfo.DisplayAttributes,
                                          },
                                          [t("Reptiles")]: {
                                            currentRows: ReptilescurrentRows,
                                            domainValues: ReptilesDomainValues,
                                            displayAttributes: window.ReptilesInfo.DisplayAttributes,
                                          },
                                        };

                                        // Dynamically get the currentRows and related data for the active tab
                                        const { currentRows, domainValues, displayAttributes } =
                                          tabMappings[activePendingtabs] || {};

                                        const formatKeyLabel = (key) => {
                                          // if (/^[A-Z0-9_]+$/.test(key)) {
                                          //   return key;
                                          // }
                                          const fixedLabels = {
                                            "point_x": "Point_X",
                                            "point_y": "Point_Y",
                                          };
                                          const lowerKey = key.toLowerCase();
                                          if (fixedLabels[lowerKey]) {
                                            return fixedLabels[lowerKey];
                                          }
                                          return key
                                            .replace(/_/g, ' ')                          // Replace underscores with spaces
                                            .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                                            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                                        };

                                        return (
                                          mobFilterShow &&
                                          currentRows &&
                                          currentRows.current &&
                                          currentRows.current[0] &&
                                          Object.keys(currentRows.current[0] || originalData)
                                            .filter(
                                              (key) =>
                                                key !== "OBJECTID" &&
                                                key !== "id" &&
                                                key !== "Status" &&
                                                key !== "DataSource" &&
                                                key !== "created_date" &&
                                                key !== "GlobalID"
                                            )
                                            .map((key) => {
                                              const filteredAttributes = displayAttributes.filter(
                                                (attr) =>
                                                  attr.AttrName !== "id" &&
                                                  attr.AttrName !== "SurveyDate" &&
                                                  attr.AttrName !== "OBJECTID" &&
                                                  attr.AttrName !== "Status" &&
                                                  attr.AttrName !== "DataSource" &&
                                                  attr.AttrName !== "GlobalID" &&
                                                  attr.AttrName !== "created_date" &&
                                                  attr.AttrName === key
                                              );

                                              return (
                                                <div className="card-container mb-3" key={`${key}-filter`}>
                                                  <div className="card-row" key={key}>
                                                    {filteredAttributes.length > 0 &&
                                                      filteredAttributes[0].Domains === true ? (
                                                      <>
                                                        <label>{formatKeyLabel(key)}</label>
                                                        <Select
                                                          options={[
                                                            { value: "All", label: "All" },
                                                            ...(domainValues[0]?.[key]?.map((domain) => ({
                                                              value: domain.key,
                                                              label: domain.value,
                                                            })) || []),
                                                          ]}
                                                          value={
                                                            filters[key]
                                                              ? {
                                                                value: filters[key],
                                                                label: filters[key],
                                                              }
                                                              : {
                                                                value: "All",
                                                                label: "All",
                                                              }
                                                          }
                                                          onChange={(selectedOption) =>
                                                            handleMobFilterChange(
                                                              key,
                                                              selectedOption?.label || "All"
                                                            )
                                                          }
                                                          components={{
                                                            DropdownIndicator: CustomDropdownIndicator,
                                                          }}
                                                          className={`react-select-container`}
                                                          classNamePrefix="react-select"
                                                          placeholder={`Select ${key}`}
                                                        />
                                                      </>
                                                    ) : (
                                                      <div className="aniMobEditInputBlk">
                                                        <label>{formatKeyLabel(key)}</label>
                                                        <input
                                                          type="text"
                                                          value={filters[key] || ""}
                                                          className="form-control InputTextHolder"
                                                          onChange={(e) =>
                                                            handleMobFilterChange(key, e.target.value)
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              )
                                            })
                                        )
                                      })()}
                                    </>
                                  </div>
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="outline" onClick={handleMobFilterReset}>
                                  {t("reset")}
                                </Button>
                                <Button
                                  variant="primary"
                                  onClick={() => {
                                    setMobFilterShow(false);
                                    handleFilterApply();
                                  }}
                                >
                                  {t("ApplyFilter")}
                                </Button>
                              </Modal.Footer>
                            </Modal>

                          }


                          {isResetBtnShow && (
                            <button
                              className="btn clearfilter-btn ms-0"
                              onClick={handleClarFilter}
                            >
                              <span>{t("Clear Filters")}</span>
                              <ImCancelCircle size={15} />
                            </button>
                          )}
                        </div>
                        <div className="table-responsive Animalapprovedtable">
                          <div className="TableScrollDiv desktopOnly">
                            <table id="tblReptiles" ref={tableRefs["Reptiles"]} className="table textwrap" data-sort-asc="true">
                              <thead className="thead-dark">
                                <tr>
                                  <th>
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      checked={
                                        ReptilesSelectedRows.length > 0 &&
                                        ReptilesSelectedRows.length === (ReptilescurrentRows?.current || []).length
                                      }
                                      disabled={isEditing && editingRows.length > 0}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          const allRowIds = (ReptilescurrentRows?.current || []).map(
                                            (row) => row.id // Assuming `id` is the unique identifier
                                          );
                                          setReptilesSelectedRows(allRowIds);
                                        } else {
                                          setReptilesSelectedRows([]);
                                        }
                                      }}
                                    />
                                  </th>
                                  {reptilesheaders.map((key, index) => (
                                    <th key={key} onClick={() => sortTable(key, "tblReptiles")}>{key}</th>
                                  ))}
                                </tr>
                                {showfilter && (
                                  <tr>
                                    <th></th>
                                    {ReptilescurrentRows &&
                                      (ReptilescurrentRows.current.length > 0 || window.ReptilesInfo.DisplayAttributes.length > 0) ? (
                                      (ReptilescurrentRows.current.length > 0 ?
                                        Object.keys(
                                          ReptilescurrentRows.current[0]) : window.ReptilesInfo.DisplayAttributes.map((attr) => attr.AttrName)
                                      ).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                        const filteredAttributes = window.ReptilesInfo.DisplayAttributes.filter(
                                          (attr) =>
                                            attr.AttrName !== "id" &&
                                            attr.AttrName !== "ObservationDate" &&
                                            attr.AttrName !== "OBJECTID" &&
                                            attr.AttrName !== "created_date" && attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                            attr.AttrName === key
                                        );
                                        return (
                                          <th key={`${key}-filter`}>
                                            {filteredAttributes.length > 0 &&
                                              filteredAttributes[0].Domains ===
                                              true ? (
                                              <Select
                                                options={[
                                                  { value: "All", label: "All" },
                                                  ...(ReptilesDomainValues[0]?.[
                                                    key
                                                  ]?.map((domain) => ({
                                                    value: domain.key,
                                                    label: domain.value,
                                                  })) || []),
                                                ]}
                                                value={
                                                  filters[key]
                                                    ? {
                                                      value: filters[key],
                                                      label: filters[key],
                                                    }
                                                    : {
                                                      value: "All",
                                                      label: "All",
                                                    }
                                                }
                                                onChange={(selectedOption) =>
                                                  handleFilterChange(
                                                    key,
                                                    selectedOption?.label || "All"
                                                  )
                                                }
                                                components={{
                                                  DropdownIndicator: CustomDropdownIndicator,
                                                }}
                                                className={`react-select-container`}
                                                classNamePrefix="react-select"
                                                placeholder={t("selectvalue", { attrName: key })}
                                              //placeholder={t(`Select ${key}`)}
                                              />
                                            ) : (
                                              <input
                                                type="text"
                                                value={filters[key] || ""}
                                                onChange={(e) =>
                                                  handleFilterChange(
                                                    key,
                                                    e.target.value
                                                  )
                                                }
                                              />
                                            )}
                                          </th>
                                        );
                                      })
                                    ) : (
                                      <td colSpan={Object.keys(InvertebratescurrentRows.current[0] || {}).length}>
                                        {t('No data available')}
                                      </td>
                                    )}
                                  </tr>
                                )}
                              </thead>
                              <tbody>
                                {Array.isArray(ReptilescurrentRows.current) ? (
                                  ReptilescurrentRows.current.map((row) => (
                                    <tr key={row.id}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={ReptilesSelectedRows.includes(
                                            row.id
                                          )}
                                          onChange={() =>
                                            handleRowSelection(row.id)
                                          }
                                          disabled={isEditing}
                                        />
                                      </td>
                                      <td style={{ display: "none" }} data-objectid={row.OBJECTID}>
                                        {row.OBJECTID}
                                      </td>
                                      {Object.keys(row).filter((key) => key !== "OBJECTID" && key != "id" && key !== "Status" && key !== "DataSource" && key !== "GlobalID").map((key) => {
                                        const filteredAttributes = window.ReptilesInfo.DisplayAttributes.filter(
                                          (attr) =>
                                            attr.AttrName !== "id" &&
                                            attr.AttrName !== "created_date" &&
                                            attr.AttrName !== "Status" && attr.AttrName !== "DataSource" && attr.AttrName !== "GlobalID" &&
                                            attr.AttrName === key
                                        );
                                        let domainValues = [];
                                        if (key === "Species") {
                                          const matchingOrder = ReptilesDomainValues[0].Reptiles?.find(
                                            (order) =>
                                              order.value === row["Reptiles"]
                                          );
                                          if (matchingOrder) {
                                            domainValues =
                                              ReptilesSpeciesNames.find(
                                                (item) =>
                                                  item.Reptile ===
                                                  matchingOrder.value
                                              )?.Species || [];
                                          }
                                        } else {
                                          domainValues =
                                            ReptilesDomainValues[0][key] || [];
                                        }
                                        return (
                                          <React.Fragment key={key}>
                                            <td>
                                              {isEditing &&
                                                ReptilesSelectedRows.includes(
                                                  row.id
                                                ) &&
                                                filteredAttributes.length > 0 ? (
                                                filteredAttributes[0].Domains ===
                                                  false ? (
                                                  key === "ObservationDate" ||
                                                    key === "created_date" ? (
                                                    <div className="dateInputBlk">
                                                      <input
                                                        //ref={dateInputRef}
                                                        type="datetime-local"
                                                        className="form-control"
                                                        value={
                                                          editedRows[row.id]?.[
                                                            key
                                                          ] !== undefined
                                                            ? formatToDatetimeLocal(
                                                              editedRows[row.id][
                                                              key
                                                              ]
                                                            )
                                                            : formatToDatetimeLocal(
                                                              row[key]
                                                            )
                                                        }
                                                        max={new Date()
                                                          .toISOString()
                                                          .slice(0, 16)} // Restrict future dates
                                                        onChange={(e) =>
                                                          handleInputChange(
                                                            row.id,
                                                            key,
                                                            e.target.value
                                                          )
                                                        } // Handle datetime input change
                                                      />
                                                      <RxCalendar onClick={handleCalendarClick} />
                                                    </div>
                                                  ) : (
                                                    <input
                                                      type="text"
                                                      value={
                                                        editedRows[row.id]?.[
                                                          key
                                                        ] !== undefined // Check if value is defined
                                                          ? editedRows[row.id][
                                                          key
                                                          ]
                                                          : row[key]
                                                      }
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          row.id,
                                                          key,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  )
                                                ) : key === "Reptiles" ? (
                                                  <Select
                                                    options={domainValues.map(
                                                      (option) => ({
                                                        value: option.key,
                                                        label: option.value,
                                                      })
                                                    )}
                                                    value={
                                                      row.Reptiles
                                                        ? {
                                                          value: row.Reptiles,
                                                          label:
                                                            domainValues.find(
                                                              (option) =>
                                                                option.value ===
                                                                row.Reptiles
                                                            )?.value ||
                                                            `Select ${key}`,
                                                        }
                                                        : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                      handleReptileChange(
                                                        selectedOption,
                                                        row
                                                      )
                                                    }
                                                    components={{
                                                      DropdownIndicator: CustomDropdownIndicator,
                                                    }}
                                                    className={`react-select-container`}
                                                    classNamePrefix="react-select"
                                                    placeholder={t(
                                                      "Select Family"
                                                    )}
                                                  />
                                                ) : (
                                                  <Select
                                                    options={domainValues.map(
                                                      (option) => ({
                                                        value: option.key,
                                                        label: option.value,
                                                      })
                                                    )}
                                                    value={
                                                      row[key]
                                                        ? {
                                                          value: row[key],
                                                          label:
                                                            domainValues.find(
                                                              (option) =>
                                                                option.value ===
                                                                row[key]
                                                            )?.value ||
                                                            `Select ${key}`,
                                                        }
                                                        : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                      handleChange(
                                                        key,
                                                        selectedOption,
                                                        row
                                                      )
                                                    }
                                                    components={{
                                                      DropdownIndicator: CustomDropdownIndicator,
                                                    }}
                                                    className={`react-select-container`}
                                                    classNamePrefix="react-select"
                                                    placeholder={`Select ${key}`}
                                                  />
                                                )
                                              ) : (
                                                <div className="tableTxtTruncate">{row[key]}</div>
                                              )}
                                            </td>
                                            {key === "created_date" && (
                                              <td
                                                colSpan={3}
                                                valign="middle"
                                                style={{ textAlign: "center" }}
                                              >
                                                <div className="col-md-12 popover-container">
                                                  <>
                                                    <img
                                                      src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                                      className="uploadicon mb-1"
                                                      ref={IconAttachtarget}
                                                      onClick={() =>
                                                        handleShow(row)
                                                      } // Show modal on click
                                                      alt="Attachment Icon"
                                                      style={{
                                                        cursor: "pointer",
                                                        width: "1.25rem",
                                                      }}
                                                    />
                                                    {showPopover &&
                                                      modalObjectId ===
                                                      row.OBJECTID && (
                                                        <Popover
                                                          show={showPopover}
                                                          target={
                                                            IconAttachtarget.current
                                                          }
                                                        >
                                                          <Popover.Body>
                                                            {attachmentsContent}
                                                            <Form>
                                                              <Form.Group
                                                                controlId="formFile"
                                                                className="mb-3"
                                                              >
                                                                <Form.Label>
                                                                  Upload
                                                                  Attachment
                                                                </Form.Label>
                                                                <Form.Control
                                                                  type="file"
                                                                  ref={
                                                                    fileInputRef
                                                                  }
                                                                  onChange={(e) =>
                                                                    handleFileChange(
                                                                      e.target
                                                                        .files
                                                                    )
                                                                  }
                                                                />
                                                              </Form.Group>
                                                            </Form>
                                                            <Button
                                                              variant="primary"
                                                              onClick={() =>
                                                                uploadAttachments(
                                                                  row.OBJECTID,
                                                                  true
                                                                )
                                                              }
                                                            >
                                                              Add Attachment
                                                            </Button>
                                                          </Popover.Body>
                                                        </Popover>
                                                      )}
                                                  </>
                                                </div>
                                              </td>
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="12">No data available</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>

                          </div>
                          <AnimalSightingMobilePending
                            data={ReptilescurrentRows}
                            className="mobileOnly"
                            modalProps={modalProps}
                            t={t}
                            IsDataModified={isDataModified}
                            OrderFamilyNames={OrderFamilyNames}
                            SpeciesOrder={SpeciesOrder}
                            GetFamilyDropdown={GetFamilyDropdown}
                            GetSpeciesDropdown={GetReptilesSpeciesDropdown}
                            DropdownFamilyValues={DropdownFamilyValues}
                            DropdownSpeciesValues={DropdownReptilesSpecies}
                            domainValues={ReptilesDomainValues[0]}
                            commonProps={commonProps}
                            fullView={fullView}
                          />
                        </div>

                      </div>
                      {isEditing && editingRows.length > 0 && (
                        <div className="d-flex gap-2 panelfooter abs edit-footer">
                          <button
                            className="btn btn-outline"
                            onClick={handleCanceledting}
                          >
                            {t("cancel")}
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={() => handleSave()}
                          >
                            {t("save")}
                          </button>
                        </div>
                      )}
                    </TabPanel>
                  )}

                </Tabs>
                <div
                  id="divSpatialEdit"
                  className="divSpatialEdit"
                  style={{
                    display: "none",
                  }}
                  ref={divSpatialEdit}
                >

                  <span>{t("spatialEdit")}</span>
                  <div
                    onClick={handleToggle}
                    className="switchToggleSpatialEdit"
                    style={{
                      backgroundColor: isToggled ? "#c5e1f2" : "#d9d9d9",
                    }}
                  >
                    <div
                      className="switchToggleCircle"
                      style={{
                        left: isToggled ? "calc(100% - 17px)" : "2px",
                        backgroundColor: isToggled ? "#1199a8" : "#75757C",
                      }}
                    ></div>
                  </div>
                  <RxCross2 onClick={handleCloseSpatialEdit} style={{ cursor: "pointer" }} />
                </div>
              </>
            ) : (
              <DivLoader />
            )}
          </div>
        </>
      )}
      {showForm && (
        <>
          {loading && <DivLoader />}
          <div className="animalSighitngForm">
            {activePendingtabs.includes(t("Invertebrates")) && (
              <>
                <h6 className="mb-3 mt-1" style={{ fontSize: '0.975rem' }}><BiArrowBack className="malAniArrow" onClick={() => setShowForm(false)} /> {t('addInsects')}</h6>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Species Order")}</label>
                      <Select
                        options={InsectsDomainValues[0].InsectOrder.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={InsectsData.insectOrder}
                        onChange={(selectedOption) =>
                          GetFamilyDropdown(
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Insect Order")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          InsectsData.insectOrder === "all" &&
                          option.value !== "all"
                        }
                      />
                      {errors.insectorderval && (
                        <div className="text-danger">{errors.insectorderval}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Species Family")}</label>
                      <Select
                        options={DropdownFamilyValues.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={InsectsData.family}
                        onChange={(selectedOption) =>
                          GetSpeciesDropdown(
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Family")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          InsectsData.family === "all" && option.value !== "all"
                        }
                      />
                      {errors.insectfamily && (
                        <div className="text-danger">{errors.insectfamily}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Species Name")}</label>
                      <Select
                        options={DropdownSpeciesValues.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={
                          InsectsData.speciesName
                            ? {
                              value: InsectsData.speciesName,
                              label: InsectsData.speciesName,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "speciesName")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Species Name")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          InsectsData.speciesName === "all" &&
                          option.value !== "all"
                        }
                      />
                      {errors.insectspecies && (
                        <div className="text-danger">{errors.insectspecies}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Location")}</label>
                      <div className="locInputBlk">
                        <input
                          type="text"
                          name="location"
                          value={InsectsData.location}
                          onChange={(e) => handleIndputDropdownChange(e, "location")}
                          className="form-control InputTextHolder"
                          maxLength="50"
                        />
                        {/* <GrLocation
                          className="filter-icon"
                          size={20}
                        /> */}
                      </div>
                      {errors.insectlocation && (
                        <div className="text-danger">{errors.insectlocation}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Habitat")}</label>
                      <Select
                        options={InsectsDomainValues[0].Habitat.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={
                          InsectsData.habitat
                            ? {
                              value: InsectsData.habitat,
                              label: InsectsData.habitat,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "habitat")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Habitat")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          InsectsData.habitat === "all" && option.value !== "all"
                        }
                      />
                      {errors.insecthabitat && (
                        <div className="text-danger">{errors.insecthabitat}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Habitat Status")}</label>
                      <Select
                        options={InsectsDomainValues[0].HabitatStatus.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          InsectsData.habitatStatus
                            ? {
                              value: InsectsData.habitatStatus,
                              label: InsectsData.habitatStatus,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "habitatStatus")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Habitat Status")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          InsectsData.habitatStatus === "all" &&
                          option.value !== "all"
                        }
                      />
                      {errors.insecthabitatstatus && (
                        <div className="text-danger">
                          {errors.insecthabitatstatus}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Survey Date")}</label>
                      <div className="dateInputBlk">
                        <input
                          ref={dateInputRef}
                          type="datetime-local"
                          class="InputTextHolder form-control"
                          name="surveyDate"
                          value={InsectsData.surveyDate}
                          onChange={(e) => handleIndputDropdownChange(e, "surveyDate")}
                          max={new Date().toISOString().slice(0, 16)}
                        />
                        <RxCalendar onClick={handleCalendarClick} />
                      </div>
                      {errors.insectsurveydate && (
                        <div className="text-danger">
                          {errors.insectsurveydate}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Recorder By")}</label>
                      <input
                        type="text"
                        value={InsectsData.recordedBy}
                        name="recordedBy"
                        onChange={(e) => handleIndputDropdownChange(e, "recordedBy")}
                        class="form-control InputTextHolder"
                      />
                      {errors.insectrecordedby && (
                        <div className="text-danger">
                          {errors.insectrecordedby}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">
                        {t("Observered Number")}
                      </label>
                      <input
                        type="number"
                        pattern="[-+]?[0-9]"
                        name="observedNumber"
                        value={InsectsData.observedNumber}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "observedNumber")
                        }
                        class="form-control InputTextHolder"
                      />
                      {errors.insectobservationnum && (
                        <div className="text-danger">
                          {errors.insectobservationnum}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Specimen Taken")}</label>
                      <Select
                        options={InsectsDomainValues[0].SpecimenTaken.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          InsectsData.specimenTaken
                            ? {
                              value: InsectsData.specimenTaken,
                              label: InsectsData.specimenTaken,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "specimenTaken")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select SpecimenTaken")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          InsectsData.specimenTaken === "all" &&
                          option.value !== "all"
                        }
                      />
                      {errors.insectspecimentaken && (
                        <div className="text-danger">
                          {errors.insectspecimentaken}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Trapping Method")}</label>
                      <Select
                        options={InsectsDomainValues[0].TrappingMethod.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          InsectsData.trappingMethod
                            ? {
                              value: InsectsData.trappingMethod,
                              label: InsectsData.trappingMethod,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "trappingMethod"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Trapping Method")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          InsectsData.trappingMethod === "all" &&
                          option.value !== "all"
                        }
                      />
                      {errors.insecttrapingmethod && (
                        <div className="text-danger">
                          {errors.insecttrapingmethod}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">{t("Photo Number")}</label>
                      <input
                        type="text"
                        value={InsectsData.photoNo}
                        name="photoNo"
                        onChange={(e) => handleIndputDropdownChange(e, "photoNo")}
                        placeholder="Photo Number"
                        class="form-control InputTextHolder"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">{t("Specimen Number")}</label>
                      <input
                        type="text"
                        value={InsectsData.specimenNo}
                        name="specimenNo"
                        onChange={(e) => handleIndputDropdownChange(e, "specimenNo")}
                        placeholder="Specimen Number"
                        class="form-control InputTextHolder"
                      />
                    </div>
                  </div>

                  <div className="form-group col-lg-12 coordinatesBlk" id="info">
                    <label className="pull-left" for="">
                      {t("Coordinates")}:
                    </label>

                    <div className="form-check ms-2 me-2">
                      <input
                        value="DMS"
                        id="btnDMS"
                        onChange={() => handleRadioChange("DMS")}
                        type="radio"
                        checked={selectedFormat === "DMS"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox1"
                      >
                        {t("DegreesMinutesSeconds")}
                      </label>
                    </div>
                    <div className="form-check ms-2 me-2">
                      <input
                        value="DD"
                        id="btnDD"
                        type="radio"
                        onChange={() => handleRadioChange("DD")}
                        checked={selectedFormat === "DD"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox2"
                      >
                        {t("DecimalDegrees")}
                      </label>
                    </div>

                    <a href="#" className="btnLink" id="latlngpoint">
                      <GrLocation
                        className="filter-icon"
                        onClick={handleAddPoint}
                        size={20}
                        ref={(el) => { if (el) elementInstances["svg"] = el; }}
                        style={{
                          color:
                            theme === "dark"
                              ? "#fff"
                              : showfilter
                                ? "#179075"
                                : "#004987",
                        }}
                      />
                    </a>
                  </div>
                  {selectedFormat === "DMS" && (
                    <div className="row dms-blk">
                      <div className="form-group col-6" id="DMSDivLong">
                        <div>
                          <span className="required">*</span>
                          <label><strong>{t("longitude")}</strong></label>
                        </div>
                        <div className="row">
                          <div className="col-4 pe-1">
                            <input
                              type="text"
                              id="LongitudeDegrees"
                              value={InsectsData.insectslongDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "insectslongDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 54"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeMinutes"
                              value={InsectsData.insectslongMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "insectslongMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 13"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeSeconds"
                              value={InsectsData.insectslongSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "insectslongSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 25.289"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group col-6" id="DMSDivLat">
                        <div>
                          <span class="required">*</span>
                          <label><strong>{t("latitude")}</strong></label>
                        </div>
                        <div className="row">
                          <div class="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeDegrees"
                              value={InsectsData.insectslatDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "insectslatDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 23"
                            />
                          </div>
                          <div class="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeMinutes"
                              value={InsectsData.insectslatMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "insectslatMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 50"
                            />
                          </div>
                          <div class="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeSeconds"
                              value={InsectsData.insectslatSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "insectslatSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 20.289"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedFormat === "DD" && (
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_X")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="insectslongitude"
                            //value={Number(InsectsData.insectslongitude).toFixed(5)}
                            // value={
                            //   InsectsData.insectslongitude && InsectsData.insectslongitude !== 0
                            //     ? Number(InsectsData.insectslongitude).toFixed(5)
                            //     : ""
                            // }
                            value={InsectsData.insectslongitude ?? ""}
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "insectslongitude")
                            }
                            placeholder="eg: Long: 54.213"
                            maxLength="8"
                          />
                          {errors.insectlong && (
                            <div className="text-danger">{errors.insectlong}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_Y")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="insectslatitude"
                            //value={Number(InsectsData.insectslatitude).toFixed(5)}
                            value={InsectsData.insectslatitude ?? ""}
                            // value={
                            //   InsectsData.insectslatitude && InsectsData.insectslatitude !== 0
                            //     ? Number(InsectsData.insectslatitude).toFixed(5)
                            //     : ""
                            // }
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "insectslatitude")
                            }
                            placeholder="Eg. Lat:57.67"
                            maxLength="8"
                          />
                          {errors.insectlat && (
                            <div className="text-danger">{errors.insectlat}</div>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Notes")}</label>
                      <textarea
                        class="form-control customtextarea"
                        name="insectsnotes"
                        value={InsectsData.insectsnotes}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "insectsnotes")
                        }
                        rows="4"
                        maxLength="500"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Attachments")}</label>
                      <div
                        id="drag-area"
                        className="drag-area"
                        style={{ border: "2px dashed var(--animalFileBorder)" }}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                      >
                        <input
                          type="file"
                          className="file-input"
                          ref={fileInputRef}
                          onChange={(e) => handleFileChange(e.target.files)}
                          id="file-upload"
                          multiple
                          style={{ display: "none" }}
                        />
                        <img
                          src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                          className="uploadicon mb-1"
                          alt=""
                        />
                        <p className="mb-0" style={{ fontWeight: "600" }}>
                          {t("DragDrop")} <br />{t("Or")}<br />
                          <button
                            className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                            onClick={handleAttachClick}
                            style={{ fontWeight: "600" }}
                          >
                            {t("clickupload")}
                          </button>
                        </p>
                        <p>{t("fileandsizenames")}</p>
                        {selectedFiles.length > 0 && (
                          // <div className="selected-file">
                          //   <span>{selectedFiles[0].name}</span>
                          //   <RiDeleteBinLine
                          //     className="delete-icon"
                          //     onClick={handleClearFiles}
                          //   />
                          // </div>

                          <div className="selected-files">
                            {selectedFiles.map((file, index) => (
                              <div key={index} className="selected-file">
                                <span>{file.name}</span>
                                <RiDeleteBinLine
                                  className="delete-icon"
                                  onClick={() => handleRemoveFile(file.name)}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex gap-2 panelfooter abs">
                    <button
                      class="btn btn-outline"
                      onClick={() => handleCancelClick()}
                    >
                      {t("cancel")}
                    </button>
                    <button
                      class="btn btn-primary"
                      onClick={() => AddInsectsFeatures()}
                    >
                      {t("Add")}{" "}
                    </button>
                  </div>
                </div>
              </>
            )}
            {activePendingtabs.includes(t("Plants")) && (
              <>
                <h6 className="mb-3 mt-1" style={{ fontSize: '0.8rem' }}>{t('addPlants')}</h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Plants Species")}</label>
                      <Select
                        options={PlantsDomainValues[0].PlantSpecies.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          PlantsDataObj.plantSpecies
                            ? {
                              value: PlantsDataObj.plantSpecies,
                              label: PlantsDataObj.plantSpecies,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "plantSpecies")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Plant Species")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          PlantsDataObj.plantSpecies === "all" && option.value !== "all"
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Phenology")}</label>
                      <Select
                        options={PlantsDomainValues[0].Phenology.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          PlantsDataObj.phenology
                            ? {
                              value: PlantsDataObj.phenology,
                              label: PlantsDataObj.phenology,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "phenology")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Phenology")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                        isOptionDisabled={(option) =>
                          PlantsDataObj.phenology === "all" && option.value !== "all"
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Location")}</label>
                      <input
                        type="text"
                        name="generalLocation"
                        value={PlantsDataObj.generalLocation}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "generalLocation")
                        }
                        class="form-control InputTextHolder"
                        maxLength="50"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Habitat")}</label>
                      <Select
                        options={PlantsDomainValues[0].Habitat.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={
                          PlantsDataObj.plantshabitat
                            ? {
                              value: PlantsDataObj.plantshabitat,
                              label: PlantsDataObj.plantshabitat,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "plantshabitat")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Habitat")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Grazing Sign")}</label>
                      <Select
                        options={PlantsDomainValues[0].GrazingSigns.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          PlantsDataObj.grazingSign
                            ? {
                              value: PlantsDataObj.grazingSign,
                              label: PlantsDataObj.grazingSign,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "grazingSign")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Grazing Sign")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Precipitation")}</label>
                      <Select
                        options={PlantsDomainValues[0].Precipitation.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          PlantsDataObj.precipitation
                            ? {
                              value: PlantsDataObj.precipitation,
                              label: PlantsDataObj.precipitation,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(selectedOption, "precipitation")
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Precipitation")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">
                        {t("Percentage Cover")}
                      </label>
                      <Select
                        options={PlantsDomainValues[0].PercentageCover.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          PlantsDataObj.percentageCover
                            ? {
                              value: PlantsDataObj.percentageCover,
                              label: PlantsDataObj.percentageCover,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "percentageCover"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Percentage Cover")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">
                        {t("Specimen Collected")}
                      </label>
                      <Select
                        options={PlantsDomainValues[0].SpecimenCollected.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          PlantsDataObj.specimenCollected
                            ? {
                              value: PlantsDataObj.specimenCollected,
                              label: PlantsDataObj.specimenCollected,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "specimenCollected"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Specimen Collected")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Survey Date")}</label>
                      <div className="dateInputBlk">
                        <input
                          ref={dateInputRef}
                          type="datetime-local"
                          class="InputTextHolder form-control"
                          name="plantssurveyDate"
                          value={PlantsDataObj.plantssurveyDate}
                          onChange={(e) =>
                            handleIndputDropdownChange(e, "plantssurveyDate")
                          }
                          max={new Date().toISOString().slice(0, 16)}
                        />
                        <RxCalendar onClick={handleCalendarClick} />
                      </div>
                    </div>
                  </div>

                  <div className="form-group col-lg-12 coordinatesBlk" id="info">
                    <label className="pull-left" for="">
                      {t("Coordinates")}
                    </label>
                    <div className="form-check ms-2 me-2">
                      <input
                        value="DMS"
                        id="btnDMS"
                        onChange={() => handleRadioChange("DMS")}
                        type="radio"
                        checked={selectedFormat === "DMS"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox1"
                      >
                        {t("DegreesMinutesSeconds")}
                      </label>
                    </div>
                    <div className="form-check ms-2 me-2">
                      <input
                        value="DD"
                        id="btnDD"
                        type="radio"
                        onChange={() => handleRadioChange("DD")}
                        checked={selectedFormat === "DD"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox2"
                      >
                        {t("DecimalDegrees")}
                      </label>
                    </div>

                    <a href="#" className="btnLink" id="latlngpoint">
                      <GrLocation
                        className="filter-icon"
                        onClick={handleAddPoint}
                        size={20}
                        ref={(el) => { if (el) elementInstances["svg2"] = el; }}
                        style={{
                          color:
                            theme === "dark"
                              ? "#fff"
                              : showfilter
                                ? "#179075"
                                : "#004987",
                        }}
                      />
                    </a>
                  </div>
                  {selectedFormat === "DMS" && (
                    <div className="row dms-blk">
                      <div className="form-group col-6" id="DMSDivLong">
                        <div>
                          <span className="required">*</span>
                          <label>{t("longitude")}</label>
                        </div>
                        <div className="row">
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeDegrees"
                              value={PlantsDataObj.plantslongDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "plantslongDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 54"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeMinutes"
                              value={PlantsDataObj.plantslongMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "plantslongMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 13"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeSeconds"
                              value={PlantsDataObj.plantslongSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "plantslongSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 25.289"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group col-6" id="DMSDivLat">
                        <div>
                          <span className="required">*</span>
                          <label>{t("latitude")}</label>
                        </div>
                        <div className="row">
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeDegrees"
                              value={PlantsDataObj.plantslatDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "plantslatDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 23"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeMinutes"
                              value={PlantsDataObj.plantslatMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "plantslatMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 50"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeSeconds"
                              value={PlantsDataObj.plantslatSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "plantslatSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 20.289"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedFormat === "DD" && (
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_X")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="plantslongitude"
                            value={PlantsDataObj.plantslongitude ?? ""}
                            // value={
                            //   PlantsDataObj.plantslongitude && PlantsDataObj.plantslongitude !== 0
                            //     ? Number(PlantsDataObj.plantslongitude).toFixed(5)
                            //     : ""
                            // }
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "plantslongitude")
                            }
                            placeholder="eg: Long: 54.213"
                            maxLength="8"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_Y")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="plantslatitude"
                            //value={PlantsDataObj.plantslatitude}
                            // value={
                            //   PlantsDataObj.plantslatitude && PlantsDataObj.plantslatitude !== 0
                            //     ? Number(PlantsDataObj.plantslatitude).toFixed(5)
                            //     : ""
                            // }
                            value={PlantsDataObj.plantslatitude ?? ""}
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "plantslatitude")
                            }
                            placeholder="Eg. Lat:22.67"
                            maxLength="8"
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Notes")}</label>
                      <textarea
                        class="form-control customtextarea"
                        name="plantsNotes"
                        value={PlantsDataObj.plantsNotes}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "plantsNotes")
                        }
                        rows="4"
                        maxLength="500"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Attachments")}</label>
                      <div
                        id="drag-area"
                        className="drag-area"
                        style={{ border: "2px dashed var(--animalFileBorder)" }}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                      >
                        <input
                          type="file"
                          className="file-input"
                          ref={fileInputRef}
                          onChange={(e) => handleFileChange(e.target.files)}
                          id="file-upload"
                          multiple
                          style={{ display: "none" }}
                        />
                        <img
                          src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                          className="uploadicon mb-1"
                          alt=""
                        />
                        <p className="mb-0" style={{ fontWeight: "600" }}>
                          {t("DragDrop")} <br />{t("Or")}<br />
                          <button
                            className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                            onClick={handleAttachClick}
                            style={{ fontWeight: "600" }}
                          >
                            {t("clickupload")}
                          </button>
                        </p>
                        <p>{t("fileandsizenames")}</p>
                        {selectedFiles.length > 0 && (
                          // <div className="selected-file">
                          //   <span>{selectedFiles[0].name}</span>
                          //   <RiDeleteBinLine
                          //     className="delete-icon"
                          //     onClick={handleClearFiles}
                          //   />
                          // </div>
                          <div className="selected-files">
                            {selectedFiles.map((file, index) => (
                              <div key={index} className="selected-file">
                                <span>{file.name}</span>
                                <RiDeleteBinLine
                                  className="delete-icon"
                                  onClick={() => handleRemoveFile(file.name)}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex gap-2 panelfooter abs">
                    <button
                      class="btn btn-outline"
                      onClick={() => handleCancelClick()}
                    >
                      {t("cancel")}
                    </button>
                    <button
                      class="btn btn-primary"
                      onClick={() => AddPlantsFeatures()}
                    >
                      {t("Add")}
                    </button>
                  </div>
                </div>
              </>
            )}
            {activePendingtabs.includes(t("Mammals")) && (
              <>
                <h6 className="mb-3 mt-1" style={{ fontSize: '0.8rem' }}>{t('addMammals')}</h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Species")}</label>
                      <Select
                        options={MammalsDomainValues[0].Species.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={MammalsDataObj.mammalsSpecies}
                        onChange={(selectedOption) =>
                          GetMammalsSpeciesDropdown(
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Species")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Species Name")}</label>
                      <Select
                        options={DropdownMammalsSpeciesNames.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={
                          MammalsDataObj.mammalsSpeciesName
                            ? {
                              value: MammalsDataObj.mammalsSpeciesName,
                              label: MammalsDataObj.mammalsSpeciesName,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "mammalsSpeciesName"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Species Name")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Species Number")}</label>
                      <input
                        type="text"
                        name="mammalsSpeciesNumber"
                        value={MammalsDataObj.mammalsSpeciesNumber}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "mammalsSpeciesNumber")
                        }
                        class="form-control InputTextHolder"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Sighting Type")}</label>
                      <Select
                        options={MammalsDomainValues[0].SightingType.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          MammalsDataObj.mammalsSightingType
                            ? {
                              value: MammalsDataObj.mammalsSightingType,
                              label: MammalsDataObj.mammalsSightingType,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "mammalsSightingType"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Sighting Type")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Habitat")}</label>
                      <Select
                        options={MammalsDomainValues[0].Habitat.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={
                          MammalsDataObj.mammalsHabitat
                            ? {
                              value: MammalsDataObj.mammalsHabitat,
                              label: MammalsDataObj.mammalsHabitat,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "mammalsHabitat"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Habitat")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Location")}</label>
                      <input
                        type="text"
                        name="mammalsLocation"
                        value={MammalsDataObj.mammalsLocation}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "mammalsLocation")
                        }
                        class="form-control InputTextHolder"
                        maxLength="50"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Collector")}</label>
                      <input
                        type="text"
                        name="mammalsCollector"
                        value={MammalsDataObj.mammalsCollector}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "mammalsCollector")
                        }
                        class="form-control InputTextHolder"
                        maxLength="50"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Survey Date")}</label>
                      <div className="dateInputBlk">
                        <input
                          ref={dateInputRef}
                          type="datetime-local"
                          class="InputTextHolder form-control"
                          name="mammalsSurveyDate"
                          value={MammalsDataObj.mammalsSurveyDate}
                          onChange={(e) =>
                            handleIndputDropdownChange(e, "mammalsSurveyDate")
                          }
                          max={new Date().toISOString().slice(0, 16)}
                        />
                        <RxCalendar onClick={handleCalendarClick} />
                      </div>
                    </div>
                  </div>

                  <div className="form-group col-lg-12 coordinatesBlk" id="info">
                    <label className="pull-left" for="">
                      {t("Coordinates")}
                    </label>
                    <div className="form-check ms-2 me-2">
                      <input
                        value="DMS"
                        id="btnDMS"
                        onChange={() => handleRadioChange("DMS")}
                        type="radio"
                        checked={selectedFormat === "DMS"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox1"
                      >
                        {t("DegreesMinutesSeconds")}
                      </label>
                    </div>
                    <div className="form-check ms-2 me-2">
                      <input
                        value="DD"
                        id="btnDD"
                        type="radio"
                        onChange={() => handleRadioChange("DD")}
                        checked={selectedFormat === "DD"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox2"
                      >
                        {t("DecimalDegrees")}
                      </label>
                    </div>

                    <a href="#" className="btnLink" id="latlngpoint">
                      <GrLocation
                        className="filter-icon"
                        onClick={handleAddPoint}
                        size={20}
                        ref={(el) => { if (el) elementInstances["svg3"] = el; }}
                        style={{
                          color:
                            theme === "dark"
                              ? "#fff"
                              : showfilter
                                ? "#179075"
                                : "#004987",
                        }}
                      />
                    </a>
                  </div>
                  {selectedFormat === "DMS" && (
                    <div className="row dms-blk">
                      <div className="form-group col-6" id="DMSDivLong">
                        <div>
                          <span className="required">*</span>
                          <label>{t("longitude")}</label>
                        </div>
                        <div className="row">
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeDegrees"
                              value={MammalsDataObj.mammalslongDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "mammalslongDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 54"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeMinutes"
                              value={MammalsDataObj.mammalslongMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "mammalslongMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 13"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeSeconds"
                              value={MammalsDataObj.mammalslongSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "mammalslongSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 25.289"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form-group col-6" id="DMSDivLat">
                        <div>
                          <span className="required">*</span>
                          <label>{t("latitude")}</label>
                        </div>
                        <div className="row">
                          <div
                            className="col-4 px-1"
                            style={{ paddingLeft: "0px" }}
                          >
                            <input
                              type="text"
                              id="LatitudeDegrees"
                              value={MammalsDataObj.mammalslatDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "mammalslatDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 23"
                            />
                          </div>
                          <div
                            className="col-4 px-1"
                            style={{ paddingLeft: "0px" }}
                          >
                            <input
                              type="text"
                              id="LatitudeMinutes"
                              value={MammalsDataObj.mammalslatMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "mammalslatMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 50"
                            />
                          </div>
                          <div
                            className="col-4 px-1"
                            style={{ paddingLeft: "0px" }}
                          >
                            <input
                              type="text"
                              id="LatitudeSeconds"
                              value={MammalsDataObj.mammalslatSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "mammalslatSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 20.289"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedFormat === "DD" && (
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_X")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="mammalsLongitude"
                            value={MammalsDataObj.mammalsLongitude ?? ""}
                            // value={
                            //   MammalsDataObj.mammalsLongitude && MammalsDataObj.mammalsLongitude !== 0
                            //     ? Number(MammalsDataObj.mammalsLongitude).toFixed(5)
                            //     : ""
                            // }
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "mammalsLongitude")
                            }
                            placeholder="eg: Long: 54.213"
                            maxLength="8"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_Y")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="mammalsLatitude"
                            value={MammalsDataObj.mammalsLatitude ?? ""}
                            // value={
                            //   MammalsDataObj.mammalsLatitude && MammalsDataObj.mammalsLatitude !== 0
                            //     ? Number(MammalsDataObj.mammalsLatitude).toFixed(5)
                            //     : ""
                            // }
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "mammalsLatitude")
                            }
                            placeholder="Eg. Lat:22.67"
                            maxLength="8"
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Notes")}</label>
                      <textarea
                        class="form-control customtextarea"
                        name="mammalsNotes"
                        value={MammalsDataObj.mammalsNotes}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "mammalsNotes")
                        }
                        rows="4"
                        maxLength="500"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Attachments")}</label>
                      <div
                        id="drag-area"
                        className="drag-area"
                        style={{ border: "2px dashed var(--animalFileBorder)" }}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                      >
                        <input
                          type="file"
                          className="file-input"
                          ref={fileInputRef}
                          onChange={(e) => handleFileChange(e.target.files)}
                          id="file-upload"
                          multiple
                          style={{ display: "none" }}
                        />
                        <img
                          src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                          className="uploadicon mb-1"
                          alt=""
                        />
                        <p className="mb-0" style={{ fontWeight: "600" }}>
                          {t("DragDrop")} <br />{t("Or")}<br />
                          <button
                            className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                            onClick={handleAttachClick}
                            style={{ fontWeight: "600" }}
                          >
                            {t("clickupload")}
                          </button>
                        </p>
                        <p>{t("fileandsizenames")}</p>
                        {selectedFiles.length > 0 && (
                          // <div className="selected-file">
                          //   <span>{selectedFiles[0].name}</span>
                          //   <RiDeleteBinLine
                          //     className="delete-icon"
                          //     onClick={handleClearFiles}
                          //   />
                          // </div>
                          <div className="selected-files">
                            {selectedFiles.map((file, index) => (
                              <div key={index} className="selected-file">
                                <span>{file.name}</span>
                                <RiDeleteBinLine
                                  className="delete-icon"
                                  onClick={() => handleRemoveFile(file.name)}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex gap-2 panelfooter abs">
                    <button
                      class="btn btn-outline"
                      onClick={() => handleCancelClick()}
                    >
                      {t("cancel")}
                    </button>
                    <button
                      class="btn btn-primary"
                      onClick={() => AddMammalsFeatures()}
                    >
                      {t("Add")}
                    </button>
                  </div>
                </div>
              </>
            )}
            {activePendingtabs.includes(t("Reptiles")) && (
              <>
                <h6 className="mb-3 mt-1" style={{ fontSize: '0.8rem' }}>{t('addReptiles')}</h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Reptiles")}</label>
                      <Select
                        options={ReptilesDomainValues[0].Reptiles.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={ReptilesDataObj.reptiles}
                        onChange={(selectedOption) =>
                          GetReptilesSpeciesDropdown(
                            selectedOption ? selectedOption.value : ""
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Reptiles")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Species")}</label>
                      <Select
                        options={DropdownReptilesSpecies.map((domain) => ({
                          value: domain.key,
                          label: domain.value,
                        }))}
                        value={
                          ReptilesDataObj.reptileSpecies
                            ? {
                              value: ReptilesDataObj.reptileSpecies,
                              label: ReptilesDataObj.reptileSpecies,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "reptileSpecies"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Species")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Number Observed")}</label>
                      <input
                        type="text"
                        name="observationNumber"
                        value={ReptilesDataObj.observationNumber}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "observationNumber")
                        }
                        class="form-control InputTextHolder"
                        pattern="[-+]?[0-9]"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Location")}</label>
                      <input
                        type="text"
                        name="reptileLocation"
                        value={ReptilesDataObj.reptileLocation}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "reptileLocation")
                        }
                        class="form-control InputTextHolder"
                        maxLength="50"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Sighting Type")}</label>
                      <Select
                        options={ReptilesDomainValues[0].SightingType.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          ReptilesDataObj.reptileSightingType
                            ? {
                              value: ReptilesDataObj.reptileSightingType,
                              label: ReptilesDataObj.reptileSightingType,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "reptileSightingType"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Sighting Type")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Micro Habitat")}</label>
                      <Select
                        options={ReptilesDomainValues[0].MicroHabitat.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          ReptilesDataObj.microHabitat
                            ? {
                              value: ReptilesDataObj.microHabitat,
                              label: ReptilesDataObj.microHabitat,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "microHabitat"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Micro Habitat")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Habitat")}</label>
                      <Select
                        options={ReptilesDomainValues[0].Habitat.map(
                          (domain) => ({
                            value: domain.key,
                            label: domain.value,
                          })
                        )}
                        value={
                          ReptilesDataObj.reptileHabitat
                            ? {
                              value: ReptilesDataObj.reptileHabitat,
                              label: ReptilesDataObj.reptileHabitat,
                            }
                            : null
                        }
                        onChange={(selectedOption) =>
                          handleIndputDropdownChange(
                            selectedOption,
                            "reptileHabitat"
                          )
                        }
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                        }}
                        placeholder={t("Select Habitat")}
                        className={`react-select-container`}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">{t("Collector")}</label>
                      <input
                        type="text"
                        name="reptileCollector"
                        value={ReptilesDataObj.reptileCollector}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "reptileCollector")
                        }
                        class="form-control InputTextHolder"
                        maxLength="50"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <span style={{ color: "red" }}>*</span>
                      <label className="form-label">
                        {t("Observation Date")}
                      </label>
                      <div className="dateInputBlk">
                        <input
                          ref={dateInputRef}
                          type="datetime-local"
                          class="InputTextHolder form-control"
                          value={ReptilesDataObj.observationDate}
                          onChange={(e) =>
                            handleIndputDropdownChange(e, "observationDate")
                          }
                          name="observationDate"
                          max={new Date().toISOString().slice(0, 16)}
                        />
                        <RxCalendar onClick={handleCalendarClick} />
                      </div>
                    </div>
                  </div>

                  <div className="form-group col-lg-12 coordinatesBlk" id="info">
                    <label className="pull-left" for="">
                      {t("Coordinates")}
                    </label>
                    <div className="form-check ms-2 me-2">
                      <input
                        value="DMS"
                        id="btnDMS"
                        onChange={() => handleRadioChange("DMS")}
                        type="radio"
                        checked={selectedFormat === "DMS"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox1"
                      >
                        {t("DegreesMinutesSeconds")}
                      </label>
                    </div>
                    <div className="form-check ms-2 me-2">
                      <input
                        value="DD"
                        id="btnDD"
                        type="radio"
                        onChange={() => handleRadioChange("DD")}
                        checked={selectedFormat === "DD"}
                        className="form-check-input"
                      />
                      <label
                        className="form-check-label"
                        for="inlineCheckbox2"
                      >
                        {t("DecimalDegrees")}
                      </label>
                    </div>

                    <a href="#" className="btnLink" id="latlngpoint">
                      <GrLocation
                        className="filter-icon"
                        onClick={handleAddPoint}
                        size={20}
                        ref={(el) => { if (el) elementInstances["svg4"] = el; }}
                        style={{
                          color:
                            theme === "dark"
                              ? "#fff"
                              : showfilter
                                ? "#179075"
                                : "#004987",
                        }}
                      />
                    </a>
                  </div>
                  {selectedFormat === "DMS" && (
                    <div className="row dms-blk">
                      <div class="form-group col-6" id="DMSDivLong">
                        <div>
                          <span className="required">*</span>
                          <label>{t("longitude")}</label>
                        </div>
                        <div className="row">
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeDegrees"
                              value={ReptilesDataObj.reptilelongDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "reptilelongDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 54"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeMinutes"
                              value={ReptilesDataObj.reptilelongMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "reptilelongMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 13"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LongitudeSeconds"
                              value={ReptilesDataObj.reptilelongSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "reptilelongSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 25.289"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-6" id="DMSDivLat">
                        <div>
                          <span class="required">*</span>
                          <label>{t("latitude")}</label>
                        </div>
                        <div className="row">
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeDegrees"
                              value={ReptilesDataObj.reptilelatDegrees}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "reptilelatDegrees")
                              }
                              className="form-control"
                              placeholder="eg: 23"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeMinutes"
                              value={ReptilesDataObj.reptilelatMinutes}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "reptilelatMinutes")
                              }
                              className="form-control"
                              placeholder="eg: 50"
                            />
                          </div>
                          <div className="col-4 px-1">
                            <input
                              type="text"
                              id="LatitudeSeconds"
                              value={ReptilesDataObj.reptilelatSeconds}
                              onChange={(e) =>
                                handleIndputDropdownChange(e, "reptilelatSeconds")
                              }
                              className="form-control"
                              placeholder="eg: 20.289"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {selectedFormat === "DD" && (
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_X")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="reptileLongitude"
                            value={ReptilesDataObj.reptileLongitude ?? ""}
                            // value={
                            //   ReptilesDataObj.reptileLongitude && ReptilesDataObj.reptileLongitude !== 0
                            //     ? Number(ReptilesDataObj.reptileLongitude).toFixed(5)
                            //     : ""
                            // }
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "reptileLongitude")
                            }
                            placeholder="eg: Long: 54.213"
                            maxLength="8"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <span style={{ color: "red" }}>*</span>
                          <label className="form-label">{t("Point_Y")}</label>
                          <input
                            type="text"
                            className="form-control"
                            name="reptileLatitude"
                            value={ReptilesDataObj.reptileLatitude ?? ""}
                            // value={
                            //   ReptilesDataObj.reptileLatitude && ReptilesDataObj.reptileLatitude !== 0
                            //     ? Number(ReptilesDataObj.reptileLatitude).toFixed(5)
                            //     : ""
                            // }
                            onChange={(e) =>
                              handleIndputDropdownChange(e, "reptileLatitude")
                            }
                            placeholder="Eg. Lat:22.67"
                            maxLength="8"
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Notes")}</label>
                      <textarea
                        class="form-control customtextarea"
                        name="reptileNotes"
                        value={ReptilesDataObj.reptileNotes}
                        onChange={(e) =>
                          handleIndputDropdownChange(e, "reptileNotes")
                        }
                        rows="4"
                        maxLength="500"
                      ></textarea>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="form-label">{t("Attachments")}</label>
                      <div
                        id="drag-area"
                        className="drag-area"
                        style={{ border: "2px dashed var(--animalFileBorder)" }}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                      >
                        <input
                          type="file"
                          className="file-input"
                          ref={fileInputRef}
                          onChange={(e) => handleFileChange(e.target.files)}
                          id="file-upload"
                          multiple
                          style={{ display: "none" }}
                        />
                        <img
                          src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                          className="uploadicon mb-1"
                          alt=""
                        />
                        <p className="mb-0" style={{ fontWeight: "600" }}>
                          {t("DragDrop")} <br />{t("Or")}<br />
                          <button
                            className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                            onClick={handleAttachClick}
                            style={{ fontWeight: "600" }}
                          >
                            {t("clickupload")}
                          </button>
                        </p>
                        <p>{t("fileandsizenames")}</p>
                        {selectedFiles.length > 0 && (
                          // <div className="selected-file">
                          //   <span>{selectedFiles[0].name}</span>
                          //   <RiDeleteBinLine
                          //     className="delete-icon"
                          //     onClick={handleClearFiles}
                          //   />
                          // </div>
                          <div className="selected-files">
                            {selectedFiles.map((file, index) => (
                              <div key={index} className="selected-file">
                                {/* <span>{selectedFiles.name}</span> */}
                                <span>{file.name}</span>
                                <RiDeleteBinLine
                                  className="delete-icon"
                                  onClick={() => handleRemoveFile(file.name)}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex gap-2 panelfooter abs">
                    <button
                      class="btn btn-outline"
                      onClick={() => handleCancelClick()}
                    >
                      {t("cancel")}
                    </button>
                    <button
                      class="btn btn-primary"
                      onClick={() => AddReptileFeatures()}
                    >
                      {t("Add")}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default AnimalPendingRecords;
